webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/MgTTe8/%3F1704288908010&title=Global%20Crisis&summary=The%20acclaimed%20historian%20demonstrates%20a%20link%20between%20climate%20change%20and%20social%20unrest%20across%20the%20globe%20during%20the%20mid-17th%20century.Revolutions%2C%20droughts%2C%20famines%2C%20invasions%2C%20wars%2C%20regicides%2C%20government%20collapses%26mdash%3Bthe%20calamities%20of%20the&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/MgTTe8/%3F1704288908010",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=The%20acclaimed%20historian%20demonstrates%20a%20link%20between%20climate%20change%20and%20social%20unrest%20across%20the%20globe%20during%20the%20mid-17th%20century.%0Dhttps://textcafe.co/books/MgTTe8/%3F1704288908010&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/MgTTe8/%3F1704288908010&posttype=link&caption=The%20acclaimed%20historian%20demonstrates%20a%20link%20between%20climate%20change%20and%20social%20unrest%20across%20the%20globe%20during%20the%20mid-17th%20century.Revolutions%2C%20droughts%2C%20famines%2C%20invasions%2C%20wars%2C%20regicides%2C%20government%20collapses%26mdash%3Bthe%20calamities%20of%20the",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/MgTTe8/%3F1704288908010&description=The%20acclaimed%20historian%20demonstrates%20a%20link%20between%20climate%20change%20and%20social%20unrest%20across%20the%20globe%20during%20the%20mid-17th%20century.Revolutions%2C%20droughts%2C%20famines%2C%20invasions%2C%20wars%2C%20regicides%2C%20government%20collapses%26mdash%3Bthe%20calamities%20of%20the&media=https://textcafe.co/books/MgTTe8/tc-custom/9780300189193.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780300189193&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=gjdDP15N4FkC&amp;rdid=book-gjdDP15N4FkC&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780300189193').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/MgTTe8/tc-custom/9780300189193.jpg?1704288908010',
        alt: 'Global Crisis'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "001Cover", "002Half_Title", "003Title_Page", "004Copyright", "005Dedication", "006Contents", "007List_of_Illustrations", "008Plates", "009Prologue_Did_Someone_Say_x2018Climate_Changex0027", "010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019", "011PART_I_THE_PLACENTA_OF_THE_CRISIS", "0121_The_Little_Ice_Age", "0132_The_x2018General_Crisisx2019", "0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis", "0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/MgTTe8/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_001Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_001Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_001Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_002Half_Title__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_002Half_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_002Half_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_003Title_Page__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_003Title_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_003Title_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_004Copyright__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_004Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_004Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_005Dedication__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_005Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_005Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_006Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_006Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_006Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_007List_of_Illustrations__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_007List_of_Illustrations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_007List_of_Illustrations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_008Plates__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_008Plates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_008Plates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_009Prologue_Did_Someone_Say_x2018Climate_Changex0027__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_009Prologue_Did_Someone_Say_x2018Climate_Changex0027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_009Prologue_Did_Someone_Say_x2018Climate_Changex0027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_011PART_I_THE_PLACENTA_OF_THE_CRISIS__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_011PART_I_THE_PLACENTA_OF_THE_CRISIS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_011PART_I_THE_PLACENTA_OF_THE_CRISIS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_0121_The_Little_Ice_Age__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_0121_The_Little_Ice_Age___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_0121_The_Little_Ice_Age__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_0132_The_x2018General_Crisisx2019__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_0132_The_x2018General_Crisisx2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_0132_The_x2018General_Crisisx2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_016PART_II_ENDURING_THE_CRISIS__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_016PART_II_ENDURING_THE_CRISIS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_016PART_II_ENDURING_THE_CRISIS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_0175_The_x2018Great_Enterprisex2019_in_China_1618x201384__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_0175_The_x2018Great_Enterprisex2019_in_China_1618x201384___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_0175_The_x2018Great_Enterprisex2019_in_China_1618x201384__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_0197_The_x2018Ottoman_tragedyx2019_1618x201383__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_0197_The_x2018Ottoman_tragedyx2019_1618x201383___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_0197_The_x2018Ottoman_tragedyx2019_1618x201383__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_0219_The_Agony_of_the_Iberian_Peninsula_1618x201389__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_0219_The_Agony_of_the_Iberian_Peninsula_1618x201389___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_0219_The_Agony_of_the_Iberian_Peninsula_1618x201389__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_02210_France_in_Crisis_1618x201388__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_02210_France_in_Crisis_1618x201388___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_02210_France_in_Crisis_1618x201388__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_025PART_III_SURVIVING_THE_CRISIS__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_025PART_III_SURVIVING_THE_CRISIS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_025PART_III_SURVIVING_THE_CRISIS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_02613_The_Mughals_and_their_Neighbours__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_02613_The_Mughals_and_their_Neighbours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_02613_The_Mughals_and_their_Neighbours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_02714_Red_Flag_over_Italy__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_02714_Red_Flag_over_Italy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_02714_Red_Flag_over_Italy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_02916_Getting_it_Right_Early_Tokugawa_Japan__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_02916_Getting_it_Right_Early_Tokugawa_Japan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_02916_Getting_it_Right_Early_Tokugawa_Japan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_030PART_IV_CONFRONTING_THE_CRISIS__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_030PART_IV_CONFRONTING_THE_CRISIS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_030PART_IV_CONFRONTING_THE_CRISIS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_034PART_V_BEYOND_THE_CRISIS__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_034PART_V_BEYOND_THE_CRISIS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_034PART_V_BEYOND_THE_CRISIS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_03520_Escaping_the_Crisis__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_03520_Escaping_the_Crisis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_03520_Escaping_the_Crisis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_03621_From_Warfare_State_to_Welfare_State__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_03621_From_Warfare_State_to_Welfare_State___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_03621_From_Warfare_State_to_Welfare_State__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_03722_The_Great_Divergence__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_03722_The_Great_Divergence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_03722_The_Great_Divergence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_038Conclusion_The_Crisis_Anatomized__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_038Conclusion_The_Crisis_Anatomized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_038Conclusion_The_Crisis_Anatomized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_039Epilogue_x2018Itx0027s_the_climate_stupidx2019__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_039Epilogue_x2018Itx0027s_the_climate_stupidx2019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_039Epilogue_x2018Itx0027s_the_climate_stupidx2019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_040Chronology__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_040Chronology___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_040Chronology__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_041Acknowledgements__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_041Acknowledgements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_041Acknowledgements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_042Note_on_Conventions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_042Note_on_Conventions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_042Note_on_Conventions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_043Note_on_Sources_and_Bibliography__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_043Note_on_Sources_and_Bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_043Note_on_Sources_and_Bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_044Abbreviations_Used_in_the_Bibliography_and_Notes__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_044Abbreviations_Used_in_the_Bibliography_and_Notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_044Abbreviations_Used_in_the_Bibliography_and_Notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_045Notes__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_045Notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_045Notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_046Bibliography__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_046Bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_046Bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_047Index__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_047Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_047Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_last__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_last__);
/*jshint esversion: 6 */






















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/001Cover",
    "name": "001Cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_001Cover___default.a
  }, {
    "path": "/002Half_Title",
    "name": "002Half_Title",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_002Half_Title___default.a
  }, {
    "path": "/003Title_Page",
    "name": "003Title_Page",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_003Title_Page___default.a
  }, {
    "path": "/004Copyright",
    "name": "004Copyright",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_004Copyright___default.a
  }, {
    "path": "/005Dedication",
    "name": "005Dedication",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_005Dedication___default.a
  }, {
    "path": "/006Contents",
    "name": "006Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_006Contents___default.a
  }, {
    "path": "/007List_of_Illustrations",
    "name": "007List_of_Illustrations",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_007List_of_Illustrations___default.a
  }, {
    "path": "/008Plates",
    "name": "008Plates",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_008Plates___default.a
  }, {
    "path": "/009Prologue_Did_Someone_Say_x2018Climate_Changex0027",
    "name": "009Prologue_Did_Someone_Say_x2018Climate_Changex0027",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_009Prologue_Did_Someone_Say_x2018Climate_Changex0027___default.a
  }, {
    "path": "/010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019",
    "name": "010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019___default.a
  }, {
    "path": "/011PART_I_THE_PLACENTA_OF_THE_CRISIS",
    "name": "011PART_I_THE_PLACENTA_OF_THE_CRISIS",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_011PART_I_THE_PLACENTA_OF_THE_CRISIS___default.a
  }, {
    "path": "/0121_The_Little_Ice_Age",
    "name": "0121_The_Little_Ice_Age",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_0121_The_Little_Ice_Age___default.a
  }, {
    "path": "/0132_The_x2018General_Crisisx2019",
    "name": "0132_The_x2018General_Crisisx2019",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_0132_The_x2018General_Crisisx2019___default.a
  }, {
    "path": "/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis",
    "name": "0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis___default.a
  }, {
    "path": "/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century",
    "name": "0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_51__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MgTTe8/tc-custom/9780300189193.jpg?1704288908010",
      "alt": "This image is the cover for the book Global Crisis"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Global Crisis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The acclaimed historian demonstrates a link between climate change and social unrest across the globe during the mid-17th century.")])]), _c('p', [_vm._v("Revolutions, droughts, famines, invasions, wars, regicides, government collapses—the calamities of the mid-seventeenth century were unprecedented in both frequency and severity. The effects of what historians call the \"General Crisis\" extended from England to Japan and from the Russian Empire to sub-Saharan Africa and the Americas.")]), _c('p', [_vm._v("In this meticulously researched volume, historian Geoffrey Parker presents the firsthand testimony of men and women who experienced the many political, economic, and social crises that occurred between 1618 to the late 1680s. He also incorporates the scientific evidence of climate change during this period into the narrative, offering a strikingly new understanding of the General Crisis.")]), _vm._v(" Changes in weather patterns, especially longer winters and cooler and wetter summers, disrupted growing seasons and destroyed harvests. This in turn brought hunger, malnutrition, and disease; and as material conditions worsened, wars, rebellions, and revolutions rocked the world.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Geoffrey Parker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Yale University Press\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "pI"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/cover.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pI"
    }
  })])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "pII"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/halftitle.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pII"
    }
  })])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pIII"
    }
  }), _c('a', {
    attrs: {
      "id": "pIV"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/title.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pIV"
    }
  })])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapbreak"
  }), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }, [_vm._v("Copyright © 2013 Geoffrey Parker")])]), _c('a', {
    attrs: {
      "id": "pV"
    }
  }, [_c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("For information about this and other Yale University Press publications, please contact:")])]), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }, [_vm._v("U.S. Office: ")]), _c('a', {
    attrs: {
      "href": "mailto:sales.press@yale.edu"
    }
  }, [_vm._v("sales.press@yale.edu")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.yalebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.yalebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Europe Office: "), _c('a', {
    attrs: {
      "href": "mailto:sales@yaleup.co.uk"
    }
  }, [_vm._v("sales @yaleup.co.uk")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.yalebooks.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.yalebooks.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Set in Arno Pro by IDSUK (DataConnection) Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in Great Britain by TJ International Ltd, Padstow, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Parker, Geoffrey, 1943–")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   Global crisis: war, climate change and catastrophe in the seventeenth century/Geoffrey Parker.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("     pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   ISBN 978-0-300-15323-1 (cloth: alkaline paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1. History, Modern—17th century. 2. Military history—17th century. 3. Civil war—History—17th century. 4. Revolutions—History—17th century. 5. Climatic changes—Social aspects—History—17th century. 6. disasters—History—17th century. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   D247.P37 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("   909'.6—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-r"
  }, [_vm._v("2012039448")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication"
  }, [_c('p', {
    staticClass: "dedicenter"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }, [_vm._v("This book is dedicated in admiration to all those who fight multiple sclerosis")])]), _c('a', {
    attrs: {
      "id": "pVI"
    }
  })]), _c('a', {
    attrs: {
      "id": "pVI"
    }
  }, [_c('p', {
    staticClass: "pbreak"
  })]), _c('div', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }, [_vm._v("‘It was so harsh a winter that no-one could remember another like it … only after Easter could the peasants go to their fields and begin to farm’")])]), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }, [_c('p', {
    staticClass: "epis"
  }, [_vm._v("(Hans Heberle, "), _c('i', [_vm._v("Zeytregister [Diary]")]), _vm._v(", Ulm, Germany, 1627)")])])]), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }, [_c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘The times here are so miserable that never in the memory of man has the like famine and mortality happened’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(East India Company officials, letter, Surat, India, 1631)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘Those who live in times to come will not believe that we who are alive now have suffered such toil, pain and misery’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Fra Francesco Voersio of Cherasco, "), _c('i', [_vm._v("Diario del contagio [Plague Diary]")]), _vm._v(", Italy, 1631)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘There have been so many deaths that the like of it has never been heard in human history’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Hans Conrad Lang, "), _c('i', [_vm._v("Tagebuch [Diary]")]), _vm._v(", South Germany, 1634)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘Jiangnan has never experienced this kind of disaster’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Lu Shiyi, "), _c('i', [_vm._v("Zhixue lu [Diary]")]), _vm._v(", South China, 1641)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘Among all the past occurrences of disaster and rebellion, there had never been anything worse than this’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("("), _c('i', [_vm._v("County Gazetteer")]), _vm._v(", Yizhou, North China, 1641)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘The whole monarchy trembled and shook, since Portugal, Catalonia, the East Indies, the Azores and Brazil had rebelled’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Viceroy don Juan de Palafox y Mendoza, Mexico, 1641)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘[These] days are days of shaking and this shaking is universal: the Palatinate, Bohemia, Germany, Catalonia, Portugal, Ireland, England’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Jeremiah Whitaker, "), _c('i', [_vm._v("Ejrenopojos [The peacemaker]")]), _vm._v(", England, 1643)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘This seems to be one of the epochs in which every nation is turned upside down, leading some great minds to suspect that we are approaching the end of the world’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("("), _c('i', [_vm._v("Nicandro [The victor]")]), _vm._v(", pamphlet, Madrid, Spain, 1643)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘'Tis tru we have had many such black days in England in former ages, but those parallel'd to the present are to the shadow of a mountain compar'd to the eclipse of the moon’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(James Howell, "), _c('i', [_vm._v("Collected letters")]), _vm._v(", England, 1647)")])])]), _c('div', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _c('a', {
    attrs: {
      "id": "pVIII"
    }
  }, [_vm._v("‘There was great hunger throughout the Christian world’")])]), _c('a', {
    attrs: {
      "id": "pVIII"
    }
  }, [_c('p', {
    staticClass: "epis"
  }, [_vm._v("(Inscription, Old Sambor Cathedral, Ukraine, 1648)")])])]), _c('a', {
    attrs: {
      "id": "pVIII"
    }
  }, [_c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘The pryces of victuall and cornes of all sortes wer heigher than ever heirtofore aneyone living could remember … The lyke had never beine seine in this kingdome’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Sir James Balfour, ‘Some shorte memorialls and passages of this yeire’, Scotland, 1649)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘If one ever had to believe in the Last Judgment, I think it is happening right now’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Judge Renaud de Sévigné, letter, Paris, France, 1652)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘The elements, servants of an irate God, combine to snuff out the rest of humankind: mountains spew out fire; the earth shakes; plague contaminates the air’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Jean-Nicolas de Parival, "), _c('i', [_vm._v("Abrégé de l'histoire de ce siècle de fer [Short history of this Iron Century]")]), _vm._v(", Brussels, South Netherlands, 1653)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘A third of the world has died’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Abbess Angélique Arnauld, letter, Port-Royale-des-Champs, France, 1654)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘I no sooner perceived myself in the world but I found myself in a storm, which hath lasted almost hitherto’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(John Locke, ‘First Tract on Government’, London, 1660)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘Because of the dearth sent to us by God, we wanted to sell our property to our relatives, but they refused, and left us to die from hunger’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Gavril Niţă, Moldavian peasant, 1660)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘Transylvania never knew such misery as this last year’.")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Mihail Teleki, Chancellor of Transylvania, "), _c('i', [_vm._v("Journal")]), _vm._v(", 1661)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘So many prophets and prophetesses arose in all the cities of Anatolia that everyone believed wholeheartedly that the End of Days had come … These were indeed miraculous occurrences and wonders, the like of which had never happened since the day the world was created’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Leib ben Oyzer, "), _c('i', [_vm._v("Beschraybung fun Shabsai Zvi [Description of Shabbatai Zvi]")]), _vm._v(", on events in the Ottoman empire in 1665–6)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘The world was aflame from the time I was 15 [1638] to the time I was 18’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Enomoto Yazaemon, "), _c('i', [_vm._v("Oboegaki [Memoranda]")]), _vm._v(", Saitama, Japan, 1670)")])]), _vm._v(" "), _c('div', {
    staticClass: "epi"
  }, [_c('p', {
    staticClass: "epi"
  }, [_vm._v("‘Since [1641] I am not afraid of seeing dead people, because I saw so many of them at that time’")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("(Yao Tinglin, "), _c('i', [_vm._v("Linian ji [Record of successive years]")]), _vm._v(", Shanghai, China, c. 1670)")])])]), _c('div', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "pVIII"
    }
  }), _c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "pVIII"
    }
  }), _c('a', {
    attrs: {
      "id": "pIX"
    }
  }, [_vm._v("‘Many people held their lives to be of no value, for the area was so wasted and barren, the common people so poor and had suffered so much, that essentially they knew none of the joys of being alive … Every day one would hear that someone had hanged himself from a beam and killed himself. Others, at intervals, cut their throats or threw themselves into the river’")])]), _c('a', {
    attrs: {
      "id": "pIX"
    }
  }, [_c('p', {
    staticClass: "epis"
  }, [_vm._v("(Huang Liuhong, "), _c('i', [_vm._v("Fuhui quanshu [Complete book concerning happiness and benevolence]")]), _vm._v(", about events in Shandong, China, c. 1670)")])])]), _c('a', {
    attrs: {
      "id": "pIX"
    }
  })])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pX"
    }
  }), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007List_of_Illustrations"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/009Prologue_Did_Someone_Say_x2018Climate_Changex0027"
    }
  }, [_c('i', [_vm._v("Prologue: Did Someone Say ‘Climate Change'?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019"
    }
  }, [_c('i', [_vm._v("Introduction: The ‘Little Ice Age’ and the ‘General Crisis’")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/011PART_I_THE_PLACENTA_OF_THE_CRISIS"
    }
  }, [_vm._v("PART I. THE PLACENTA OF THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0121_The_Little_Ice_Age"
    }
  }, [_vm._v("1 The Little Ice Age")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0132_The_x2018General_Crisisx2019"
    }
  }, [_vm._v("2 The ‘General Crisis’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis"
    }
  }, [_vm._v("3 ‘Hunger is the greatest enemy’: The Heart of the Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century"
    }
  }, [_vm._v("4 ‘A third of the world has died’: Surviving in the Seventeenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/016PART_II_ENDURING_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II. ENDURING THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The ‘Great Enterprise’ in China, 1618–84")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 ‘The great shaking’: Russia and the Polish-Lithuanian Commonwealth, 1618–86")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The ‘Ottoman tragedy’, 1618–83")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The ‘lamentations of Germany’ and its Neighbours, 1618–88")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Agony of the Iberian Peninsula, 1618–89")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 France in Crisis, 1618–88")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Stuart Monarchy: The Path to Civil War, 1603–42")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Britain and Ireland from Civil War to Revolution, 1642–89")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/025PART_III_SURVIVING_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III. SURVIVING THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02613_The_Mughals_and_their_Neighbours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 The Mughals and their Neighbours")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02714_Red_Flag_over_Italy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Red Flag over Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The ‘dark continents’: The Americas, Africa and Australia")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02916_Getting_it_Right_Early_Tokugawa_Japan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Getting it Right: Early Tokugawa Japan")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/030PART_IV_CONFRONTING_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV. CONFRONTING THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 ‘Those who have no means of support’: The Parameters of Popular Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 ‘People who hope only for a change’: Aristocrats, Intellectuals, Clerics and ‘dirty people of no name’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 ‘People of heterodox beliefs … who will join up with anyone who calls them’: Disseminating Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/034PART_V_BEYOND_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V. BEYOND THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03520_Escaping_the_Crisis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Escaping the Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 From Warfare State to Welfare State")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03722_The_Great_Divergence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 The Great Divergence")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/038Conclusion_The_Crisis_Anatomized",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Conclusion: The Crisis Anatomized")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/039Epilogue_x2018Itx0027s_the_climate_stupidx2019",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue: ‘It's the climate, stupid’")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/040Chronology",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chronology")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/041Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/042Note_on_Conventions",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Note on Conventions")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/043Note_on_Sources_and_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Note on Sources and Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/044Abbreviations_Used_in_the_Bibliography_and_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Abbreviations Used in the Bibliography and Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/046Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/047Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }, [_vm._v("Illustrations")])]), _c('a', {
    attrs: {
      "id": "pXI"
    }
  }, [_c('p', {
    staticClass: "ahd1"
  }, [_vm._v("Plates")])]), _c('div', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXI"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008Plates#plate1"
    }
  }, [_vm._v("1.")]), _vm._v(" Johannes Hevelius, Sunspot observations in Danzig, 1642–4. Source: Hevelius, "), _c('i', [_vm._v("Selenographia")]), _vm._v(" (Danzig, 1647), fig. 3. The Thomas Fischer Rare Book Library, University of Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate2"
    }
  }, [_vm._v("2.")]), _vm._v(" Leonhard Kern, "), _c('i', [_vm._v("Scene from the Thirty Years War,")]), _vm._v(" 1640s"), _c('i', [_vm._v(".")]), _vm._v(" Source: Kunsthistorisches Museum, Vienna (KK 4363).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate3"
    }
  }, [_vm._v("3.")]), _vm._v(" King Charles I exchanges his worldly crown for a crown of thorns, 1649. Source:"), _c('i', [_vm._v(" Eikōn Basilikē")]), _vm._v(", 1649, frontispiece by William Marshall. The Huntington Library, San Marino, California (RB 121950).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate4"
    }
  }, [_vm._v("4.")]), _vm._v(" Zacharias Wagenaer, Drawing of the city of Edo on 4 March 1657 after the fire, 1651. Source: Edo-Tokyo Museum, Tokyo.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate5"
    }
  }, [_vm._v("5.")]), _vm._v(" Yang Dongming, "), _c('i', [_vm._v("Jimin tushuo")]), _vm._v(" ["), _c('i', [_vm._v("Album of the Famished")]), _vm._v("], 1688. Source: By kind permission of Henan Provincial Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate6"
    }
  }, [_vm._v("6.")]), _vm._v(" A letter left with an abandonned baby, 1628. Source: AHN Consejos, 41,391, unfol.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate7"
    }
  }, [_vm._v("7.")]), _vm._v(" Weather in China, 1640 and 1641. Source: "), _c('i', [_vm._v("Zhongguo Jin-wubai-nian Hanlao Fenbu Tu-ji")]), _vm._v(", 91.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate8"
    }
  }, [_vm._v("8.")]), _vm._v(" A Chinese male undergoes ‘tonsorial castration’, 1843. Source: Rev. G. N. Wright, "), _c('i', [_vm._v("China")]), _vm._v(", III, 50. © The British Library Board (Maps 10.bb.31).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate9"
    }
  }, [_vm._v("9.")]), _vm._v(" ‘The Wine Jew’, Germany, 1629. Source: Germanisches Nationalmuseum (HB 2057, Kapsel 1279).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate10"
    }
  }, [_vm._v("10.")]), _vm._v(" The salt register for Calle Fuencarral, Madrid, 1631. Source: BNE Ms 6760. Courtesy of the Biblioteca National de España.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate11"
    }
  }, [_vm._v("11.")]), _vm._v(" Spanish stamp duty ("), _c('i', [_vm._v("Papel Sellado")]), _vm._v("). Source: Hispanic Society of America, "), _c('i', [_vm._v("Altamira Papers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate12"
    }
  }, [_vm._v("12.")]), _vm._v(" A consulta signed by Philip IV, 7 December 1640. Source: AGS GA 1331, unfol., Philip IV's rescript to a consulta from the "), _c('i', [_vm._v("Junta de Ejecució")]), _vm._v("n, 7 December 1640. España, Ministerio de Cultura, Archivo General de Simancas.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate13"
    }
  }, [_vm._v("13.")]), _vm._v(" Wenceslaus Hollar, "), _c('i', [_vm._v("The British Civil Wars and the Revolt of Bohemia")]), _vm._v(", 1632. Source: Wenceslaus Hollar, "), _c('i', [_vm._v("Map of Civil War England and a View of Prague")]), _vm._v(", 1632. Private Collection/The Bridgeman Art Library.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate14"
    }
  }, [_vm._v("14.")]), _vm._v(" ‘The Arch-Prelate of St Andrews in Scotland reading the new service book in his pontificalious assaulted by men & women, with crickett tooles sticks and stones’, 1637. Source: Private Collection/The Bridgeman Art Library.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate15"
    }
  }, [_vm._v("15.")]), _vm._v(" Wenceslaus Hollar, The earl of Strafford's impeachment in Westminster Hall, 1641. Source: The Thomas Fischer Rare Book Library, University of Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/008Plates#plate16"
    }
  }, [_vm._v("16.")]), _vm._v(" ‘Now are ye wilde Irisch as well as wee’, 1655. Source: Anon., "), _c('i', [_vm._v("The Barbarous and Inhumane Proceedings Against the Professors of the Reformed Religion")]), _vm._v(" (London, 1655), 13. The Huntington Library, San Marino, California (RB 16167).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate17"
    }
  }, [_vm._v("17.")]), _vm._v(" Yang Dongming, "), _c('i', [_vm._v("Jimin tushuo")]), _vm._v(" ["), _c('i', [_vm._v("Album of the Famished")]), _vm._v("], 1688. Source: By kind permission of Henan Provincial Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate18"
    }
  }, [_vm._v("18.")]), _vm._v(" Micco Spadaro, "), _c('i', [_vm._v("The revolt of Masaniello")]), _vm._v(", c. 1647. Source: Museo di San Martino, Naples. Photo Scala, Florence. Courtesy of the Ministero Beni e Att. Culturali.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate19"
    }
  }, [_vm._v("19.")]), _vm._v(" ‘The figure of the Indians’ fort or Palizado in New England And the marer of the destroying it by Captayne Underhill And Captayne Mason’, 1637. Source: John Underhill, "), _c('i', [_vm._v("Nevves from America")]), _vm._v(" (1638). Library of Congress, LC-USZ62-32055.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate20"
    }
  }, [_vm._v("20.")]), _vm._v(" Portion of a map of Edo, Japan. Source: University of Texas Libraries.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate21"
    }
  }, [_vm._v("21.")]), _vm._v(" Micco Spadaro, The Execution of Don Giuseppe Carafa, c. 1647. Source: Museo di San Martino, Naples. Photo Scala, Florence. Courtesy of the Ministero Beni e Att. Culturali.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate22"
    }
  }, [_vm._v("22.")]), _vm._v(" ‘Smoking kills’, 1658. Source: Jakob Balde, "), _c('i', [_vm._v("Die trückene Trünckenheit")]), _vm._v(" (Nuremberg, 1658), frontispiece.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate23"
    }
  }, [_vm._v("23.")]), _vm._v(" Frontispiece to Grimmelshausen, "), _c('i', [_vm._v("Der Abenteuerliche Simplicissimus")]), _vm._v(" ("), _c('i', [_vm._v("The Adventurous Simplicissimus")]), _vm._v("), 1668. Source: akg-images.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate24"
    }
  }, [_vm._v("24.")]), _vm._v(" Johan Niewhaf, "), _c('i', [_vm._v("Tiencenwey")]), _vm._v(", 1656. Source: Nieuhof, "), _c('i', [_vm._v("Die Gesantschaft der Ost-Indischen Geselschaft")]), _vm._v(", Heidelberg University Library, A4820, pull-out 28.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate25"
    }
  }, [_vm._v("25.")]), _vm._v(" "), _c('i', [_vm._v("A general Bill for this present year")]), _vm._v(", 1665. Source: Guildhall Library, London. Courtesy of the London Metropolitan Archives.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate26"
    }
  }, [_vm._v("26.")]), _vm._v(" Jan van de Heyden, A fire engine in action during a major freeze, Amsterdam, 1684. Source: "), _c('i', [_vm._v("Beschryving der nieuwlyks uitgevonden en geoctrojeerde slang-brand-spuiten en haare wyze van brand-blussen, tegenwoordig binnen Amsterdam in gebruik zijnde")]), _vm._v(" (Amsterdam, 1672), figure 16.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate27"
    }
  }, [_vm._v("27.")]), _vm._v(" "), _c('i', [_vm._v("Renatus Cartesius")]), _vm._v(", c. 1720. Source: Pieter van der Aa, "), _c('i', [_vm._v("XX icones clarissimorum medicorum Philosophorum Liberales Artes Profitentium Aliorumque")]), _vm._v(" (Leiden, c. 1720). Landesbibliothek Oldenburg.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/008Plates#plate28"
    }
  }, [_vm._v("28.")]), _vm._v(" ‘A Scheme At one View representing to the Eye the Observations of the Weather for a Month’, 1663. Source: Sprat, "), _c('i', [_vm._v("History")]), _vm._v(", I, 179. © The British Library Board (740.c.17).")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd1"
  }, [_vm._v("Figures")]), _vm._v(" "), _c('div', {
    staticClass: "nl"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/009Prologue_Did_Someone_Say_x2018Climate_Changex0027#fig_01"
    }
  }, [_vm._v("1.")]), _vm._v(" The Global Crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0121_The_Little_Ice_Age#fig_02"
    }
  }, [_vm._v("2.")]), _vm._v(" Sunspot cycles, volcanic anomalies, and summer temperature variations in the seventeenth century. Source: Eddy, ‘The “Maunder Minimum”’, 290, figure 11–6; Vaquero, ‘Revised, sunspot data’, figure 2; and Atwell, ‘Volcanism’, Figures C5 and E3.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0121_The_Little_Ice_Age#fig_03"
    }
  }, [_vm._v("3.")]), _vm._v(" Estimated heights of French males born between 1650 and 1770. Source: Komlos, ‘Anthropometric history’, 180, "), _c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0132_The_x2018General_Crisisx2019#fig_04"
    }
  }, [_vm._v("4.")]), _vm._v(" Frequency of wars in Europe 1610–80")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_05"
    }
  }, [_vm._v("5.")]), _vm._v(" Farms in south-east Scotland abandoned in the seventeenth century. Source: Grove, "), _c('i', [_vm._v("Little Ice Age")]), _vm._v(", 409.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_06"
    }
  }, [_vm._v("6.")]), _vm._v(" The ‘dampening effect’ of London on England's overall demographic growth. Courtesy of Sir Tony Wrigley.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_07"
    }
  }, [_vm._v("7.")]), _vm._v(" The fires of Istanbul 1600–1700. Source: Atasoy and Raby, "), _c('i', [_vm._v("Iznik")]), _vm._v(", 16–17.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_08"
    }
  }, [_vm._v("8.")]), _vm._v(" The double-cropping cycle in Liangan southeast China. Source: Marks, "), _c('i', [_vm._v("Tigers")]), _vm._v(", 203.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXIII"
    }
  }), _c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_09"
    }
  }, [_vm._v("9.")]), _vm._v(" A simple model of early modern economic systems. Courtesy of Kishimoto Mio.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis#fig_10"
    }
  }, [_vm._v("10.")]), _vm._v(" The social structure of Navalmoral, Spain, in the early seventeenth century. Source: Weisser, "), _c('i', [_vm._v("Peasants")]), _vm._v(", 38–42.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_11"
    }
  }, [_vm._v("11.")]), _vm._v(" The Mediterranean plague epidemic of 1648–56. Courtesy of Jorge Nadal.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_12"
    }
  }, [_vm._v("12.")]), _vm._v(" Mortality in Barcelona, 1650–4. Source: Betrán, "), _c('i', [_vm._v("La peste")]), _vm._v(", 73.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_13"
    }
  }, [_vm._v("13.")]), _vm._v(" Burials in Berkshire, England. Source: Dils, ‘Epidemics’, 148.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_14"
    }
  }, [_vm._v("14.")]), _vm._v(" A subsistence crisis: Geneva 1627–32. Source: Perrenoud, "), _c('i', [_vm._v("La population de Genève")]), _vm._v(", 443.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century#fig_15"
    }
  }, [_vm._v("15.")]), _vm._v(" Children abandoned at the Foundlings Hospital of Milan. Source: Hunecke, "), _c('i', [_vm._v("Die Findelkinder von Mailand")]), _vm._v(", 218 and 221.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")]), _vm._v(" Ming China in the seventeenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")]), _vm._v(" Disasters and diseases cripple Ming China, 1641. Source: Dunstan, ‘Late Ming epidemics’, map 6; von Glahn, "), _c('i', [_vm._v("Fountain of fortune")]), _vm._v(", xiii.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384#fig_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")]), _vm._v(" East Asian temperatures, 800–1800. Courtesy of Keith Briffa and Tim Osborn.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386#fig_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")]), _vm._v(" The Russian empire and the Polish-Lithuanian Commonwealth.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383#fig_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")]), _vm._v(" The climatic zones of the Ottoman Empire. Source: Hütterroth, ‘Ecology’, 20.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383#fig_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.")]), _vm._v(" Tax yields in the Balkans, Anatolia and Syria, 1640–1834. Source: McGowan, "), _c('i', [_vm._v("Economic life in Ottoman Europe")]), _vm._v(", 113.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383#fig_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.")]), _vm._v(" The Ottoman empire at war, 1630–1700. Source: Mantran, "), _c('i', [_vm._v("Istanbul")]), _vm._v(", 260.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388#fig_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.")]), _vm._v(" The rhythm of pamphlet publication in Germany, 1618–50.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388#fig_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.")]), _vm._v(" The depopulation of Germany during the Thirty Years War, 1618–48. Source: Franz, "), _c('i', [_vm._v("Der dreissigjähriger Krieg,")]), _vm._v(" 4th edn, 8.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.")]), _vm._v(" The revolt of Portugal, 1637. Source: Schaub, "), _c('i', [_vm._v("Le Portugal")]), _vm._v(", 491.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.")]), _vm._v(" Catalonia in revolt, May 1640. Source: "), _c('i', [_vm._v("Atles d'Història de catalunya")]), _vm._v(", 157.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.")]), _vm._v(" The subsistence crisis in Madrid, 1647–8. Source: Larquié, “Popular uprisings,” 97.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.")]), _vm._v(" The ‘Green Banner’ revolts in Andalusia, 1647–52. Source: Domínguez Ortiz, "), _c('i', [_vm._v("Alteraciones andaluzas")]), _vm._v(", 51.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389#fig_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.")]), _vm._v(" Baptisms in Castile, 1600–1700. Source: Nadal, ‘La población española’, 53–4.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.")]), _vm._v(" Seventeenth-century France. Source: Bonney, "), _c('i', [_vm._v("Political change,")]), _vm._v(" 345.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.")]), _vm._v(" Receipts from the "), _c('i', [_vm._v("taille")]), _vm._v(" by the French treasury, 1600–47. Source: Bonney, "), _c('i', [_vm._v("The rise of the fiscal state,")]), _vm._v(" 141.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.")]), _vm._v(" Pamphlet publication in seventeenth-century France. Source: Duccini, 'Regard’, 323.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.")]), _vm._v(" Monthly production of "), _c('i', [_vm._v("Mazarinades")]), _vm._v(", May 1649–July 1653. Source: Carrier, "), _c('i', [_vm._v("La presse")]), _vm._v(", I, 275.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388#fig_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.")]), _vm._v(" War, climate and mortality in Ile-de-France during the seventeenth century. Source: Garnier, ‘Calamitosa tempora, 9, figure 4.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342#fig_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.")]), _vm._v(" Plan of the Palace of Westminster, England. Source: Jones and Kelsey, "), _c('i', [_vm._v("Housing Parliament")]), _vm._v(", ix.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389#fig_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.")]), _vm._v(" Periodicals and newspapers published in England, 1620–75. Source: Crane and Kaye, "), _c('i', [_vm._v("A census")]), _vm._v(", 179–81.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389#fig_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.")]), _vm._v(" Publications in seventeenth-century England. Source: Cressy, "), _c('i', [_vm._v("England on edge")]), _vm._v(", 293.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389#fig_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.")]), _vm._v(" The redistribution of confiscated Irish land, 1653–60. Source: Bottigheimer, "), _c('i', [_vm._v("English money and Irish land")]), _vm._v(", 215.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02613_The_Mughals_and_their_Neighbours#fig_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.")]), _vm._v(" The Mughal annual ‘radius of action’. Source: Gommans, "), _c('i', [_vm._v("Mughal warfare")]), _vm._v(", 108.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02613_The_Mughals_and_their_Neighbours#fig_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.")]), _vm._v(" Drought and the seventeenth-century crisis in Indonesia. Source: Reid, ‘The crisis’, 213.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02714_Red_Flag_over_Italy#fig_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.")]), _vm._v(" The kingdom of Naples in revolt, 1647–8. Source: Hugo, "), _c('i', [_vm._v("Naples")]), _vm._v(", 93.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.")]), _vm._v(" Trade between Seville and America, 1500–1650. Source: Romano, "), _c('i', [_vm._v("Conjonctures opposées")]), _vm._v(", 162.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43.")]), _vm._v(" The southward advance of the Sahara from 1630. Source: Brooks, "), _c('i', [_vm._v("Landlords and strangers")]), _vm._v(", 10.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "id": "pXIV"
    }
  }), _c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44.")]), _vm._v(" Drought and disease in west-central Africa, 1560–1710. Source: Miller, ‘The significance of drought’, 21.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45.")]), _vm._v(" Famine and drought in Chad, Senegambia and the Niger Bend, 1500–1710. Source: Nicholson, ‘Methodology’, 45.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia#fig_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46.")]), _vm._v(" Slaves captured and shipped from Africa, 1600–1700. Courtesy of David Eltis.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/02916_Getting_it_Right_Early_Tokugawa_Japan#fig_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47.")]), _vm._v(" The growth of publishing houses in Japan, 1591–1818. Source: Ikegami, "), _c('i', [_vm._v("Bonds of Civility")]), _vm._v(", 296.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance#fig_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48.")]), _vm._v(" Collective violence in Ming China, 1368–1644. Source: Tong, "), _c('i', [_vm._v("Disorder under heaven")]), _vm._v(", 47.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019#fig_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49.")]), _vm._v(" Universities founded in Europe, 1600–60. Source: H. de Ridder-Simoens, "), _c('i', [_vm._v("History of the university in Europe. II: early modern Europe")]), _vm._v(" (Cambridge, 1996), 98.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution#fig_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50.")]), _vm._v(" Revolts in the Papal States in 1648. Source: Hugon, "), _c('i', [_vm._v("Naples")]), _vm._v(", 27.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/034PART_V_BEYOND_THE_CRISIS#fig_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51.")]), _vm._v(" ‘The Great Winter’ of 1708/9. Source: Lachiver, "), _c('i', [_vm._v("Les années de misère")]), _vm._v(", 274.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State#fig_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52.")]), _vm._v(" An economy of integrated regions. Courtesy Kishimoto Mio.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State#fig_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53.")]), _vm._v(" The conquest of plague in seventeenth-century Europe. Source: Lebrun, "), _c('i', [_vm._v("Se soigner autrefois")]), _vm._v(", 162–3.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03722_The_Great_Divergence#fig_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54.")]), _vm._v(" Henry Oldenburg's network of correspondents, 1641–77. Source: Hatch, ‘Between erudition and science’, 57.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/03722_The_Great_Divergence#fig_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55.")]), _vm._v(" Sources of the information used by Newton in "), _c('i', [_vm._v("Principia Mathematica")]), _vm._v(" (1687). Source: Schaffer, "), _c('i', [_vm._v("The information order")]), _vm._v(", 23.")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate1"
    }
  }, [_vm._v("1 Sunspot observations by Johannes Hevelius in Danzig, 1644. (See page 13.) Hevelius, a brewer, and his wife noted all the sunspots they observed, and later created composite disks that recorded their movement (in this case between 27 August and 8 October 1644) , a task facilitated by the relative absence of spots between the 1640s and the 1710s. With the insouciance characteristic of the age, Hevelius published these solar observations as an appendix to his book about the moon.")])]), _c('a', {
    attrs: {
      "id": "plate1"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_02.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate1"
    }
  }), _c('a', {
    attrs: {
      "id": "plate2"
    }
  }, [_vm._v("2 Leonhard Kern, ‘Scene from the Thirty Years War’. (See page 31.) This shocking alabaster sculpture, carved in the 1640s, shows a Swedish officer abducting a young naked woman, presumably to rape her. In preparation, he has tied her hands and presses his blade into her back.")])]), _c('a', {
    attrs: {
      "id": "plate2"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_03.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate2"
    }
  }), _c('a', {
    attrs: {
      "id": "plate3"
    }
  }, [_vm._v("3 King Charles I exchanges his worldly crown for a crown of thorns. (See page 41.) While in prison, Charles ‘set down the private reflections of my conscience, and my most impartial thoughts, touching the chief passages . . . in my late troubles’, in a book called "), _c('i', [_vm._v("Eikon Basilike")]), _vm._v(" (‘The king’s image’). Printed copies circulated on the day of his execution, 30 January 1649, and 35 English and 25 foreign editions had appeared by year’s end.")])]), _c('a', {
    attrs: {
      "id": "plate3"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_04.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate3"
    }
  }), _c('a', {
    attrs: {
      "id": "plate4"
    }
  }, [_vm._v("4 ‘Drawing of the city of Edo on 4 March 1657 after the fire’. (See page 63.) Zacharias Wagenaer, a Dutch merchant who had trained as a draughtsman, graphically depicted the desolation caused by the Meireki fire. Dead bodies lie in the street (F), and the castle of the shogun, once the largest edifice in Japan, lies in ruins (A) . Only a few merchant ‘Godowns’ made of stone remain intact (D).")])]), _c('a', {
    attrs: {
      "id": "plate4"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_05.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate4"
    }
  }), _c('a', {
    attrs: {
      "id": "plate5"
    }
  }, [_vm._v("5 Famine kills: Henan, China. (See page 79.) In his "), _c('i', [_vm._v("Album of the famished")]), _vm._v(" (1688), Yang Dongming, a government inspector, showed how hunger produced suicide. Here, five members of a starving family of seven have hanged themselves from a tree in the garden of the local magistrate whom they blamed for failing to feed them. They leave two young children to fend for themselves.")])]), _c('a', {
    attrs: {
      "id": "plate5"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_06.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate5"
    }
  }), _c('a', {
    attrs: {
      "id": "plate6"
    }
  }, [_vm._v("6 A baby pleads for good treatment at the Foundling Hospital of Madrid. (See page 100.) ‘My name is Ana'begins the label written by distraught parents when they abandoned their daughter in 1628. It ends: ‘I beg you to entrust me to someone who will look after me. A.’")])]), _c('a', {
    attrs: {
      "id": "plate6"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_07.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate6"
    }
  }), _c('a', {
    attrs: {
      "id": "plate7"
    }
  }, [_vm._v("7 Weather in China, 1640 and 1641. (See page 126.) Chinese historians of climate have reconstructed the prevailing weather in each of the last 500 years by plotting data from local Gazetteers on a scale from 1 (very wet) to 5 (very dry) . Both 1640 and 1641 emerge as years of extreme drought in northern China and Manchuria, with abnormal precipitation in parts of the south.")])]), _c('a', {
    attrs: {
      "id": "plate7"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_08.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate7"
    }
  }), _c('a', {
    attrs: {
      "id": "plate8"
    }
  }, [_vm._v("8 A Chinese male undergoes ‘tonsorial castration’. (See page 141.) The Qing edict that all their male subjects must shave their foreheads and wear the rest of their hair in a pigtail provoked widespread opposition not only because it provided unequivocal proof of allegiance to the new dynasty, but also because it required constant repetition. Han Chinese had to re-affirm submission to their conquerors on a regular basis.")])]), _c('a', {
    attrs: {
      "id": "plate8"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_09.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate8"
    }
  }), _c('a', {
    attrs: {
      "id": "plate9"
    }
  }, [_vm._v("9 ‘The Wine Jew’, Germany, 1629. (See page 220.) A popular print shows the devil guiding a Jewish wine-merchant to Hell. The upper register records the climatic disasters of the previous ‘year without a summer’, linked to a Biblical warning. On the left, vineyards are destroyed by torrential rain (‘He serves you a storm for a punishment’: Psalm 11) and drought (‘I will command the clouds not to rain’: Isaiah 5:6) . In the centre, clouds obscure the sun (‘I will make the sun go down at noon and darken the land’: Amos 8:9).")])]), _c('a', {
    attrs: {
      "id": "plate9"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_10.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate9"
    }
  }), _c('a', {
    attrs: {
      "id": "plate10"
    }
  }, [_vm._v("10 The ‘salt register’ for Calle Fuencarral, Madrid, 1631. (See page 259.) To enforce its new salt monopoly, the Spanish government pre-printed forms where each head of household had to state his or her name, the size of the household, and how much salt it would buy in the coming year. They then either signed it or (like all these householders) authorized the notary to sign ‘because they do not know how’.")])]), _c('a', {
    attrs: {
      "id": "plate10"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_11.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate10"
    }
  }), _c('a', {
    attrs: {
      "id": "plate11"
    }
  }, [_vm._v("11 Spanish stamp duty ("), _c('i', [_vm._v("Papel Sellado")]), _vm._v(") . (See page 262.) Another fiscal innovation introduced by the Spanish government in the 1630s was ‘stamp duty’ payable for official transactions. The recipient of this grant, personally signed by the king ("), _c('i', [_vm._v("Yo el Rey")]), _vm._v(") , had to pay 272 "), _c('i', [_vm._v("maravedis")]), _vm._v(" to the treasury of ‘Philip IIII, the Great’ for the paper on which it was written.")])]), _c('a', {
    attrs: {
      "id": "plate11"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_12.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate11"
    }
  }), _c('a', {
    attrs: {
      "id": "plate12"
    }
  }, [_vm._v("12 Philip IV weeps, 7 December 1640. (See page 277.) A consulta from his ‘Executive committee’ concerning rumours of ‘unrest in Portugal’ noted the absence of any news from the duke of Braganca, suggesting that the duke had defected. The tear stains and poor script suggest that Philip lost his self-control as he wrote his response and added his initial (the large ‘J’ at the end).")])]), _c('a', {
    attrs: {
      "id": "plate12"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_13.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate12"
    }
  }), _c('a', {
    attrs: {
      "id": "plate13"
    }
  }, [_vm._v("13 The British Civil Wars and the Revolt of Bohemia. (See page 324.) The Czech engraver Wenceslas Hollar, a fugitive in England, summarized in images the argument of John Rushworth’s "), _c('i', [_vm._v("Historical Collections")]), _vm._v(" concerning the origins of the Civil Wars. Like Rushworth, Hollar began with the ‘blazing comet’ and defenestration of Prague in 1618 (Q and W, upper right) , leading to the battle of White Mountain (the large right-hand image: X) ; while in Britain the Edinburgh riots (C, top centre) , the pacification of Berwick, the battle of Newburn, the Irish Rebellion (D, G and H, on the large left-hand image) , and Charles’s attempt to arrest the Five Members (I, bottom centre) , combined to produce war.")])]), _c('a', {
    attrs: {
      "id": "plate13"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_14.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate13"
    }
  }), _c('a', {
    attrs: {
      "id": "plate14"
    }
  }, [_vm._v("14 Rioting against the first use of ‘Laud’s Liturgy’ in Edinburgh, 1637. (See page 334.) Although this crude woodcut implied that only men participated, women took the lead in the rioting that broke out in St Giles Cathedral during the morning service on 23 July 1637.")])]), _c('a', {
    attrs: {
      "id": "plate14"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_15.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate14"
    }
  }), _c('a', {
    attrs: {
      "id": "plate15"
    }
  }, [_vm._v("15 The earl of Strafford’s impeachment in Westminster Hall, 1641. (See page 344.) Wenceslas Hollar’s engraving shows England’s 70 peers (wearing their hats and robes) surrounded by grandstands where almost 600 members of the House of Commons sit bare-headed. Behind Strafford (standing front centre) over 1,000 members of the public who had purchased tickets listened and watched as the trial unfolded.")])]), _c('a', {
    attrs: {
      "id": "plate15"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_16.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate15"
    }
  }), _c('a', {
    attrs: {
      "id": "plate16"
    }
  }, [_vm._v("16 ‘Now are ye wilde Irisch as well as wee.’ (See page 350.) One of several graphic illustrations that accompanied later propaganda accounts of how Catholics murdered their Protestant neighbours in the uprising that began on 23 October 1641. Note the reference to ‘the frost & snowe’ – then, as now, a rarity in Ireland.")])]), _c('a', {
    attrs: {
      "id": "plate16"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_17.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate16"
    }
  }), _c('a', {
    attrs: {
      "id": "plate17"
    }
  }, [_vm._v("17 Selling children for food: Henan Province, China. (See page 403.) Another haunting image from Yang Dongming’s "), _c('i', [_vm._v("Album of the Famished")]), _vm._v(", shows one of the desperate acts described by observers of the ‘perfect famine’ in Gujarat in 1630–2 as well as in China: in the left-hand panel, a starving mother sells her child for a pot of rice, while on the right other mothers line up to do the same.")])]), _c('a', {
    attrs: {
      "id": "plate17"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_18.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate17"
    }
  }), _c('a', {
    attrs: {
      "id": "plate18"
    }
  }, [_vm._v("18 ‘The revolt of Masaniello’ in Naples, 1647, by Micco Spadaro. (See page 438.) In one of the earliest European pictorial records of ‘current events’, the young painter Domenico (‘Micco’ for short) Gargiulo (also known as ‘Spadaro’ because his family made swords) depicted what happened in the Piazza del Mercato during the first few days of the Naples revolt. On the left, Masaniello speaks to the crowd, as he did on 7 July 1647, while various groups of his followers (including armed bare-footed boys) mill around him. In the centre, the ‘Epitaph’ displays the naked torso of Don Giuseppe Carafa and the severed heads of others who tried to assassinate Masaniello. In the lower centre, Masaniello rides to meet the viceroy in the silver costume he wore on 11 July. The tower of Santa Maria del Carmine, headquarters of the rebels (upper right) , and high-rise apartments dominate the square.")])]), _c('a', {
    attrs: {
      "id": "plate18"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_19.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate18"
    }
  }), _c('a', {
    attrs: {
      "id": "plate19"
    }
  }, [_vm._v("19 The Massacre of the Pequots at Mystic Fort, Connecticut, in 1637. (See page 450.) The English colonists burst into the palisaded Pequot encampment at Mystic and set fire to ‘The Indians houses’. They then form a circle and use their muskets to shoot down those who try to escape, while a wider circle of their Native American allies wait to kill with their arrows any Pequots who get past the English. Recent archaeological excavations suggest that some 400 Pequots died in the massacre.")])]), _c('a', {
    attrs: {
      "id": "plate19"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_20.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate19"
    }
  }), _c('a', {
    attrs: {
      "id": "plate20"
    }
  }, [_vm._v("20 Knowledge is power: mapping Edo, capital of Tokugawa Japan. (See page 502.) The central panel of one of the many maps of Edo created from the exhaustive surveys undertaken by the Tokugawa authorities. Edo castle lies at the centre, marked with the trefoil Tokugawa crest in red and gold, surrounded by moats, canals, and rivers, as well as streets, alleys and bridges . all meticulously identified. Temples, shrines, and warehouses are clearly shown; each daimy. complex is identified by names, crests and regalia; commoner residences are left blank.")])]), _c('a', {
    attrs: {
      "id": "plate20"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_21.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate20"
    }
  }), _c('a', {
    attrs: {
      "id": "plate21"
    }
  }, [_vm._v("21 ‘The Execution of Don Giuseppe Carafa’ in Naples, 1647, by Micco Spadaro. (See page 522.) A striking ‘capriccio’ shows Masaniello, in his fisherman’s overalls and red bonnet, addressing his supporters on 10 July 1647 as they execute and mutilate the noblemen who had just tried to assassinate him. Other members of the crowd wave red flags.")])]), _c('a', {
    attrs: {
      "id": "plate21"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_22.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate21"
    }
  }), _c('a', {
    attrs: {
      "id": "plate22"
    }
  }, [_vm._v("22 ‘Smoking kills’ (See page 602.) Death, decay and debility dominate the frontispiece to a verse satire by Jakob Balde, S. J., "), _c('i', [_vm._v("Dry drunkenness")]), _vm._v(", published in Latin in 1657 with a German translation the following year. The vomiting smoker in the centre reminds viewers of some side-effects of the habit; while the skeleton on the right, with smoke pouring out of its eye sockets, leaves readers in no doubt where tobacco use leads. Modern anti-smoking images pale in comparison.")])]), _c('a', {
    attrs: {
      "id": "plate22"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_23.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate22"
    }
  }), _c('a', {
    attrs: {
      "id": "plate23"
    }
  }, [_vm._v("23 Frontispiece to Grimmelshausen, "), _c('i', [_vm._v("Abenteurlicher Simplicissimus")]), _vm._v(". (See page 612.) A phoenix, wearing only a sword and bandolier and trampling below its feet several theatrical masks, points to images of war in a book. In an age of limited literacy, images were carefully chosen and this engraving epitomized the message of "), _c('i', [_vm._v("The adventures of a German simpleton")]), _vm._v(": the Thirty Years War is over; Germany has risen from its ashes.")])]), _c('a', {
    attrs: {
      "id": "plate23"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_24.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate23"
    }
  }), _c('a', {
    attrs: {
      "id": "plate24"
    }
  }, [_vm._v("24 The Grand Canal at Tianjin, China, 1656. (See page 622.) The ingenious pen of Johannes Nieuhof, secretary of a Dutch embassy to the Qing emperor in 1656, captured the bustling scene as his barge reached the end of the Grand Canal at Tianjin, the ‘staple’ where ‘whatsoever vessels are bound for Peking from any other part of China must touch’.")])]), _c('a', {
    attrs: {
      "id": "plate24"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_25.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate24"
    }
  }), _c('a', {
    attrs: {
      "id": "plate25"
    }
  }, [_vm._v("25 The General Bill of Mortality for London, 1665. (See page 630.) Burials during the year of the Great Plague are organized both by location (upper register: one column for the total, another for plague deaths) and by cause (lower register) . The different ‘diseases and casualties’ include ‘Abortive and stillborne (617) and suicides (‘Hang’d & made away themselves’ 7) . Overall, burials in 1665 numbered 97,306, an increase over the preceding year of 79,009.")])]), _c('a', {
    attrs: {
      "id": "plate25"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_26.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate25"
    }
  }), _c('a', {
    attrs: {
      "id": "plate26"
    }
  }, [_vm._v("26 A fire engine in action during a major freeze, Amsterdam, 1684. (See page 636.) Jan van der Heyden, artist, inventor and fire-master, wrote a book – part description, part sales catalogue – about the powerful new fire engines he designed, capable of pumping water from rivers and canals even when they had iced over. He devoted three pages to how they extinguished a fire in a house on a canal in January 1684 (although he kept secret exactly how the engines worked and how he manufactured the hoses).")])]), _c('a', {
    attrs: {
      "id": "plate26"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_27.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate26"
    }
  }), _c('a', {
    attrs: {
      "id": "plate27"
    }
  }, [_vm._v("27 René Descartes gloats in his study. (See page 649.) The scholar plants his foot disparagingly on one book labelled ‘Aristotle’ as he annotates another – surely not the "), _c('i', [_vm._v("Discourses")]), _vm._v(" of Galileo, which Descartes purchased on its publication in 1638 only to complain: ‘I just spent two hours leafing through it, but I found little there with which to fill the margins’.")])]), _c('a', {
    attrs: {
      "id": "plate27"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Global Crisis",
      "src": "images/plate_28.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate27"
    }
  }), _c('a', {
    attrs: {
      "id": "plate28"
    }
  }, [_vm._v("28 ‘A scheme At one View representing to the Eye the Observations of the Weather for a Month’, England, 1663. (See page 661.) Robert Hooke, ‘Curator of experiments’ for the newly founded Royal Society of Great Britain, proposed to its Fellows a method for collecting data for ‘A history of the weather’, mobilizing observers in various stations throughout England. Although the ‘scheme’ came to nothing, the Society’s first historian, Thomas Sprat, considered it worthy of commemoration.")])]), _c('a', {
    attrs: {
      "id": "plate28"
    }
  })])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pXV"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "pXV"
    }
  }, [_c('p', {
    staticClass: "ct1"
  }, [_vm._v("Did Someone Say ‘Climate Change’?")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "pXV"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("LIMATE CHANGE HAS ALMOST EXTINGUISHED LIFE ON EARTH ON THREE")]), _vm._v(" occasions. Some 250 million years ago, a series of massive volcanic eruptions in Siberia caused rapid changes in the earth's atmosphere that wiped out 90 per cent of its species. Next, 65 million years ago, an asteroid struck what is now Mexico and created another atmospheric catastrophe that eliminated 50 per cent of the earth's species (including the dinosaurs). Finally, some 73,000 years ago, the volcanic eruption of Mount Toba in Indonesia caused a ‘winter’ that lasted several years and apparently killed off most of the human population."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-1",
      "id": "nr-pro-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("No subsequent environmental disaster has had a global impact on this scale, but several other episodes of climate change have caused widespread destruction and dislocation. About 13,000 years ago, the northern hemisphere experienced an episode of global cooling (probably after a comet collided with the earth), which wiped out most animal life. About 4,000 years ago, societies in south and west Asia collapsed amid general drought; while between "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 750 and 900 drought on both sides of the Pacific fatally weakened the Tang empire in China and the Maya culture in central America."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-2",
      "id": "nr-pro-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Then, in the mid-fourteenth century, a combination of violent climatic oscillations and major epidemics halved Europe's population and caused severe depopulation and disruption in much of Asia."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-3",
      "id": "nr-pro-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Finally, in the mid-seventeenth century, the earth experienced some of the coldest weather recorded in over a millennium. Perhaps one-third of the human population died.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Although climate change can and does produce human catastrophe, few historians include the weather in their analyses. Even in his pioneering 1967 study, "), _c('i', [_vm._v("Times of feast, times of famine: a history of climate since the year 1000")]), _vm._v(", Emanuel Le Roy Ladurie averred that ‘In the long term, the human consequences of climate seem to be slight, perhaps negligible’. By way of example, he stated that ‘it would be quite absurd’ to try and ‘explain’ the French rebellion between 1648 and 1653 known as the Fronde ‘by the adverse meteorological conditions of the 1640s’. A few years later Jan de Vries, a distinguished economic historian, likewise argued that ‘Short-term climatic crises stand in relation to economic history as bank robberies to the history of banking’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-4",
      "id": "nr-pro-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Historians are not alone in denying a link between climate and catastrophe. Richard Fortey, a noted palaeontologist, has observed that ‘There is a kind of optimism built into our species that seems to prefer to live in the comfortable "), _c('a', {
    attrs: {
      "id": "pXVI"
    }
  }, [_vm._v("present rather than confront the possibility of destruction’, with the result that ‘Human beings are never prepared for natural disasters’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-5",
      "id": "nr-pro-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Extreme climatic events therefore continue to take us by surprise, even if they cause massive damage. In 2003 a summer heatwave that lasted just two weeks led to the premature death of 70,000 people in Europe; while in 2005 Hurricane Katrina killed over 2,000 people and destroyed property worth over $81 billion in an area of the United States equivalent in size to Great Britain. In the course of 2011 over 106 million people around the world were adversely affected by floods; almost 60 million by drought; and almost 40 million by storms. Yet although we know that the climate caused these and many other catastrophes in the past, and although we also know that it will cause many more in the future, we still convince ourselves that they will not happen just yet (or, at least, not to us)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-6",
      "id": "nr-pro-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Currently, most attempts to predict the consequences of climate change extrapolate from recent trends; but another methodology exists. Instead of hitting ‘fast forward’, we can ‘rewind the tape of History’ and study the genesis, impact and consequences of past catastrophes, using two distinct categories of proxy data: a ‘natural archive’ and a ‘human archive’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The ‘natural archive’ comprises four groups of sources:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Ice cores and glaciology")]), _vm._v(": the annual deposits on ice caps and glaciers around the world, captured in deep boreholes, provide evidence of changing levels of volcanic emissions, precipitation, air temperature and atmospheric composition."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-7",
      "id": "nr-pro-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Palynology")]), _vm._v(": pollen and spores deposited in lakes, bogs and estuaries capture the natural vegetation at the time of deposit."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-8",
      "id": "nr-pro-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Dendrochronology")]), _vm._v(": the size of growth rings laid down by certain trees during each growing season reflects local conditions in spring and summer. A thick ring indicates a year favourable to growth, whereas a narrow ring reflects a year of adversity."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-9",
      "id": "nr-pro-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Speleothems")]), _vm._v(": the annual deposits formed from groundwater trickling into underground caverns, especially in the form of stalactites, can serve as a climate proxy."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-10",
      "id": "nr-pro-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The ‘human archive’ on climate change comprises five groups of sources:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Narrative")]), _vm._v(" information contained in oral traditions and written texts (chronicles and histories, letters and diaries, judicial and government records, ships’ logs, newspapers and broadsheets).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Numerical")]), _vm._v(" information extracted from documents (such as fluctuations in the date when harvesting certain crops began each year, in food prices, in sunspots observed, or in the number of men paid each spring to steer the detritus that swept down rivers along with snowmelt); and from narrative reports (‘Rain fell for the first time in 42 days’).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Pictorial")]), _vm._v(" representations of natural phenomena (paintings or engravings that show the position of a glacier's tongue in a given year, or that depict ice floes in a harbour during a winter of unusual severity)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-11",
      "id": "nr-pro-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "pXVII"
    }
  }, [_vm._v("• "), _c('i', [_vm._v("Epigraphic")]), _vm._v(" or "), _c('i', [_vm._v("archaeological")]), _vm._v(" information, such as inscriptions on structures that date flood levels, or excavations of settlements abandoned because of climate change.")])]), _c('a', {
    attrs: {
      "id": "pXVII"
    }
  }), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "pXVII"
    }
  }, [_vm._v("• "), _c('i', [_vm._v("Instrumental data.")]), _vm._v(" Starting in the 1650s, in Europe, some observers regularly recorded weather data, including precipitation, wind direction and temperatures."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-12",
      "id": "nr-pro-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The failure of most historians to exploit the data available in these two ‘archives’ for the seventeenth century is particularly regrettable, because an intense episode of global cooling coincided with an unparalleled spate of revolutions and state breakdowns around the world (including Ming China, the Polish–Lithuanian Commonwealth and the Spanish Monarchy), while other states came close to revolution (notably, the Russian and Ottoman empires in 1648; and the Mughal empire, Sweden, Denmark and the Dutch Republic in the 1650s) ("), _c('a', {
    attrs: {
      "href": "#/#fig_01"
    }
  }, [_vm._v("Fig. 1")]), _vm._v("). In addition, Europe saw only three years of complete peace during the entire seventeenth century, while the Ottoman empire enjoyed only ten. The Chinese and Mughal empires fought wars almost continuously. Throughout the northern hemisphere, war became the norm for resolving both domestic and international problems.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Historians have christened this age of turmoil ‘The General Crisis’, and some have seen it as the gateway to the modern world. The term was popularized by Hugh Trevor-Roper in an influential essay, first published in 1959, which argued that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The seventeenth century did not absorb its revolutions. It is not continuous. It is broken in the middle, irreparably broken, and at the end of it, after the revolutions, men can hardly recognize the beginning. Intellectually, politically, morally, we are in a new age, a new climate. It is as if a series of rainstorms has ended in one final thunderstorm which has cleared the air and changed, permanently, the temperature of Europe. From the end of the fifteenth century until the middle of the seventeenth century we have one climate, the climate of the Renaissance; then, in the middle of the seventeenth century, we have the years of change, the years of revolution; and thereafter, for another century and a half, we have another, very different climate, the climate of the Enlightenment."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-13",
      "id": "nr-pro-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("But of ‘climate’ in its literal sense Trevor-Roper said not a word, even though the upheavals he described occurred during a period marked by global cooling and extreme weather events.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The climatic evidence is both clear and consistent. Daily readings from an international network of observation stations reveal that winters between 1654 and 1667 were, on average, more than 1ˆC cooler than those of the later twentieth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-14",
      "id": "nr-pro-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Other records show that 1641 saw the third coldest summer recorded over the past six centuries in the northern hemisphere; the second coldest winter in a century experienced in New England; and the coldest winter "), _c('i', [_vm._v("ever")]), _vm._v(" recorded in Scandinavia. The summer of 1642 was the 28th coldest, and that of 1643 the 10th coldest, recorded in the northern hemisphere over the past six centuries; while the winter of 1649–50 seems to have been the coldest on record in both northern and eastern China. Abnormal climatic conditions lasted from the 1640s until the 1690s – the longest as well as the most severe episode of global cooling recorded in the entire Holocene Era – leading climatologists to dub this period ‘The Little Ice Age’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-15",
      "id": "nr-pro-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXVIII"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/map_01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pXVIII"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXVIII"
    }
  }), _c('a', {
    attrs: {
      "id": "pXIX"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pXIX"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "pXIX"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_01"
    }
  }, [_vm._v("1. The Global Crisis."), _c('br'), _vm._v("Although Europe and East Asia formed the heartland of the ‘General Crisis’, the Mughal and Ottoman empires, like the European colonies in America, also experienced episodes of severe political disruption in the mid-seventeenth century.")])]), _c('a', {
    attrs: {
      "id": "fig_01"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_01"
    }
  }, [_vm._v("This volume seeks to link the climatologists’ Little Ice Age with the historians’ General Crisis – and to do so without ‘painting bull's eyes around bullet holes’: without arguing that global cooling ‘must’ have somehow caused recession and revolution around the world simply because climate change is the only plausible common denominator. Le Roy Ladurie was absolutely correct to insist in 1967 that ‘The historian of seventeenth-century climate’ must ‘be able to apply a quantitative method comparable in rigour if not in accuracy and variety to the methods used by present-day meteorologists in the study of twentieth-century climate’, and he regretted that this goal was then unattainable."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-16",
      "id": "nr-pro-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" The sources now available, however, allow historians to integrate climate change with political, economic and social change with unprecedented precision. Accounts of climatic conditions in Africa, Asia, Europe and the Americas in the mid-seventeenth century abound, while millions of measurements of tree-rings, ice-cores, pollen deposits and stalactite formations are available."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-17",
      "id": "nr-pro-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, the new data, however abundant and however striking, must not turn us into climatic determinists. As early as 1627, Joseph Mede, a polymath with a special interest in astronomy and eschatology who taught at Christ's College, "), _c('a', {
    attrs: {
      "id": "pXX"
    }
  }, [_vm._v("Cambridge, pointed out a methodological pitfall: any increase in observations may simply reflect an increase in the number of observers. Thus when he heard almost simultaneously about an earthquake near Glastonbury and ‘another prodigie from Boston [Lincolnshire] of fire from heaven’, Mede observed sagely: ‘Either we have more strange accidents than was wont, or we take more notice of them, or both.’ Subsequent research has corroborated Mede's surmise. For example, while modern astronomy has confirmed that the seventeenth century indeed witnessed an unusual frequency of comets, humans took ‘more notice of them’ – both because the proliferation of telescopes enabled more of them to be seen from earth, and because dramatic improvements in gathering and disseminating news meant that every sighting soon became known to more people."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-18",
      "id": "nr-pro-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A second obstacle to the accurate assessment of climatic data by historians is the role of infrastructure and contingency. On the one hand, the deleterious consequences of colder or wetter weather may be mitigated if a community has either a well-stocked granary or access to food imported through a neighbouring port. On the other hand, war may create famine even in a year of bountiful harvest by destroying or disrupting the food supply on which a community depends. In the aphorism of Andrew Appleby: ‘the crucial variable’ was often ‘not the weather but the ability to adapt to the weather’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-19",
      "id": "nr-pro-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" This volume therefore examines not only the impact of climate change and extreme climate events on human societies during the seventeenth century, but also the various adaptive strategies taken to survive the worst climate-induced catastrophe of the last millennium.")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pXXI"
    }
  }, [_vm._v("Introduction: The ‘Little Ice Age’ and the ‘General Crisis’")])]), _c('a', {
    attrs: {
      "id": "pXXI"
    }
  }, [_c('p', {
    staticClass: "ftxt"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("N 1638, FROM THE SAFETY OF HIS")]), _vm._v(" O"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("XFORD COLLEGE")]), _vm._v(", R"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("OBERT")]), _vm._v(" B"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("URTON")]), _vm._v(" informed readers of his best-selling book, "), _c('i', [_vm._v("The anatomy of melancholy")]), _vm._v(", that ‘every day’ he heard news of")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("War, plagues, fires, inundations, thefts, murders, massacres, meteors, comets, spectrums, prodigies, apparitions; of towns taken, cities besieged in France, Germany, Turky, Persia, Poland, etc; daily musters and preparations, and such like, which these tempestuous times affoord; battels fought, so many men slain, monomachies, shipwracks and sea-fights, peace, leagues, stratagems, and fresh alarums.")])])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "pXXI"
    }
  }, [_vm._v("Four years later, the English Civil War started and a group of London merchants lamented that ‘All trade and commerce in this kingdom is almost fallen to the ground through our own unhappy divisions at home, unto which the Lord in mercy put a good end. And as the badness of trade and scarcity of money are here, so is all Europe in little better condition, but in a turmoil, either foreign or domestic war.’ In 1643 the preacher Jeremiah Whitaker warned his hearers that ‘[These] days are days of shaking, and this shaking is universal: the Palatinate, Bohemia, Germany, Catalonia, Portugal, Ireland, England.’ Normally, Whitaker argued, God ‘shakes all successively’, but now it seemed that He planned to ‘shake all nations collectively, jointly and universally’. Indeed, he speculated, so much simultaneous ‘shaking’ must herald the Day of Judgement:"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-1",
      "id": "nr-intro-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("That same year, in Spain, a tract entitled "), _c('i', [_vm._v("Nicandro")]), _vm._v(" ["), _c('i', [_vm._v("The victor")]), _vm._v("] made the same point.")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Sometimes Providence condemns the world with universal and evident calamities, whose causes we cannot know. This seems to be one of the epochs in which every nation is turned upside down, leading some great minds to suspect that we are approaching the end of the world. We have seen all the north in commotion and rebellion, its rivers running with blood, its populous provinces deserted; England, Ireland and Scotland aflame with Civil War.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("‘What area does not suffer,’ the "), _c('i', [_vm._v("Nicandro")]), _vm._v(" concluded rhetorically, ‘if not from war, then from earthquakes, plague and famine?’, repeating: ‘This seems to be one of the epochs in which every nation is turned upside down, leading some great minds to suspect that we are approaching the end of the world.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-2",
      "id": "nr-intro-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "pXXII"
    }
  }, [_vm._v("In Germany, a Swedish diplomat expressed alarm in 1648 at a new bout ‘of revolts by the people against their rulers everywhere in the world, for example in France, England, Germany, Poland, Muscovy, the Ottoman empire’. He was well informed: civil war had just begun in France, and continued to rage in England; the Thirty Years War (1618–48) had left much of Germany devastated and depopulated; the Cossacks of Ukraine had rebelled against their Polish overlords and massacred thousands of Jews; revolts rocked Moscow and other Russian cities; and an uprising in Istanbul led to the murder of the Ottoman sultan. The following year, a Scottish exile in France concluded that he and his contemporaries lived in an ‘Iron Age’ that would become ‘famous for the great and strange revolutions that have happened in it’. In 1653, in Brussels, historian Jean-Nicolas de Parival used the same metaphor in the title of his book, "), _c('i', [_vm._v("A short history of this Iron Century, containing the miseries and misfortunes of recent times")]), _vm._v(". ‘I call this century the “Iron Century”’, he informed his readers, because so many misfortunes ‘have come together, whereas in previous centuries they came one by one’. He noted that rebellions and wars now ‘resemble Hydra: the more you cut off their heads, the more they grow’. Parival also noted that ‘The elements, servants of an irate God, combine to snuff out the rest of humankind: mountains spew out fire, the earth shakes, plague contaminates the air’, and ‘the continuous rain causes rivers to flood’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-3",
      "id": "nr-intro-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Seventeenth-century China also suffered. First, a combination of droughts and disastrous harvests, rising tax demands and drastic cutbacks in government programmes unleashed a wave of banditry and chaos. Then, in 1644, one of the bandit leaders, Li Zicheng, declared himself ruler of China and seized Beijing from the demoralized defenders of the Ming emperor (who committed suicide). Almost immediately, China's northern neighbours, the Manchus or Qing, invaded and defeated Li, entered Beijing, and for the next 30 years ruthlessly extended their authority over the whole country. Several million people perished in the Ming-Qing transition.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Few areas of the world survived the mid-seventeenth century unscathed. North America and West Africa both experienced famines and savage wars. In India, drought followed by floods killed over a million people in Gujarat between 1627 and 1630; while a vicious civil war in the Mughal empire intensified the impact of another drought between 1658 and 1662. In Japan, following several poor harvests, in 1637–8 the largest rural rebellion in modern Japanese history broke out on the southern island of Kyushu. Five years later famine, followed by a winter of unusual severity, killed perhaps 500,000 people.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The fatal synergy that developed between natural and human factors created a demographic, social, economic and political catastrophe that lasted for two generations, and convinced contemporaries that they faced unprecedented hardships. It also led many of them to record their misfortunes as a warning to others. ‘Those who live in times to come will not believe that we who are alive now have suffered such toil, pain and misery,’ wrote Fra Francesco Voersio, an Italian friar, in his "), _c('i', [_vm._v("Plague Diary")]), _vm._v(". Nehemiah Wallington, a London craftsman, compiled several volumes of ‘Historical notes and meditations’ so that ‘the generation to come may see what wofull and miserable times we lived in’. Likewise Peter Thiele, a German tax official, "), _c('a', {
    attrs: {
      "id": "pXXIII"
    }
  }, [_vm._v("kept a diary so that ‘our descendants can discover from this how we were harassed, and see what a terribly distressed time it was'; while the German Lutheran Pastor Johann Daniel Minck did the same because, ‘without such records … those who come after us will never believe what miseries we have suffered’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-4",
      "id": "nr-intro-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" According to the Welsh historian James Howell in 1647, ‘‘Tis tru we have had many such black days in England in former ages, but those parallel'd to the present are to the shadow of a mountain compar'd to the eclipse of the moon’; and he speculated that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("God Almighty has a quarrel lately with all Mankind, and given the reins to the ill Spirit to compass the whole earth; for within these twelve years there have the strangest Revolutions and horridest things happened, not only in Europe but all the world over, that have befallen mankind (I dare boldly say) since Adam fell, in so short a revolution of time … [Such] monstrous things have happened [that] it seems the whole world is off the hinges; and (which is the more wonderful) all these prodigious passages have fallen out in less than the compass of twelve years."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-5",
      "id": "nr-intro-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In 1651, in his book "), _c('i', [_vm._v("Leviathan")]), _vm._v(", Thomas Hobbes (then a refugee from the English Civil War living in France) provided perhaps the most celebrated description of the consequences of the fatal synergy between natural and human disasters faced by him and his contemporaries:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("There is no place for industry, because the fruit thereof is uncertain, and consequently no culture of the earth; no navigation, nor use of the commodities that may be imported by sea; no commodious building; no instruments of moving and removing such things as require much force; no knowledge of the face of the earth; no account of Time; no arts; no letters; no society. And, which is worst of all, continual fear and danger of violent death; and the life of man, solitary, poor, nasty, brutish and short."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-6",
      "id": "nr-intro-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When did this fatal synergy commence? In his "), _c('i', [_vm._v("History of the civil wars of these recent times")]), _vm._v(" of 1652, the Italian historian Majolino Bisaccione traced the sequence of ‘popular revolts in my lifetime’ back to the rebellion of Bohemia in 1618, which had attracted the support of some German Protestants, led by Frederick of the Palatinate, and so began a civil war in Germany. Seven years later, the English antiquarian John Rushworth agreed. When he sought to explain, ‘how we came to fall out among ourselves’ in the English Civil War, he too started his account back in 1618 because his research convinced him that the conflict originated in ‘the causes and grounds of the war in the Palatinate, and how far the same concerned England, and the oppressed Protestants in Germany’. Rushworth also noted the appearance of three comets of unusual brilliance in 1618, which (like almost all his contemporaries) he interpreted as a harbinger of evil. He therefore ‘resolved that very instant should be the "), _c('i', [_vm._v("Ne Plus Ultra")]), _vm._v(" of my retrospect’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-7",
      "id": "nr-intro-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The available evidence amply vindicates the chronology proposed by Bisaccione and Rushworth. Although Europe had experienced many earlier economic, social and political crises, they remained largely isolated and relatively short-lived. By "), _c('a', {
    attrs: {
      "id": "pXXIV"
    }
  }, [_vm._v("contrast, the Bohemian revolt began a prolonged conflict that lasted three decades and eventually involved all the major states of Europe: Denmark, the Dutch Republic, France, Poland, Russia, Sweden, the Swiss Confederation and, above all, the Stuart and Spanish Monarchies. The year 1618 also saw long-running crises commence in two other parts of the world. In the Ottoman empire, a palace faction deposed the sultan (the first such event in the history of the dynasty), unleashing a series of catastrophes that a generation later the scholar-bureaucrat Kâtib Çelebi would term "), _c('i', [_vm._v("Haile-i Osmaniye")]), _vm._v(": ‘The Ottoman Tragedy’. Meanwhile, in East Asia, Nurhaci, leader of a tribal confederation in Manchuria, declared war on the Chinese emperor and invaded Liaodong, a populous area of Chinese settlement north of the Great Wall. Some observers immediately realized the significance of this step. Years later, Wu Yingji, a gentleman-scholar, recalled ‘a friend telling me, when the difficulties began in the eighth month of 1618 in Liaodong, that the state would have several decades of warfare; and my thinking that his words were absurd because the state was quite intact’. Nevertheless the ‘friend’ had been right: the Manchu invasion initiated almost seven ‘decades of warfare’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-8",
      "id": "nr-intro-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These events took place against a background of extreme weather events. Many parts of sub-Saharan Africa suffered a serious drought between 1614 and 1619; Japan experienced its coldest spring of the seventeenth century in 1616; heavy snow fell in subtropical Fujian in 1618; the winter of 1620–1 was intensely cold in Europe and the Middle East; drought afflicted both the valley of Mexico and Virginia for five years out of six between 1616 and 1621. Finally, 1617 and 1618 marked the beginning of a prolonged aberration in the behaviour of the sun, signalled first by the reduction and then by the virtual disappearance of sunspots. For all these reasons, this book follows the lead of Bisaccione, Rushworth, Kâtib Çelebi and Wu Yingji's friend: 1618 is ‘the "), _c('i', [_vm._v("Ne Plus Ultra")]), _vm._v(" of my retrospect’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When did the fatal synergy end? Here the evidence is less consistent. In 1668 Thomas Hobbes began "), _c('i', [_vm._v("Behemoth")]), _vm._v(", his account of the English Civil Wars, by observing that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("If in time, as in place, there were degrees of high and low, I verily believe that the highest of times would be that which passed between the years 1640 and 1660. For he that thence, as from the Devil's Mountain, should have looked upon the world and observed the actions of men, especially in England, might have had a prospect of all kinds of injustice and all kinds of folly that the world could afford."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-9",
      "id": "nr-intro-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Yet exactly 20 years later another revolution occurred: William of Orange landed at the head of the largest army ever to invade first Britain and then Ireland, in both of which he created a new regime. On the European continent, most of the contentious issues unleashed by the revolt of Bohemia were resolved between 1648 and 1661, but France's invasion of the Palatinate in 1688 generated a new conflict. In the Ottoman empire, in the 1650s the Grand Vizier Köprüllük Mehmet managed to end the cycle of domestic rebellion and, during the following decade, his son and successor defeated all foreign enemies and the empire began to expand again; but "), _c('a', {
    attrs: {
      "id": "pXXV"
    }
  }, [_vm._v("the defeat of the Turkish army before Vienna in 1683 halted the Ottoman advance into Europe and led to the deposition of another sultan.")])]), _c('a', {
    attrs: {
      "id": "pXXV"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "pXXV"
    }
  }, [_vm._v("Nevertheless, the 1680s saw the end of several conflicts. The ‘Eternal Peace of Moscow’ in 1686 marked the permanent ascendancy of Russia over the Polish-Lithuanian Commonwealth; while in 1683, Manchu troops finally defeated the last of their opponents, allowing a government inspector to exult that the Qing emperor ‘has crushed all the rebels and even the seas are calm. At present, the people have returned to their former lands. Their homes are protected and their livelihood is secure. They will respect and honour Your Majesty's benevolence for generations to come.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-10",
      "id": "nr-intro-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" China's seventeenth-century crisis had ended at last. Meanwhile, in Boston, Massachusetts, Increase Mather (preacher at the North Church in Boston and president of Harvard College) warned the world that the brilliant comets that appeared in 1680 and 1682 ‘are the presages of great calamities at hand’. Little did he know that these two comets would be the last ‘fearful sights and signs in heaven’ of the age."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-11",
      "id": "nr-intro-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, although both political upheavals and comets became less frequent, the Little Ice Age continued. In the northern hemisphere, 9 of the 14 summers between 1666 and 1679 were either cool or exceptionally cool – harvests in western Europe ripened later in 1675 than in any other year between 1484 and 1879 – and climatologists regard the extreme climatic events and disastrous harvests during the 1690s, with average temperatures 1.5°C below those of today, as the ‘climax of the Little Ice Age’. This time, global cooling did not produce a wave of revolutions. The fatal synergy had been broken. This book ends by examining why."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-12",
      "id": "nr-intro-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Writing global history is not easy. In 2011 Alain Hugon prefaced his study of the revolt of Naples in 1647–8 by noting that, although ‘contemporaries clearly stated that no barriers separated the various revolutions of the seventeenth century’, nevertheless ‘We historians of the twentieth and twenty-first centuries dare not study them in their totality, despite our awareness of this synchronicity, of the interdependence, and of the interactions that occurred’. Hugon reported that whenever he ‘tried to make historical comparisons appropriate to the mid-seventeenth century, the problems that arise from the need to contextualize each historical event render the attempt vain’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-13",
      "id": "nr-intro-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It is easy to sympathize with this view. On the one hand, recent research has revealed both far more ‘historical events’ than previous scholars had imagined – Hugon himself uncovered evidence of over 100 revolts in the kingdom of Naples in 1647–8; over 20 towns and cities in Andalusia took part in the ‘Green Banner Revolts’ of 1648–52; almost half the communities of Portugal followed Évora into rebellion in 1637 – and far broader participation in many of the events already known (over a million Chinese joined the ‘roving bandits’ in the 1630s; perhaps a million people perished in France's Fronde revolt, 1648–53). On the other hand, although almost all regions of the northern hemisphere experienced both the Little Ice Age and the General Crisis in the mid-seventeenth century, each did so in different ways, for different reasons, and with different outcomes – not least because some structural causes (such as climate change) lie largely beyond human control, while others (such "), _c('a', {
    attrs: {
      "id": "pXXVI"
    }
  }, [_vm._v("as wars and revolutions) involve so many people that they lie largely beyond the control of any individual. Nevertheless, modern historians must emulate the global vision of contemporaries of the Crisis and, as we ‘contextualize each historical event’, try to identify what united as well as what separated the victims.")])]), _c('a', {
    attrs: {
      "id": "pXXVI"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("A second problem in explaining the synchronicity, the interdependence and the interactions of the various revolutions is the role played by contingency. Minor events repeatedly produced consequences that were both unanticipated and disproportionate. As Dr Samuel Johnson observed:")])]), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "pXXVI"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "pXXVI"
    }
  }, [_vm._v("It seems to be almost the universal error of historians to suppose it politically, as it is physically true, that every effort has a proportionate cause. In the inanimate action of matter upon matter, the motion produced can be but equal to the force of the moving power; but the operations of life, whether private or publick, admit no such laws. The caprices of voluntary agents laugh at calculation. "), _c('i', [_vm._v("It is not always that there is a strong reason for a great event")]), _vm._v("."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-14",
      "id": "nr-intro-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Dr Johnson's warning requires historians to identify the precise moment in each revolution when ‘the motion produced’ was no longer ‘equal to the force of the moving power’, and ‘the caprices of voluntary agents laugh at calculation’. Scholars used to describe this as ‘the turning point’, and recently John Lewis Gaddis adopted from physics the term ‘phase transitions’: the moment ‘where water begins to boil or freeze, for example, or sand piles begin to slide, or fault lines begin to fracture’. I prefer another term, the ‘tipping point’, a metaphor popularized by Malcolm Gladwell, because it implies that such changes, however sudden and dramatic, may one day be reversed. Ice, after all, can easily turn back to water."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-15",
      "id": "nr-intro-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("This book studies the Global Crisis of the mid-seventeenth century through three different lenses. Part I presents evidence from both the human and natural archives to identify the channels by which the crisis impinged on humankind. Chapter 1 examines how global cooling affects the supply of food, above all of staple crops such as cereals and rice, around the world. Chapter 2 evaluates how the policies pursued by early modern states interacted with these climate changes, for example by waging wars that intensified economic hardship and by pursuing unpopular policies that destabilized societies already under economic stress, or (more rarely) by adopting initiatives that mitigated the consequences of global cooling. Chapter 3 examines four zones where a disproportionate number of key events of the mid-seventeenth century occurred: composite states; cities; marginal lands; and ‘macroregions’. Composite states, normally created by dynastic unions, were vulnerable because the ruler's authority was often weaker in peripheral areas than elsewhere; yet in wartime, precisely because they were on the periphery, these areas experienced greater political and economic pressure and often rebelled first. Global cooling gravely affected the other three zones – cities, marginal lands and macroregions – because they relied disproportionately on the yield of crops vulnerable to climate change. In addition, cities regularly suffered both fiscal and military calamities because both governments and armies targeted places that boasted a large, compact population. For the "), _c('a', {
    attrs: {
      "id": "pXXVII"
    }
  }, [_vm._v("same reasons, macroregions (densely populated areas that concentrated on producing goods for export rather than for local consumption) were also especially vulnerable to political and military changes – not just at home, but also in those areas on which they were economically dependent for imports or exports. Chapter 4 examines the demographic responses by the victims in different regions as the crisis increased an imbalance between supply and demand for resources – an imbalance that would eventually reduce the global population by perhaps one-third.")])]), _c('a', {
    attrs: {
      "id": "pXXVII"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("The chapters in Part II examine a dozen states in Eurasia that experienced the full intensity of both the Little Ice Age and the General Crisis in the mid-seventeenth century, proceeding geographically from east to west: China; Russia and Poland; the Ottoman empire; Germany and Scandinavia; the Dutch and Swiss Republics; the Iberian Peninsula; France; Great Britain and Ireland. Each chapter charts the interplay of human and natural forces right up to the ‘tipping point’ that ended the existing social, economic and political equilibrium; it then analyses the nature of the ensuing crisis; and, finally, it documents the emergence of a new equilibrium.")])]), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "pXXVII"
    }
  }, [_vm._v("The choice of an east-to-west itinerary, starting with China, is arbitrary – it reflects neither chronological differences (in most cases the ‘days of shaking’ began in or around 1618 and ended in the 1680s) nor the intensity of the crisis (although in terms of physical and personal damage, China and Ireland seem to have suffered worst of all). By contrast, the decision to devote greater space to the experience of Britain and Ireland than to other states gripped by major trauma is deliberate. In the words of Christopher Hill, perhaps the most perceptive modern historian of the subject, ‘The middle decades of the seventeenth century saw the greatest upheaval that has yet occurred in Britain’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-16",
      "id": "nr-intro-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Moreover, the ‘upheaval’ lasted longer, and produced more dramatic changes, than anywhere else except China. However, the wealth of surviving British and Irish sources permits a more detailed understanding of the causes, course and consequences of the crisis than is possible for any other society. Chapter 11 therefore charts the path to state breakdown in England, Scotland and Ireland between 1603, when they became a single state, and 1642, when the failure of his policies forced King Charles I to flee his capital. Chapter 12 examines the consequences of the prolonged wars and multiple regime changes in the three kingdoms between 1642 and 1660, including the first formulation of democratic principles now regarded as central to Western society; the attempts by the central government to overthrow them between 1660 and 1688; and their limited resurrection after the ‘Glorious Revolution’ of 1688–9.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Part III considers two categories of ‘exception’ to this pattern: those areas where at least part of the population apparently emerged from the seventeenth-century trauma relatively unscathed (some European colonies in America; South and Southeast Asia; Japan); and those regions where the impact of the Little Ice Age remains ambiguous (the Great Plains of North America; Sub-Saharan Africa; Australia). Within the first category, in Mughal India and some of its neighbours, abundant resources enabled the state to ride out the crisis (chapter 13); while in Spanish Italy, the government managed to overcome major rebellions by making major concessions (chapter 14). Elsewhere, notably in Europe's overseas outposts, "), _c('a', {
    attrs: {
      "id": "pXXVIII"
    }
  }, [_vm._v("the prosperity of a few (the European colonists) was achieved only at the expense of the many (the indigenous population: chapter 15). Only Tokugawa Japan seems to have avoided the full effects of the crisis as the result of human initiatives: although global cooling caused a major famine in the archipelago during the 1640s, a barrage of effective countermeasures first limited and then repaired the damage (chapter 16).")])]), _c('a', {
    attrs: {
      "id": "pXXVIII"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "pXXVIII"
    }
  }, [_vm._v("Despite the remarkable diversity of human experience in the states and societies afflicted by the General Crisis, some striking common denominators emerge, and Part IV considers three of them. First, popular responses to catastrophe exhibited a number of similar protocols and conventions, ranging from a surprising measure of restraint in violent protests around the world to striking similarities in what James C. Scott termed ‘the weapons of the weak’: ‘foot-dragging, dissimulation, desertion, false compliance, pilfering, feigned ignorance, slander, arson, sabotage’ (chapter 17)."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-17",
      "id": "nr-intro-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Second, an investigation of the individuals and groups in different societies who exploited the mounting instability to produce a ‘tipping point’ also exposes similarities. In many areas aristocrats played a prominent role, as they had done in many earlier crises; but in the mid-seventeenth century, from China through the Muslim world to Europe, the most prominent ‘troublemakers’ included men (some clerical, others secular) who had made great sacrifices to acquire advanced education but then failed to find suitable employment (chapter 18). A third common denominator is the ease with which radical ideas developed and spread. Proliferation sometimes occurred because insurgents travelled directly from one area to spread information and seditious ideas. Thus in 1647 the transfer of news between Naples and Palermo synchronized the rebellions in the two capitals; while the following year, in Russia, many towns rebelled as soon as their citizens returned from Moscow and described the rioting there that had forced the tsar to make massive concessions. More often, ideas spread because the proliferation of printed works and of schools had created a literate proletariat of unprecedented size in much of Asia and Europe, capable of reading, discussing and implementing new ideas. Thus although the Catholics of Ireland hated and feared the Calvinists of Scotland, they were prepared to learn from them. A few days after the 1641 uprising, when a captured Protestant asked a leading Irish Catholic: ‘“What? Yow have made a Covenant amongst yow as the Scotts did?” “Yea”, said hee, “The Scotts have taught us our A. B. C.”’ (chapter 19)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-intro-18",
      "id": "nr-intro-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Finally, Part V examines how the survivors coped with the crisis and its aftermath, and how their choices shaped a new equilibrium that emerged in various states and regions. Although the 1690s and 1700s saw further bouts of extreme weather, famine and (in Europe and China) almost continuous war, unlike the 1640s and 1650s, no revolutions and relatively few revolts occurred. So although the Little Ice Age continued, the General Crisis did not. Several changes help to explain this paradox. Throughout the northern hemisphere, massive depopulation encouraged elites to control migration: groups that had rigorously excluded newcomers now welcomed them; states that had allowed freedom of movement now sought to bind their subjects to the land (chapter 20). In most parts of the globe, the experience of state "), _c('a', {
    attrs: {
      "id": "pXXIX"
    }
  }, [_vm._v("breakdown, and the ‘continual fear and danger of violent death’, cooled the ardour of many advocates of economic, political and religious change, leading to greater political stability, economic innovation and religious toleration. It also led many governments to switch resources from warfare to welfare, fostering economic regeneration (chapter 21). Finally, chapter 22 examines a variety of intellectual responses devised to cope more effectively with future crises, some (like compulsory universal schooling) imposed by the state, others emerging among subjects – including ‘practical knowledge’ in China and Japan, the ‘new reason’ in Mughal India and the ‘Scientific Revolution’ in Europe. For various reasons, these innovations put down deeper roots in the West than elsewhere and formed a crucial ingredient in the ‘Great Divergence’ between East Asia and Northwest Europe that later developed.")])]), _c('a', {
    attrs: {
      "id": "pXXIX"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("The Conclusion considers some implications of recognizing that, far from being an aberration, ‘catastrophe’ forms an integral part of human history, while the Epilogue suggests that the current debate on ‘global warming’ confuses two distinct issues: whether human activity is making the world warmer; and whether or not sudden climate change can occur. Although some may still legitimately question the first, the seventeenth-century evidence places the second beyond doubt. The critical issues are not "), _c('i', [_vm._v("whether")]), _vm._v(" climate change occurs, but "), _c('i', [_vm._v("when")]), _vm._v("; and whether it makes better sense for states and societies to invest money now to prepare for natural disasters that are inevitable – hurricanes in the Gulf and Atlantic coasts of North America; storm surges in the lands around the North Sea; droughts in Africa; prolonged heatwaves – or instead wait to pay the far higher costs of inaction.")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("PART I")])]), _c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_c('p', {
    staticClass: "pt"
  }, [_vm._v("THE PLACENTA OF THE CRISIS")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("RENCH PHILOSOPHER AND AUTHOR")]), _vm._v(" V"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("OLTAIRE WAS THE FIRST")]), _vm._v(" to write about a Global Crisis in the seventeenth century. His "), _c('i', [_vm._v("Essay on the customs and character of nations, and on the principal facts of history from Charlemagne to Louis XIII")]), _vm._v(", composed in the 1740s for his friend, the Marquise du Châtelet (who, although an eminent mathematician, found history boring), set the wars and rebellions a century earlier within a global framework. Thus, after describing the murder of an Ottoman sultan in 1648, Voltaire immediately noted:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("This unfortunate time for Ibrahim was unfortunate for all monarchs. The Holy Roman Empire was unsettled by the famous Thirty Years’ War. Civil war devastated France and forced the mother of Louis XIV to flee with her children from her capital. In London, Charles I was condemned to death by his own subjects. Philip IV, king of Spain, having lost almost all his possessions in Asia, also lost Portugal.")])])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }, [_vm._v("Voltaire went on to consider the careers of Cromwell in England, Li Zicheng in China, Aurangzeb in India, and others who had seized power by force, concluding that the mid-seventeenth century had been ‘a period of usurpations almost from one end of the world to the other’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-part1-1",
      "id": "nr-part1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Voltaire's "), _c('i', [_vm._v("Essay")]), _vm._v(" repeatedly stressed the global dimension of the crisis: ‘In the flood of revolutions which we have seen from one end of the universe to the other, a fatal sequence of events seems to have dragged people into them, just as winds move the sand and the waves. The developments in Japan offer another example …’. Eventually, fearing that the marquise might still find his 174 chapters and 800 pages of ‘examples’ boring, he delivered his analysis in a single sentence: ‘Three things exercise a constant influence over the minds of men: climate, government and religion.’ Taken together, Voltaire proclaimed, they offer ‘the only way to explain the enigma of this world’. Two decades later, Voltaire re-read his "), _c('i', [_vm._v("Essay")]), _vm._v(" and added a number of "), _c('i', [_vm._v("Remarks")]), _vm._v(", including a fourth ‘thing’ that, he now believed, could ‘reconcile what was irreconcilable and explain what is inexplicable’ in human history: changes in population size."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-part1-2",
      "id": "nr-part1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Voltaire's global vision has attracted few imitators. Although many subsequent historians have provided accounts filled with facts on ‘government and religion’ in the seventeenth century, until very recently few noted population trends and "), _c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_vm._v("virtually none considered the influence of the climate. Nevertheless, recent work by demographers and climatologists suggests that around 1618, when the human population of the northern hemisphere was larger than ever before, the average global temperature started to fall, producing extreme climate events, disastrous harvest failures and frequent disease epidemics. Human demographic systems can seldom adapt swiftly enough to such adverse events, yet instead of seeking ways to mitigate the natural disasters and save lives, most governments around the globe exacerbated the situation by continuing their existing policies, above all their wars. These various natural and human factors constituted a ‘placenta’ capable of nourishing a global catastrophe. Even though they did not constitute the catastrophe itself, an examination of the placenta explains why the catastrophe lasted for two generations, why it killed up to one-third of the human population, and why it transformed the world inhabited by the survivors."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-part1-3",
      "id": "nr-part1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "p3"
    }
  }), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("The Little Ice Age"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-1",
      "id": "nr1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("‘A strange and wondrous succession of changes in the weather’")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("N")]), _vm._v(" 1614 R"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("ENWARD")]), _vm._v(" C"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("YSAT, BOTANIST, ARCHIVIST AND TOWN HISTORIAN OF")]), _vm._v(" Luzern, Switzerland, began a new section of his chronicle entitled ‘The Seasons of the Year’, because ‘the past few years have seen such a strange and wondrous succession of changes in the weather’. He decided to")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Record the same as a service and a favour to future generations because, unfortunately, on account of our sins, for some time now the years have shown themselves to be more rigorous and severe in the recent past, and we have seen deterioration amongst living things, not only among mankind and the animal world but also in the earth's crops and produce."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-2",
      "id": "nr1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Cysat was correct: ‘a strange and wondrous succession of changes in the weather’ had begun around the globe – and it would continue for almost a century. In west Africa, records reveal a prolonged drought from 1614 until 1619 both for Angola and for the Sahel (the semi-arid belt of savannah south of the Sahara that stretches from the Atlantic Ocean to the Red Sea). In Europe, Catalonia suffered ‘the year of the flood’ in 1617: after over a month of continuous rain, a final four-day downpour washed away bridges, mills, drainage works, houses and even town walls. All Europe experienced an unusually cold winter in 1620–1: many rivers froze so hard that for three months they could bear the weight of loaded carts and, most spectacularly, the Bosporus froze over so that people could walk across the ice between Europe and Asia (apparently a unique climatic anomaly)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-3",
      "id": "nr1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Other parts of the northern hemisphere also experienced abnormal weather. Japan endured its coldest spring of the seventeenth century in 1616; while Chinese Gazetteers recorded heavy snowfall in 1618 in subtropical Fujian (almost as rare as the Bosporus freezing over). Four provinces reported a severe winter in 1620, as did four more in 1621. In the Americas, drought afflicted the valley of Mexico for five years out of six between 1616 and 1621, and reduced the crops in the Chesapeake basin so severely that the new Virginia colony almost failed. After six better harvests, the summer of 1627 was the wettest recorded in Europe during the past 500 years, while 1628 was a ‘year without a summer’, with temperatures so low that many crops never ripened. Between 1629 and 1632, much of Europe suffered excessive rains "), _c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("followed by drought. Conversely northern India suffered a ‘perfect drought’ in 1630–1 followed by catastrophic floods in 1632. All of these regions experienced dramatic falls in population."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-4",
      "id": "nr1-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Some better weather followed in the 1630s, but then came three of the coldest summers ever recorded in the northern hemisphere. Drought and cold significantly stunted the growth of trees throughout the western United States between 1640 and 1644, while the Canadian Rockies experienced severe and prolonged drought from 1641 until 1653. Since virtually no rain fell in the valley of Mexico in 1640, 1641 and 1642, the clergy of Mexico City organized processions with the ‘Virgen de los Remedios’, an image believed to possess special efficacy in bringing rain, to beg God's intervention before everyone starved to death (the first time the image had ever been used in consecutive years). Early in 1642, John Winthrop, governor of the Massachusetts Bay colony, noted that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The frost was so great and continual this winter that all the Bay was frozen over, so much and so long, as the like, by the Indians’ relation, had not been so these forty years … To the southward also the frost was as great and the snow as deep, and at Virginia itself the great [Chesapeake] bay was much of it frozen over, and all of their great rivers.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("To the north, English settlers on the coast of Maine complained of the ‘most intolerable piercing winter’ and found it ‘incredible to relate the extremity of the weather’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-5",
      "id": "nr1-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Abnormal droughts also prevailed on the other side of the Pacific. The Indonesian rice harvest failed in both 1641 and 1642; and between 1643 and 1671 Java experienced the longest drought recorded during the past four centuries. In Japan the first winter snow of 1641 fell on Edo (as Tokyo was then known) on 28 November, almost the earliest date on record (the average date is 5 January), and both that year and the next saw unusually late springs. According to a 1642 pamphlet published in the Philippines, because of the ‘great drought’ throughout the archipelago ‘a great famine is feared'; and two years later, a resident of Manila recorded that once again ‘there has been much famine among the Indians [Filipinos] because the rice harvest was a poor one on account of the drought’. In North China, numerous Gazetteers reported drought in 1640 and the following year the Grand Canal, which brought food to Beijing, dried up for lack of rain (another unparalleled event); while in the lower Yangzi valley chroniclers recorded abnormal rain and cold throughout the spring of 1642."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-6",
      "id": "nr1-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The lands around the Mediterranean also experienced extreme weather at this time. In March 1640 a messenger approaching Istanbul, ‘with snow up to the horses’ knees’, experienced ‘such a frost that I caught two frozen birds on the way simply with my own hand’. Catalonia endured a drought in spring 1640 so intense that the authorities declared a special holiday to enable the entire population to make a pilgrimage to a local shrine to pray for water – one of only four such occasions in the past five centuries. In 1641 the Nile fell to the lowest level ever recorded while the narrow growth rings laid down by trees in Anatolia reveal a disastrous drought. In Istanbul, by contrast, a chronicler recorded that rain flooded areas near Hagia "), _c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("Sophia so that ‘the shops were under water and destroyed'; while in Macedonia, the autumn saw ‘so much rain and snow that many workers died through the great cold’. Early in 1642 the Guadalquivir broke its banks and flooded Seville, and the years 1640–3 were the wettest on record throughout Andalusia."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-7",
      "id": "nr1-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Further north, English men and women noted ‘the extraordinary distemperature of the season in August 1640, when the land seemed to be threatened with the extraordinary violence of the winds and unaccustomed abundance of wet'; while in Ireland, frost and snow in October 1641 began what contemporaries considered ‘a more bitter winter than was of some years before or since seen in Ireland’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-8",
      "id": "nr1-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Hungary experienced uncommonly wet and cold weather between 1638 and 1641, while summer frosts repeatedly devastated crops in Bohemia. In the Alps, unusually narrow tree rings reflect poor growing seasons throughout the 1640s, while estate papers record the disappearance of fields, farmsteads and even whole villages as glaciers advanced up to 1.2 miles beyond their current positions (their furthest extent in historical times). In eastern France, each grape harvest between 1640 and 1643 began a full month later than usual and grain prices surged, indicating poor cereal harvests. In the Low Countries, all along the river Maas (or Meuse), floods caused by snowmelt early in 1643 created ‘the greatest desolation that one could imagine: the houses all broken open and overturned, and people and animals dead in the hedgerows. Even the branches of the highest trees contained a number of cows, sheep and chicken.’ In Iceland, the unusual cold and constant rain ruined the hay, and in 1640 farmers resorted to dried fish as fodder for their cattle. Perhaps most striking of all, a soldier serving in central Germany recorded in his diary in "), _c('i', [_vm._v("August")]), _vm._v(" 1640 that ‘at this time there was such a great cold that we almost froze to death in our quarters and, on the road, three people did freeze to death: a cavalryman, a woman and a boy'; while 1641 remains the coldest year "), _c('i', [_vm._v("ever")]), _vm._v(" recorded in Scandinavia."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-9",
      "id": "nr1-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Data from the southern hemisphere reveal a similar climatic aberration. In Chile, drought in the 1630s led the chief inquisitor to apologize to his superiors that he could not send them any proceeds from fines and confiscations because ‘for the past three years we have not collected a penny on account of the drought'; while glaciers, tree rings and carbon-14 deposits all show significantly cooler weather in Patagonia in the 1640s."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-10",
      "id": "nr1-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" In Sub-Saharan Africa, a severe drought afflicted both Senegambia and the Upper Niger between 1640 and 1644; while Angolan records show a unique concentration of droughts, locust infestations and epidemics throughout the second quarter of the seventeenth century, with a major drought and famine in 1639–45.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The decade ended with another bout of extreme weather around the globe. In 1648, on the Isle of Wight in southern England, a local landowner lamented that ‘from Mayday till the 15th of September, we had scarce three dry days together’, and when a visitor asked him ‘whether that weather was usual in our island? I told him that in this forty years I never knew the like before’. Meanwhile, in Scotland, ‘The long great rains for many weeks did prognosticate famine’, and produced 'so great a dearth of corn as Ireland has not seen in our memory, and so cruel a famine, which has already killed thousands of the poorer sort’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-11",
      "id": "nr1-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The following "), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("winter, the river Thames froze over as far as London Bridge and the barge arrying the corpse of Charles I to its final resting place after his execution on 30 January 1649 avoided ice floes in the river only with difficulty. Other parts of northwest Europe also experienced unusual precipitation that year – 226 days of rain or snow according to a meticulous set of records from Fulda in Germany (compared with an upper limit of 180 days in the twentieth century) – followed by ‘a winter that lasted six months’. In France, appalling weather delayed the grape harvest into October in 1648, 1649 and 1650, and drove bread prices to the highest levels in almost a century, while floods covered central Paris for much of spring 1649. In China, the winter of 1649–50 seems to have been the coldest on record."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-12",
      "id": "nr1-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The 1650s brought no respite. In the Dutch Republic, so much snow fell early in 1651 that the state funeral of Stadholder William II had to be postponed because mourners could not reach The Hague, and then the combination of snowmelt and a storm tide caused the worst flooding for 80 years in coastal regions. Catastrophic floods caused by snowmelt also occurred along the Vistula and the Seine. Conversely, 1651 saw the longest recorded drought in Languedoc and Roussillon, the Mediterranean borderlands between France and Spain: 360 days, or almost an entire year. In the Balkans, in spring 1654 ‘it snowed abundantly, [and] the snow covered the ground until Easter. I have never before seen such snowstorms and frost, moisture and cold.’ Even olive ‘oil and wine got frozen in the jars’. England experienced an ‘unusual drought, which has lain upon us for some years, and still continues and increases upon us, threatening famine and mortality'; while in 1658 John Evelyn judged that he and his compatriots had just lived through ‘the severest winter that man alive had known in England: the crow's feet were frozen to their prey; islands of ice enclosed both fish and fowl frozen, and some persons in their boats’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-13",
      "id": "nr1-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The same ‘landmark winter’ of 1657–8 affected other parts of the northern hemisphere. Along America's Atlantic coast, Massachusetts Bay froze over while the Delaware river froze so hard that deer ran across it. In Europe, people rode their horses on the ice across the Danube at Vienna, across the Main at Frankfurt and across the Rhine at Strasbourg, while barge traffic along the rivers and canals of the Netherlands gave way to sledges. The canal between Haarlem and Leiden remained frozen for 63 days. A Swedish ambassador returning home from Edirne (modern Turkey-in-Europe) noted in February 1658 that the weather was so cold that even migrating birds turned back, ‘causing everyone to wonder'; while the Baltic froze so hard that a horse and cart could pass easily from the mouth of the Vistula at Danzig to the Hell Peninsula, and the Swedish army with all its artillery marched 20 miles over the Danish Sound from Jutland to Copenhagen. Inevitably, the following spring brought disastrous flooding as the snow and ice melted: the Seine again inundated Paris and many other towns, while the dikes in the Netherlands broke in 22 different places. Lieuwe van Aitzema, the official historian of the Dutch Republic, devoted two pages of his chronicle to the extreme climatic events around Europe during 1658, ‘a year in which the winter was as harsh and severe at the beginning as at the end’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-14",
      "id": "nr1-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("The seventeenth century saw not only extreme climatic events but also unusual concentrations of them. Of 62 recorded floods of the river Seine in and around Paris, 18 occurred in the seventeenth century. In England (and probably elsewhere in northwest Europe), ‘bad weather ruined the harvests of corn and hay for five years from the autumn of 1646 onwards’, with five more bad harvests in a row between 1657 and 1661. Put another way, 10 harvest failures occurred within the space of 16 years. The Aegean and Black Sea regions experienced the worst drought of the last millennium in 1659, followed by a winter so harsh that the Danube at Girugiu (200 miles inland from the Black Sea) froze so hard in a single night that the Ottoman army marched across the ice into Romania, ‘laying waste all the villages and leaving no blade of grass or soul alive anywhere’. An official noted in his journal that, thanks to war and the weather, ‘Transylvania never knew such misery as this last year [1660]’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-15",
      "id": "nr1-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" Extreme weather conditions continued in Europe. Ice floes blocked the Vistula with unequalled frequency, and in March 1657 a ship entering the river Elbe encountered ‘mountaines of ice coming downe the river’ and, despite using ‘long poles to keep off the ice’ all night, ‘at day light wee had a mountaine of ice gathered before us, much higher’ than the vessel itself. In 1675 much of the northern hemisphere experienced a ‘year without a summer’. Ice floes repeatedly clogged and even froze the Thames during the 1660s and 1670s, most spectacularly in 1683–4, when ‘there was a whole streete called the broad streete framed quite over the Thames from the Temple to the Bear Garden, and booths built, and many thousands of people walking sometimes together at once’. For six weeks crowds enjoyed ‘severall Bull baitings’ and ‘all manner of debauchery on the Thames’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-16",
      "id": "nr1-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Poland experienced frost on several summer days in 1664, 1666 and 1667, and 109 days with frost in the year 1666–7 (compared with an average of 63 days today). Further south, in Moldavia, in the summer of 1670,")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Terrible floods, frequent showers and heavy rainfall day and night raged for three months on end, destroying all of the best wheat, barley, oats, millet and all types of crop. Because they lie in water and are attacked by too much moisture, they neither ripen nor can bear seeds. Nor can the grasses and herbaceous seeds in hay-fields grow, for frost and water; or, if they do, they cannot be harvested [because] the sun never warms or dries up the land.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In 1686 a military engineer on campaign in what is now Romania complained that ‘for three years now, I haven't seen a single drop of rain’. Lakes and rivers dried up, and ‘in the swampy soil, cracks were so deep that a standing man could not be seen … I doubt if there is another example of such a terrible and lasting drought.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-17",
      "id": "nr1-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" In Russia, tree-ring, pollen and peat-bed data show that the springs, autumns and winters between 1650 and 1680 were some of the coldest on record; and, in China, the winters between 1650 and 1680 formed the coldest spell recorded in the Yangzi and Yellow river valleys over the last two millennia. In Africa, finally, according to a Turkish traveller in the 1670s, ‘no one in Egypt used to know about wearing furs. There was no winter. But now we have severe winters and we have started wearing "), _c('a', {
    attrs: {
      "id": "p8"
    }
  }, [_vm._v("fur because of the cold.’ Meanwhile, in the Sahel, drought in the 1680s became so severe and so widespread that Lake Chad fell to its lowest recorded level."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-18",
      "id": "nr1-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Two artefacts from these years still strikingly reflect the unusually cold climate that prevailed. First, the abnormal frost, snow and ice gave rise to the popular genre of ‘winter landscapes’ by Dutch painters: most art galleries possess at least one, and almost all date from the later seventeenth century. Second, the wooden backs of the peerless violins made by Antonio Stradivari of Cremona in northern Italy display remarkably narrow growth rings, reflecting the unique succession of cold summers in the mid-seventeenth century that stunted the growth of the trees with which he worked.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("So much abnormal weather led some contemporaries to suspect that they lived in the middle of a major climate change. In June and July 1675 (the century's second ‘year without a summer’), the Paris socialite Madame de Sévigné complained to her daughter, in Provence, that ‘It is horribly cold: we have the fires lit, just like you, which is very remarkable'; and speculated that ‘like you, we think the behaviour of the sun and of the seasons has changed’. A generation later the Kangxi emperor, who collected and studied weather reports from all over China, noted how ‘the climate has changed’. For example, His Majesty noted, ‘in Fujian, where it never used to snow, since the beginning of our dynasty [1636], it has’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-19",
      "id": "nr1-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The Search for Scapegoats")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Early modern people had good reason to monitor and to fear climate change. In the eloquent assessment of historian Thomas C. Smith:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Farming, with its allied tasks, was the principal occupation and nearly the sole source of income for most families, and its rhythms defined the annual cycle of work, rest and worship. Severe annual variations in the harvest reverberated through family life, determining whether the family ate well or meagrely, whether the old might live another winter, whether a daughter could marry."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-20",
      "id": "nr1-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Men and women therefore searched anxiously for explanations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many attributed natural disasters to divine displeasure. In China, the heavy and prolonged snows in 1641–2 convinced the scholar Qi Biaojia that ‘Heaven is extremely angry'; somewhat later, the Kangxi emperor claimed that ‘If our administration is at fault on earth, Heaven will respond with calamities from above'; while a Chinese folk song from the period reproached the Lord of Heaven for the catastrophic conditions:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Old skymaster, you're getting on,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Your ears are deaf, your eyes are gone.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Can't see people, can't hear words.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Glory for those who kill and burn;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For those who fast and read the scriptures, Starvation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("Similarly, a Jesuit living in the Philippines speculated that the simultaneous eruption of three volcanoes in 1641 meant that ‘Divine Providence wishes to show us something, perhaps to warn us of some approaching catastrophe, which our sins so deserve, or the loss of some territory, because God is angry’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-21",
      "id": "nr1-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Such statements reflected the prevailing ‘peccatogenic’ outlook (from "), _c('i', [_vm._v("peccatum")]), _vm._v(", the Latin word for ‘sin’): attributing disasters, including military defeats as well as bad weather and famine, to human misconduct. A circular letter written in 1648 by a new president of the Council of Castile, the minister responsible for internal affairs, was typical: ‘The principal cause of the calamities that afflict this kingdom are the public sins and injustices committed’, and punishing the former and ‘administering justice with due rectitude and speed are the most important ways to oblige Our Lord to provide the successes that this Monarchy needs so much’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-22",
      "id": "nr1-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" In Germany the Protestant magistrates of Nuremberg commanded citizens to avert divine displeasure by showing moderation in food, drink and fashion and by refraining from sensual pleasure (especially if it involved adultery, sodomy or dancing). For the same reason, their Catholic neighbour, Maximilian of Bavaria, issued a stream of orders that forbade dancing, gambling, drinking and extramarital sex; limited the duration and cost of wedding festivities; forbade women to wear skirts that revealed their knees; proscribed the joint bathing of men and women; and periodically prohibited carnival and "), _c('i', [_vm._v("Fastnacht")]), _vm._v(" celebrations. The same logic appears in an edict issued by the English Parliament in 1642:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Whereas the distressed state of Ireland, steeped in her own blood, and the distracted state of England, threatened with a cloud of blood by a civil war, call for all possible means to appease and avert the wrath of God … [and whereas] public sports do not well agree with public calamities, nor public stage-plays with the seasons of humiliation … being spectacles of pleasure, too commonly expressing lascivious mirth and levity … all public stage plays shall cease.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Parliament would later ban Maypoles and prohibit the celebration of Christmas, and in 1648 it ‘authorized and required’ the magistrates of London ‘to pull down and demolish’ all theatres, to have all actors publicly whipped, and to fine all playgoers, because plays tended ‘to the high provocation of God's wrath and displeasure, which lies heavy upon this Kingdom’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-23",
      "id": "nr1-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The search for scapegoats targeted individuals as well as activities. In Europe, the climatic and economic disasters of the mid-seventeenth century fed a ‘witchcraze’ in which thousands of people were tried and executed because their neighbours blamed them for causing their misfortunes. Most of the victims were women, many of them unable to support themselves unaided; many lived in marginal areas for crop cultivation – in Lorraine, the Rhine and Main valleys for vines; in Scotland and Scandinavia for cereals – where the impact of global cooling was felt first and worst. Thus in southern Germany, a hailstorm in May 1626 followed by Arctic temperatures led to the arrest, torture and execution of 900 men and women suspected of producing the calamity through witchcraft. Two decades later, the Scottish Parliament likewise blamed a winter of heavy snow and rain followed by a cereal "), _c('a', {
    attrs: {
      "id": "p10"
    }
  }, [_vm._v("harvest of ‘small bulke’ on ‘the sin of witchcraft [which] daily increases in this land'; and, to avert more divine displeasure, it authorized more executions for sorcery than at any other time in the country's history. A ‘witch panic’ also gripped the Hurons of North America between 1635 and 1645, although most of the accused were men; while in China, too, ‘To anyone oppressed by tyrannical kinsmen or grasping creditors’, a witchcraft accusation ‘offered relief. To anyone who feared prosecution, it offered a shield. To anyone who needed quick cash, it offered rewards. To the envious it offered redress; to the bully, power; and to the sadist, pleasure.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-24",
      "id": "nr1-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The popularity of stage plays, sodomy and sorcery as explanations for catastrophe in the seventeenth century paled in comparison with five ‘natural’ scapegoats: stars, eclipses, earthquakes, comets and sunspots. In Germany, a Swedish diplomat wondered in 1648 whether the spate of contemporaneous rebellions might ‘be explained by some general configuration of the stars in the sky'; while, according to a chronicler in Spain, only ‘the malign influence of the stars’ could explain the coincidence that ‘in a single year [1647–8] in Naples, Sicily, the Papal States, England and France’, such ‘atrocities and extraordinary events’ had occurred. A few years later, the Italian historian Majolino Bisaccione likewise argued that only ‘the influence of the stars’ could have created so much ‘wrath among the people against the governments’ of his day."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-25",
      "id": "nr1-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Others blamed eclipses. The author of a Spanish almanac felt complete confidence that a recent eclipse of the sun had produced ‘great upsets in war, political upheavals and damage to ordinary people’ between March 1640 and March 1642 (as well as future catastrophes meticulously charted down to the year 2400). A similar English compilation predicted that the two lunar eclipses and unusual planetary conjunction forecast for 1642 would bring ‘many strange accidents’, namely ‘sharp tertian fevers, war, famine, pestilence, house-burnings, rapes, depopulations, manslaughters, secret seditions, banishments, imprisonments, violent and unexpected deaths, robberies, thefts and piratical invasions’. An otherwise hard-headed chronicler writing two years after the Naples revolution of 1647 blamed it all on a recent solar eclipse; while in Iran, another solar eclipse in 1654 led some ‘Persian wise men’ to assert that it meant ‘that the King had died; others said that there would be a war and blood would be shed; still others said wholesale deaths would occur.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-26",
      "id": "nr1-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" In India, even the Mughal emperors took special precautions during eclipses, staying indoors and eating and drinking little; while in "), _c('i', [_vm._v("Paradise Lost")]), _vm._v(", composed between 1658 and 1663, John Milton noted the popular panic whenever the sun")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("… from behind the Moon")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("In dim Eclips disastrous twilight sheds")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("On half the Nations; and with fear of change")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Perplexes Monarchs."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-27",
      "id": "nr1-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many seventeenth-century people also speculated that earthquakes and comets presaged catastrophe – perhaps because the frequency of both increased notably. Thus an account of the destruction wrought by an earthquake, volcano and tsunami "), _c('a', {
    attrs: {
      "id": "p11"
    }
  }, [_vm._v("in the Azores in 1638 concluded: ‘Let the speculative ponder, and the philosopher search out the cause of so portentous an effect.’ A few years later a Dutch pamphleteer assured his readers that the")])]), _c('a', {
    attrs: {
      "id": "p11"
    }
  }), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p11"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p11"
    }
  }, [_vm._v("Earthquake not long since felt in the year 1640, was a token of great commotions, and mighty shakings of the kingdomes of the earth, for a little before and shortly thereupon was concluded the revolt of Cathalonia, the falling-off of Portugal, the stirres in Scotland, the rebellion of the Irish, [and] those civill (uncivill) warres, great alterations, [and] unexpected tumults in England."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-28",
      "id": "nr1-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Likewise, when severe tremors shook the buildings of Istanbul in 1648, the Ottoman minister and intellectual Kâtib Çelebi solemnly noted that ‘when an earthquake happens during daytime in June, blood is shed in the heart of the empire’: he was therefore not surprised by the murder of Sultan Ibrahim two months later. Records from Romania mention over 40 earthquakes between 1600 and 1690; while according to the "), _c('i', [_vm._v("Earthquake Catalogue")]), _vm._v(", a peak of activity occurred in the mid-seventeenth century, especially in the ‘ring of fire’ around the Pacific Ocean, where more than two-thirds of the world's major earthquakes normally occur. Contemporaries saw each eruption as a harbinger of disaster."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-29",
      "id": "nr1-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The mid-seventeenth century witnessed not only a peak of seismic activity but also a rare ‘fireball flux’. The English astronomer John Bainbridge was apparently the first to comment, in 1619, on the ‘many new stars and comets, which have been more [numerous] this last century of the world than in many ages before’. He wrote just after the appearance of three comets in 1618, which excited widespread anxiety. Even before they appeared, Johannes Kepler, the foremost mathematician of his day, warned in his "), _c('i', [_vm._v("Astrological Almanac")]), _vm._v(" for 1618 that the conjunction of five planets in May would cause extreme climatic events; and if a comet appeared as well everyone should ‘sharpen their pens’, because it would presage a major political upheaval. Over the winter of 1618–19, a multitude of books and pamphlets in Europe reminded readers that comets ‘signify wars’ and brought in their wake ‘discord, irritations, deaths, upheavals, robberies, rape, tyranny and the change of kingdoms’, and they predicted dire consequences for humanity following the three ‘blazing stars’ of 1618."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-30",
      "id": "nr1-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Some observers were more precise: a Spanish friar argued that the comets would prove especially dangerous for the Habsburg dynasty ‘because they have touched us to the quick with the deaths of the empress, the Archduke Maximilian, and most recently the emperor [Matthias] … May God preserve those members of the House of Austria who are left!‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-31",
      "id": "nr1-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Astronomers in Ming China also interpreted the three comets of 1618 as a portent of major upheavals, while the chronicles of their northern neighbours in Manchuria contain ‘an overwhelming number of reports of such heavenly signs’. In Russia, the same comets provoked discussion and doleful interpretations among ‘wise men'; in India, a Mughal chronicler claimed that ‘no household remained unaffected’ by fear, and blamed the comets for both an epidemic of plague and the subsequent rebellion of the crown prince; while in Istanbul, writers blamed them not only for the extreme weather (especially the freezing of the Bosporus) but also "), _c('a', {
    attrs: {
      "id": "p12"
    }
  }, [_vm._v("for the deposition of one sultan in 1618, the murder of another in 1622, and the provincial revolts that followed."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-32",
      "id": "nr1-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Belief in the baleful effects of the comets of 1618 proved remarkably enduring. In 1643 a Dutch pamphleteer claimed that the")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Star with a tail, seen in the year 1618, was a warning and type of a rod that should come over all Christendome, whereupon followed those bloody effects, those horrible warrs, lamentable wastings, barbarous destruction of countreys and cities, the ruine of so many costly buildings, of so many gentlemen, so many inhabitants, men and women, young and old, in Germanie.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In 1649 a London newspaper considered that the end of the Thirty Years War the previous year was ‘foretold by the Blazing Star which, in the year the war began, appeared over Europe for thirty days and no more’. A generation later in Boston, Massachusetts, the Reverend Increase Mather devoted three pages of his "), _c('i', [_vm._v("Kometographia, or a discourse concerning comets")]), _vm._v(" to the ‘prodigy’ of 1618 which, he claimed, had ‘caused’ not only a major drought throughout Europe, an earthquake in Italy, a plague in Egypt and ‘the Bohemian and Germanic war, in which rivers of blood were poured forth’, but also ‘a plague amongst the Indians here in New England which swept them away in such numbers, as that the living were not enough to bury the dead’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-33",
      "id": "nr1-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Some contemporaries blamed the catastrophes that afflicted them on a combination of these natural phenomena. A popular Chinese encyclopaedia argued that ‘when Venus has dominated Heaven, wars have arisen on a great scale, and that when comets have dominated Heaven, there have been conflicts over the succession to the throne'; while the Spanish almanac of 1640 already quoted reminded readers that ‘whenever eclipses, comets and earthquakes and other similar prodigies have occurred, great miseries have usually followed’. In 1638 Robert Burton's "), _c('i', [_vm._v("Anatomy of Melancholy")]), _vm._v(" provided the most comprehensive ‘catastrophe catalogue’ of all. He felt sure that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The heavens threaten us with their comets, starres, planets, with their great conjunctions, eclipses, oppositions, quartiles, and such unfriendly aspects. The air with his meteors, thunder and lightning, intemperate heat and cold, mighty windes, tempests, unseasonable weather; from which proceed dearth, famine, plague, and all sorts of epidemicall diseases, consuming infinite myriads of men."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-34",
      "id": "nr1-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Others doubted such precise links. One Italian historian expressly ridiculed the idea that ‘certain celestial constellations have the power to move the spirits of the inhabitants of a country to sedition, tumults and revolutions’ in many different places at once; while the comets of 1618 provoked animated debates between astronomers and astrologers over whether or not they were capable of causing ‘catastrophes’. Such uncertainty prompted a handful of observers to suggest an alternative natural scapegoat for the extreme weather of the seventeenth century: fluctuations in the number of sunspots – those dark regions of intense magnetic activity on the solar surface surrounded by ‘flares’ that make the sun shine with greater "), _c('a', {
    attrs: {
      "id": "p13"
    }
  }, [_vm._v("intensity. Even though they incorrectly argued that "), _c('i', [_vm._v("more")]), _vm._v(" sunspots would produce cooler temperatures on earth (whereas the reverse is true), unlike comet and star-gazers, the early solar astronomers had stumbled on an important cause of climate change in the seventeenth century."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-35",
      "id": "nr1-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The development of telescopes as astronomical instruments after 1609 enabled observers to track the number of sunspots with unprecedented accuracy. They noted a ‘maximum’ between 1612 and 1614, followed by a ‘minimum’ with virtually no spots in 1617 and 1618, and markedly weaker maxima in 1625–6 and 1637–9. And then, although astronomers around the world made observations on over 8,000 days between 1645 and 1715, they saw virtually no sunspots: the grand total of sunspots observed in those 70 years scarcely reached 100, fewer than currently appear in a single year. This striking evidence of absence suggests a reduction in solar energy received on earth."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-36",
      "id": "nr1-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Four other sets of data confirm this hypothesis. First, trees (like other plants) absorb carbon-14 from the atmosphere, and the amount rises as solar energy received on earth declines; and many tree-rings laid down in the seventeenth century contain increased carbon-14 deposits, which suggests reduced global temperatures. Second, between October 1642 and October 1644, Johannes Hevelius of Danzig made daily drawings of the sun that recorded the precise location of all spots, and he later printed his findings in a series of 26 ‘composite disks’ that showed not only the number but also the movement of the spots over a few days (Plate 1). Hevelius's ‘disks’ reveal that sunspots were already rare: he seldom saw more than one or two groups at a time. Third, the aurora borealis (the ‘northern lights’ caused when highly charged electrons from the magnetosphere interact with elements in the earth's atmosphere) became so rare that when the astronomer Edmond Halley saw an aurora in 1716 he wrote a learned paper describing the phenomenon – because it was the first he had seen in almost fifty years of observation."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-37",
      "id": "nr1-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Finally, neither Halley nor other astronomers between the 1640s and the 1700s mentioned the brilliant corona nowadays visible during a total solar eclipse: instead they reported only a pale ring of dull light, reddish and narrow, around the moon. All four phenomena confirm that the energy of the sun diminished between the 1640s and the 1710s, a condition normally associated with both reduced surface temperatures and extreme climatic events on earth."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-38",
      "id": "nr1-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A further astronomical aberration also troubled seventeenth-century observers living in the northern hemisphere: the appearance of ‘dust veils’ in the sky that made the sun seem either paler or redder than usual. Thus a Seville shopkeeper lamented that during the first six months of 1649 ‘the sun did not shine once … and if it came out it was pale and yellow, or else much too red, which caused great fear’. Thousands of miles to the east, Korea's royal astronomers reported darkened skies during the daytime on 38 occasions during the seventeenth century. On some days they recorded that ‘the skies all around are darkened and grey as if some kind of dust had fallen’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-39",
      "id": "nr1-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Both the dust and the reddened skies stemmed from an unusual spate of major volcanic eruptions in the mid-seventeenth century. Each hurled sulphur dioxide into the stratosphere where it deflected some of the sun's radiation back into "), _c('a', {
    attrs: {
      "id": "p14"
    }
  }, [_vm._v("space and, thus, significantly reduced temperatures in all areas of the earth beneath the dust clouds.")])]), _c('a', {
    attrs: {
      "id": "p14"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p14"
    }
  }, [_vm._v("Vivid descriptions have survived for two of these volcanic eruptions. In February 1640, in Chile, Mount Villarica ‘began to erupt with such force that it expelled burning rocks … So much burning ash fell into the river Alipen that the waters burned in such a way that it cooked all the fish there.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-40",
      "id": "nr1-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" Less than a year later, on the other side of the Pacific, a Spanish garrison in the southern Philippines saw one day at noon ‘a great darkness approaching from the south which gradually extended over that entire hemisphere and blocked out the whole horizon. By 1 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("PM")]), _vm._v(" they were already in total night and at 2 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("PM")]), _vm._v(" they were in such profound darkness that they could not see their own hands before their eyes.’ Ash fell on them for 12 hours until, early the following morning, ‘they began to see the moon’. They had just witnessed a ‘force six’ eruption, an event so terrifying that the authorities in Manila mounted an inquiry in which ‘various priests and other trustworthy people’ testified that the eruption was heard at exactly the same time ‘throughout the Philippines and the Moluccas, and as far as the Asian mainland, in the kingdoms of Cochin-China, Champa and Cambodia – a radius of 900 miles, a wondrous thing which seems to exceed the bounds of the natural world’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-41",
      "id": "nr1-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" The dust veils produced by the 12 known volcanic eruptions around the Pacific between 1638 and 1644 (apparently an all-time record) combined with the sunspot minimum both to cool the earth's atmosphere and to destabilize its climate ("), _c('a', {
    attrs: {
      "href": "#/#fig_02"
    }
  }, [_vm._v("Fig. 2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Blame it on El Niño?")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The global cooling caused by reduced sunspot and increased volcanic activity seems to have triggered a dramatic change in the climatic phenomena known as El Niño. In normal years, the surface air pressure in the equatorial region of the Pacific is higher in the east than in the west, which means that easterly winds blowing from America to Australia and South East Asia prevail. In cooler years, however, surface air pressure in the equatorial region of the Pacific falls in the east and rises in the west, so the pattern reverses: westerly winds blowing from Asia to America prevail. El Niño episodes dramatically affect the world's climate. As the air above the equatorial Pacific warms each spring it creates massive rain clouds: in a normal year, these fall on Asia as the ‘monsoon’, which nurtures the harvest, but in an El Niño year the monsoon weakens and heavy rains fall instead on America, causing catastrophic floods. Today this reversal – also known as ENSO (El Niño-Southern Oscillation) – happens about once every five years, but in the mid-seventeenth century it happened twice as often: in 1638, 1639, 1641, 1642, 1646, 1648, 1650, 1651, 1652, 1659, 1660 and 1661. This same period saw some of the weakest East Asian monsoons of the past two millennia."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-42",
      "id": "nr1-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Admittedly historians cannot ‘blame El Niño’ for everything. Some regional climates are El Niño sensitive; others, even though contiguous, are not. Thus, in southern Africa, the eastern Cape is susceptible to El Niño-related droughts whereas the western Cape is not; likewise, droughts in northeast Brazil appear to occur in El Niño years but those in western Mexico do not. The ‘global footprint’ of El Niño normally includes three regions besides the lands adjoining the Pacific: the Caribbean suffers floods; Ethiopia and northwest India experience droughts; and Europe suffers hard winters. In most of the 20 El Niño episodes recorded between 1618 and 1669, and in all 12 between 1638 and 1661, each of these regions experienced adverse weather.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p15"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p15"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_02"
    }
  }, [_vm._v("2. Sunspot cycles, volcanic anomalies, and summer temperature variations in the seventeenth century."), _c('br'), _vm._v("The number of sunspots observed and recorded by European astronomers ("), _c('i', [_vm._v("top")]), _vm._v(") shows the Maunder Minimum (1643–1715), in which fewer sunspots appeared in seventy years than appear in a single year now. Measurements of volcanic deposits in the polar icecap (the ‘Ice-Volcanic Index’) reveal a peak in the 1640s. Both phenomena show a striking correlation with lower summer temperatures in the northern hemisphere.")])]), _c('a', {
    attrs: {
      "id": "fig_02"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_02"
    }
  }), _c('a', {
    attrs: {
      "id": "p16"
    }
  }, [_vm._v("The changed weather conditions in the Pacific Ocean during this period emerge starkly from two anomalies recorded in historical sources. On the one hand, the coastal province of Guangdong in southern China suffered more typhoon landfalls between 1660 and 1680 than at any other time in recorded history."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-43",
      "id": "nr1-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" On the other hand, the voyages of galleons sailing from Acapulco in Mexico to Manila in the Philippines took longer than in any other period. In the first and last decades of the seventeenth century the crossing took an average of 80 days (a few took only 50 days), but between 1640 and 1670 the average duration rose to over 120 days (and three took over 160). Some ships never arrived: of the 11 galleons known to have sunk or run aground before reaching Manila during the seventeenth century, nine did so between 1639 and 1671. The return voyage from Manila to Acapulco also took much longer: the average duration rose from 160 to well over 200 days, and the longest voyages ever recorded (240 days, or eight months) took place in the 1660s. Nothing except a major shift in wind pattern could explain such a dramatic change. Diego de Villatoro, a crown official who had made the voyage twice, saw the connection clearly. In a memorial written in 1676 he noted sadly that ‘now we consider a voyage from the Philippines to Acapulco that takes less than seven months to be good’, and he perceptively ascribed the longer duration ‘to a change in the monsoons’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-44",
      "id": "nr1-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Villatoro, of course, lacked the expertise either to blame this change on the increased frequency of El Niño activity or to associate El Niño with reduced solar activity, weaker Asian monsoons and increased volcanic activity. But we now know that in ‘normal’ years, when easterly winds prevail, the Pacific stands some 24 inches higher off the Asian than off the American coast, whereas in El Niño years, when westerly winds prevail, those levels reverse. The movement of such a huge volume of water places enormous pressure on the edges of the earth's tectonic plates around the Pacific periphery, where the most violent and most active volcanoes in the world are located, and this may trigger a spate of eruptions."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-45",
      "id": "nr1-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" If this hypothesis is true, it creates a deadly cycle:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• Reduced solar energy received on earth lowers temperatures, which increases the risk of more, and more severe, El Niño events.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• El Niño events may trigger volcanic eruptions around the Pacific that throw sulphur dioxide into the stratosphere, which further reduces the solar energy received on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• El Niño activity becomes twice as likely after a major volcanic eruption.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Whatever the exact connections between these natural phenomena (and not all scientists agree), the mid-seventeenth century certainly experienced both an unusual spate of earthquakes, fireball fluxes, volcanic eruptions and El Niño "), _c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("episodes, and a drastic reduction in sunspot activity, the weakest monsoons and some of the lowest global temperatures recorded in the past few centuries.")])]), _c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_c('p', {
    staticClass: "ahd"
  }, [_vm._v("Climate and Crops")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("So what? To a sceptic, ‘global cooling’ that amounts to a fall of only one or two degrees Celsius in mean summer temperatures, and a modest glacier advance, may seem insignificant; but that is to think in linear terms. On the one hand, the mean global temperature has shown remarkable stability over the last six millennia: the difference at the equator between the ‘Medieval Optimum’ (the hottest temperatures recorded until the late twentieth century) and the Little Ice Age was probably less than 3°C. A change of even one degree is thus highly significant. On the other hand, in the northern hemisphere, home to the majority of humankind and site of most of the wars and revolutions of the seventeenth century, solar cooling reduces temperatures far more than at the equator, in part because increased snow cover and sea-ice reflect more of the sun's rays back into space. The extension of the polar icecaps and glaciers in the mid-seventeenth century would thus have reduced mean temperatures in northerly latitudes dramatically.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A recent ‘model’ of the probable global climate in the later seventeenth century shows significantly colder weather in Siberia, North Africa, North America and northwest India; colder and drier weather in central China and Mongolia; and cooler and less stable conditions in the Iberian Peninsula, France, the British Isles and Germany. As already noted, these same areas – the Russian and Ottoman empires in Eurasia; the Ming and Qing states in East Asia; and the dominions of Philip IV, Charles I, Louis XIV and Ferdinand II in Europe – reported not only cooler weather in the 1640s and 1650s but also a significant number of extreme weather events and serious political upheavals. The former should cause no surprise: an overall decline in mean temperatures is normally associated with a greater frequency of severe weather events – such as flash floods, freak storms, prolonged droughts and abnormal (as well as abnormally long) cold spells. All of these climatic anomalies can critically affect the crops that feed the people.")])]), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("In the ‘temperate zone’, which stretches roughly from 30 to 50 degrees of latitude, crop yields suffer disproportionately from a cold spell during germination, a drought in the early growing season and a major storm just before harvest. To take a single example, a Gazetteer from Zhejiang in eastern China reported that ‘When on the 13th day of the 5th moon in 1640 the fields were inundated, those who had planted out on the 12th or earlier had no disaster once the flood had subsided, but those who planted on or after the 13th’ lost everything."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-46",
      "id": "nr1-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" An unseasonable frost could prove equally disastrous. In areas of wet rice cultivation, a fall of 0.5°C in the average spring temperature prolongs the risk of the "), _c('i', [_vm._v("last")]), _vm._v(" frost by 10 days, while a similar fall in the average autumn temperature advances the risk of the "), _c('i', [_vm._v("first")]), _vm._v(" frost by the same amount. Either event suffices to kill the entire crop. Even without frosts, a fall of 2°C during the growing season – precisely the scale of global cooling in the 1640s – reduces rice harvest yields by between 30 and 50 per cent, and also lowers "), _c('a', {
    attrs: {
      "id": "p18"
    }
  }, [_vm._v("the altitude suitable for wet-rice cultivation by about 1,300 feet. Likewise, in cereal-growing regions, a fall of 2°C shortens the growing season by three weeks or more, diminishes crop yields by up to 15 per cent, and lowers the maximum altitude at which crops will ripen by about 300 feet. Drought, too, destroys harvests by depriving crops of the precipitation they required. As a Chinese manual of agriculture, published in 1637, warned: ‘All rice plants die if water is lacking for ten [consecutive] days.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-47",
      "id": "nr1-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Extreme weather could also destroy crops indirectly. Excessive rain might allow rodents to multiply. In Moldavia in 1670 ‘myriads of mice’ not only ate ‘all they found in the vegetable gardens’ but also, ‘climbing up the trees, ate all the fruit, finishing them up; and to end the job’ they ‘finished the wheat in the field’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-48",
      "id": "nr1-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Drought favoured locusts. In 1647 the Moldavian nobleman Miron Costin reported that ‘about the time of the year when people pick up their sickles to harvest the wheat’, he and some companions were on the road and ‘suddenly noticed a cloud towards the south’:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("We thought it was a rainstorm until we were suddenly hit by the locust swarm, coming at us like a flying army. The sun disappeared immediately, veiled by the blackness of these insects. Some of them flew high, at three or four metres, while others flew at our level, or even right above the ground … They flew around us without fearing anything … It took an hour for a swarm to pass, and then after an hour and a half there came another, and then another, and so on. It lasted from noon till dusk. No leaf, no blade of grass, no hay, no crop, nothing remained."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-49",
      "id": "nr1-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In latitudes north of the ‘temperate zone’, where the growing season is shorter, the impact of climate change on crop cultivation increases. First, it radically reduces yields. In Manchuria, with a total of only 150 frost-free days in even ‘good’ years, a fall of 2°C in mean summer temperature reduces harvest yields by a stunning 80 per cent. In Finland, the growing season even in ‘normal’ years is the shortest compatible with an adequate harvest so that even a single summer night's frost can kill an entire crop. Seventeenth-century Finland saw 11 crop failures (compared with only one in the eighteenth century)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-50",
      "id": "nr1-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Second, global cooling increases the frequency of harvest failure in northerly latitudes.")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• In the ‘temperate zone’, if early winters or summer droughts occur with a frequency of P = 0.1, the harvest will fail once every 10 years, and two consecutive harvests will fail once every 100 years. If, however, early winters or summer droughts occur with a frequency of P = 0.2, the harvest will fail once every 5 years (double the risk) while two consecutive harvests will fail every 25 years (quadruple the risk).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• In latitudes north of the ‘temperate zone’, each fall of 0.5°C in mean summer temperatures decreases the number of days on which crops ripen by 10 per cent, doubles the risk of a single harvest failure, and increases the risk of a double failure six-fold.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• For those farming 1,000 feet or more above sea level, a fall of 0.5°C in mean summer temperatures increases the chance of two consecutive failures 100-fold.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("Climate and Calories")])]), _c('a', {
    attrs: {
      "id": "p19"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("In densely populated parts of the early modern world, whether sub-boreal, temperate or tropical, most people relied on a single crop, high in bulk and in carbohydrates, known as a ‘staple’. Cereals (wheat, rye, barley and oats) formed the principal staple in Europe, northern India and northern China. Rice occupied the same role in Monsoon Asia, maize in the Americas, and millet in upland India and Sub-Saharan Africa. The economic allure of staple crops is almost irresistible to farmers. An acre under cereals feeds between ten and twenty times as many people as an acre devoted to animal husbandry; furthermore, the same amount of money usually bought 10 pounds of bread but only 1 pound of meat. An acre planted with wet-rice yields up to 6 tons of food – three times as much as an acre of wheat or maize and sixty times as much as an acre devoted to animal husbandry. Not surprisingly, therefore, according to a Chinese textbook printed in 1637, ‘70 per cent of the people's staple food is rice’, while in Europe, cereals likewise provided up to three-quarters of the total calorie intake of every family (not only in the form of bread but also as a ‘filler’ for soups and as the basic ingredient for beer and ale)."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-51",
      "id": "nr1-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Steven Kaplan has rightly insisted on the ‘tyranny’ of popular dependence on staple crops – cereals, rice, maize or millet, depending on the region – in the pre-industrial world. In Europe,")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Cereal-dependence conditioned every phase of social life. Grain was the pilot sector of the economy; beyond its determinant role in agriculture, directly and indirectly grain shaped the development of commerce and industry, regulated employment, and provided a major source of revenue for the state, the church, the nobility, and large segments of the Third Estate … Because most of the people were poor, the quest for subsistence preoccupied them relentlessly. No issue was more urgent, more pervasively felt, and more difficult to resolve than the matter of grain provisioning. The dread of shortage and hunger haunted this society."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-52",
      "id": "nr1-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("‘Shortage and hunger’ could arise in three distinct ways. First, throughout the early modern world, food accounted for up to half the total expenditure of most families, and so any increase in staple prices caused hardship because most families had little spare cash and soon faced the risk that they could not feed themselves. Second, spending more on food left little or nothing with which to purchase other goods, leading to a fall in demand: this meant that many non-agricultural workers lost their jobs and reduced the wages received by the rest – that is, their income fell just as their expenditure rose. Third, since the impact of harvest failure on the price of cereals is non-linear, any shortfall in the harvest reduced the food supply geometrically and not arithmetically. Suppose that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• In a normal year a European farmer sowed 50 acres with grain and harvested 10 bushels an acre, a total of 500 bushels. Of this, he needed 175 bushels for animal fodder and seed corn and 75 bushels to feed himself and his family – a total of 250 bushels – leaving 250 for the market.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("• If bad weather reduced his crop by 30 per cent, the harvest would produce only 350 bushels yet the farmer still needed 250 of them for his immediate use. The share available for the market therefore dropped to 100 bushels – a fall of 60 per cent.")])]), _c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• But if bad weather reduced crops by 50 per cent, the harvest would produce only 250 bushels, all of them needed by the farmer, leaving virtually nothing for the market.")])])]), _c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_c('p', {
    staticClass: "ftxt"
  }, [_vm._v("This non-linear correlation explains why a 30 per cent reduction in the grain harvest often "), _c('i', [_vm._v("doubled")]), _vm._v(" the price of bread, whereas a 50 per cent reduction "), _c('i', [_vm._v("quintupled")]), _vm._v(" it. It also explains why, if the harvest failed for two or more consecutive years, starvation almost always followed.")])]), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("Steven Kaplan concluded his study of famines in eighteenth-century France by suggesting that this cruel calculus ‘produced a chronic sense of insecurity that caused contemporaries to view their world in terms that may strike us as grotesquely or lugubriously overdrawn’. However, a study by Alex de Waal of the Darfur famine of 1984–5 in East Africa rejected the notion of ‘overdrawn’ where harvest shortfalls are concerned because, even today, failures can ‘cross a threshold of awfulness and become an order of magnitude worse’. Not only do large numbers of people die, so does their entire way of life."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-53",
      "id": "nr1-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" De Waal identified three characteristics of these ‘landmark famines’:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• First, they force those affected to use up their assets, including investments, stores and goods. Although a family might choose to go hungry for a season in order to preserve its ability to function as a productive unit (for example by keeping back grain to feed its livestock or to use as seed corn instead of eating it all), it can rarely maintain that strategy for a second, let alone a third year. Two or three successive harvest failures therefore leave victims permanently destitute.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• Second, prolonged starvation also forces those affected to use up their social claims (‘entitlements’). A hungry family may refrain from begging for assistance from other individuals and institutions for a short period, but once again it can rarely maintain that strategy for long. If a large number of families suddenly becomes destitute, it may cripple and even destroy the communities in which they live.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• Third, as communities cease to be viable, some families migrate. Initially, migration may form a reasonable ‘coping strategy’ in a famine because, although the migrants necessarily abandon both their assets and their ‘entitlements’ by leaving their local community, those who survive can return to their homes and their previous way of life when conditions improve. Prolonged dearth, however, will sever the links with the world they have left and thus, according to De Waal, lead to the ‘mortality’ of their entire way of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Calories and Death")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Each day, every human needs to consume at least 1,500 calories to maintain her or his basic metabolic functions and to resist infection. Pregnant women and those who earn their living by physical labour require at least 2,500 calories. Few people "), _c('a', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("in the early modern period were so lucky: during the Italian plague of 1630–1, hospital records show that each patient received a daily ration of half a kilo of bread, a quarter of a kilo of meat (probably in a stew), and half a litre of wine – a daily intake of scarcely 1,500 calories (and one seriously deficient in vitamins). Even in the ‘normal’ years of the seventeenth century, the average Frenchman consumed barely 500 calories more than his basic metabolic requirement, and the average Englishman barely 700 calories more."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-54",
      "id": "nr1-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Two short-term ‘safety mechanisms’ help humans to adjust to malnutrition. We may cut back on energy demands (working more slowly, resting longer); and, as body weight declines, we can get by with fewer calories to sustain the basic metabolism (and the reduced physical activity). Nevertheless, in the long term, even a small reduction in our daily calorific intake can have dramatic consequences. A decrease of one-fifth, from 2,500 to 2,000 calories, "), _c('i', [_vm._v("halves")]), _vm._v(" our ability to work efficiently because the body's basic metabolism still requires 1,500 calories. In the case of a pregnant woman, a similar reduction imperils the health of both mother and child. Furthermore, a weight loss of 10 per cent reduces energy by about one-sixth, but a weight loss of 20 per cent reduces energy by about one-half, and if a woman or man loses 30 per cent of their normal body weight, blood pressure falls and the ability to absorb nutrients fails.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In this weakened condition, any additional stress on the body, such as disease, usually proves fatal – and, amid the social disruption normally associated with famine, infectious diseases often spread rapidly – while cold and damp further weaken those who are starving. According to a report on an Indian famine in the nineteenth century: ‘The most common termination of life in those debilitated by famine was diarrhoea or dysentery, aggravated by damp and exposure … Cold and damp had a most detrimental effect upon the starving poor, and those in a physically reduced condition from chronic insufficiency of food.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-55",
      "id": "nr1-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Observers in the seventeenth century described the same fatal decline. According to Yang Dongming, a government official and philanthropist in central China:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("All beings are physically the same, alike in their intolerance of cold. Those people with old, tattered clothes … go nearly naked in the dead of winter, their hair dishevelled and feet bare and their teeth chattering; crying out and terrified … Being solitary, they have no place to go … [and] falling snow covers their bodies. At this point, their organs freeze and their bodies stiffen like pieces of wood. At first they are still able to groan. Gradually they cough up phlegm. Then, their lives are extinguished.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Five thousand miles to the west, Sir Robert Sibbald, a Scottish physician and geographer, lamented that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The bad seasons these several years past hath made so much scarcity and so great a dearth, that for want, some die by the way-side, some drop down on the streets, the poor sucking babes are starving for want of milk, which the empty breasts of their mothers cannot furnish them. Every one may see death in the face of the poor "), _c('a', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("that abound everywhere: the thinness of their visage, their ghostly looks, their feebleness, their agues and their fluxes threaten them with sudden death, if care be not taken of them. And it is not only common wandering beggars that are in this case, but many house-keepers who lived well by their labour and industrie are now by want forced to abandon their dwellings and they and their little ones must beg."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-56",
      "id": "nr1-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Famines afflicted ‘little ones’ with especial severity. Starvation killed many infants because their mothers had no milk to feed them; but, famished children, especially when they are also cold and exposed to disease, suffer ‘stunting’. Because simply staying alive and keeping warm absorbs so many calories, and a famine diet usually lacks adequate protein and vitamins, the long bones in the legs and arms of children cease to grow. Human remains from the Little Ice Age show unmistakable evidence of such ‘stunting’. When archaeologists excavated the skeletons of 50 workers buried in the permafrost at Smeerenburg (‘Blubber Town’), a whaling station maintained by the Dutch on Spitsbergen Island in the Arctic between 1615 and 1670 (when the intolerable cold forced them to withdraw), no fewer than 43 showed evidence of stunting and a corresponding reduction in height."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-57",
      "id": "nr1-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Even more striking, French soldiers born in the second half of the seventeenth century were on average about an inch shorter than those born after 1700; and those born in famine years were notably shorter than the rest. Thus ‘stunting’ reduced the average height of those born in 1675, the ‘year without a summer’, or during the years of cold and famine in the early 1690s, to only 63 inches: the lowest ever recorded. Once warmer weather and better harvests returned in the eighteenth century, the average height of Frenchmen increased by almost 1.5 inches – an unparalleled surge – and the ‘bantam soldiers’ never reappeared ("), _c('a', {
    attrs: {
      "href": "#/#fig_03"
    }
  }, [_vm._v("Fig. 3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("‘Stunting’ does not only adversely affect the long bones of children: because malnutrition often impairs the development of major organs as well as long bones, it makes children more vulnerable to both contagious and chronic diseases, which can in turn further diminish stature. Children living in the countryside might experience a catch-up growth spurt, which partially compensates for stunting, but those living in overcrowded and insanitary towns often stayed short (which probably explains why recruits for the French Army from Paris were always shorter than the rest). John Komlos, the demographer whose research revealed the reduced height of Louis XIV's soldiers, was surely correct that the seventeenth-century crisis ‘had an immense impact on the human organism itself’. His data provide perhaps the clearest – and saddest – evidence of the consequences of the Little Ice Age for the human population. The repeated famines not only killed: many of those who survived literally embodied Thomas Hobbes's assertion that ‘the life of man’ had indeed become ‘solitary, poor, nasty, brutish and short’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-58",
      "id": "nr1-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("An Overpopulated World?")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Although Hobbes and his contemporaries apparently stood somewhat shorter than their grandparents, they were far more numerous. A run of warm summers in the "), _c('a', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("sixteenth century had allowed the human population in most parts of Europe and Asia to increase and in some areas to double – until by 1618 China boasted perhaps 150 million inhabitants, India 116 million and Europe 100 million. In some areas, the number of inhabitants had increased so fast that local resources no longer sufficed to feed them because of another cruel calculus: "), _c('i', [_vm._v("population increases geometrically while agricultural output grows only arithmetically")]), _vm._v(". Just like ‘compound interest’, a sustained demographic increase of 1 per cent per year over a century causes a population not merely to double, but to triple; while a 2 per cent increase over a century produces a sevenfold growth. Since crop yields rarely increase at this pace, food shortages can occur very rapidly.")])]), _c('a', {
    attrs: {
      "id": "p23"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_03.jpg"
    }
  })])]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p23"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_03"
    }
  }, [_vm._v("3. Estimated heights of French males born between 1650 and 1770."), _c('br'), _vm._v("John Komlos assembled 38,700 ‘observations’ from the personal records of French males who enlisted in the army between 1671 and 1786. Even though recruiting officers rejected the shortest volunteers, the ‘stunting’ effect of global cooling is evident, especially for those born in 1675, ‘the year without a summer’ (one of two experienced in the seventeenth century). The average height of Louis XIV's soldiers was 1,617 mm, or 5 foot 3 inches.")])]), _c('a', {
    attrs: {
      "id": "fig_03"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_03"
    }
  }, [_vm._v("Many people in the early seventeenth century realized that their part of the world possessed more mouths than could be fed, and feared the consequences. China's Lower Yangzi valley, known as Jiangnan, boasted a population of about 20 million by 1618, equivalent to almost 1,200 persons per square mile (by way of comparison, the overall population density of the modern Netherlands, the most densely settled part of Europe today, is 1,000 persons per square mile). According to Alvaro Semedo, a Portuguese Jesuit long resident in the region who wrote in the 1630s, Jiangnan ‘is so full of all sorts of people that not only the villages but even the cities ")]), _c('a', {
    attrs: {
      "id": "p24"
    }
  }, [_vm._v("can now be seen one from another’ and, in some areas, ‘settlement is almost continuous’. Indeed, he mused,")])]), _c('a', {
    attrs: {
      "id": "p24"
    }
  }, [_c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("This kingdom is so overpopulated ["), _c('i', [_vm._v("eccessivamente popolato")]), _vm._v("] that after living there for twenty-two years, I remain almost as amazed at the end as I was at the beginning by the multitude of people. Certainly the truth is above any exaggeration: not only in the cities, towns and public places … but also on the roads there are normally as many people as would turn out in Europe [only] for some holiday or public festival.")])])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p24"
    }
  }, [_vm._v("Since ‘the number of people is infinite,’ Semedo concluded, ‘there can be no capital sufficient for so many, or money enough to fill so many purses’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-59",
      "id": "nr1-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many of Semedo's contemporaries also considered Europe ‘overpopulated’. John Winthrop justified ‘the plantation of New England’ because England itself ‘groweth her inhabitants soe that man, the best of creatures, is held more base then the earth they tredd on'; while Sir Ferdinando Gorges also claimed that England's ‘peaceable time affords no means of employment to the multitude of people that daily do increase’, and he sent colonists to settle the coast of North America primarily to reduce population pressure at home. His rivals in the Virginia Company, fearing ‘the surcharge of necessitous people, the matter or fuel of dangerous insurrections’, likewise sought to remove them from England to their new colony. These and other measures enjoyed such success that by the 1630s thousands crossed the Atlantic each year, promoting England's stability because the colonies ‘serve for drains to unload their populous state which else would overflow its own banks by continuance of peace and turn head upon itself, or make a body fit for any rebellion’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-60",
      "id": "nr1-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Scarcely had the ink dried on these words than the global population began to contract sharply. In China, the victorious Qing believed that in the mid-seventeenth-century crisis ‘over half of the population perished. In Sichuan, people lamented that they did not have a single offspring.’ In the 1650s, after a decade of sectarian violence and civil war in Ireland, according to one of the English victors ‘a man might travel twenty or thirty miles and not see a living creature’ except for ‘very aged men with women and children’ whose skin was ‘black like an oven because of the terrible famine'; and a generation later, another English eye-witness estimated that over 500,000 Irish men and women had died ‘by the sword and famine and other hardships’ in the troubles. Contemporaries elsewhere made similarly bleak assessments. In southern Germany, one eye-witness of the Thirty Years War believed that ‘there have been so many deaths that the like of it has never been heard in human history'; while a Lutheran minister wrote despondently in 1639 that of his 1,046 communicants a decade earlier, barely one-third remained: ‘Just in the last five years, 518 of them have been killed by various misfortunes. I have to weep for them,’ he continued forlornly, ‘because I remain here so impotent and alone. Out of my whole life scarcely fifteen people remain alive with whom I can claim some trace of friendship.’ Perhaps most striking of all, in France, ravaged between 1648 and 1653 by war, famine and disease, Abbess Angélique Arnauld of Port-Royal (just outside Paris) estimated that ‘a third of the world has died’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en1-61",
      "id": "nr1-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("Subsequent research has corroborated each of these striking claims. In China, ‘the cultivated area of land decreased by about one-third’ during the Ming-Qing transition, while ‘the demographic losses were nearly the same’. Sichuan suffered particularly badly, with perhaps a million killed. Ireland's population fell by at least one-fifth during the mid-seventeenth century. In Germany, ‘about 40 per cent of the rural population fell victim to the war and epidemics [while] in the cities, the losses may be estimated at about 33 per cent’ between 1618 and 1648. Many villages in the Île-de-France suffered their worst demographic crisis of the entire Ancien Régime in 1648–53."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en1-62",
      "id": "nr1-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" Census data from Poland, Russia and the Ottoman empire suggest a population fall in the mid-seventeenth century of at least one-third, sometimes more. These staggering losses were not caused by the Little Ice Age alone, however: it required the misguided policies pursued by religious and political leaders to turn the crisis caused by sudden climate change into catastrophe.")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("The ‘General Crisis’")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("‘The century of the soldiers’")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("Most of those who lived through the seventeenth-century crisis identified war rather than climate as the principal cause of their misfortunes – and with good reason: more wars took place around the world than in any other era before the Second World War. The historical record reveals only one year entirely without war between the states of Europe in the first half of the century (1610) and only two in the second half (1670 and 1682) (")]), _c('a', {
    attrs: {
      "href": "#/#fig_04"
    }
  }, [_vm._v("Fig. 4")]), _vm._v("). In 1641 the prevalence of conflicts led the Italian warrior and man of letters Fulvio Testi to claim that ‘This is the century of the soldiers'; while according to the English philosopher Thomas Hobbes, ‘man's natural state’ was war. In Denmark, more than one-tenth of all texts printed between 1611 and 1669 concerned war, and publishing data from neighbouring countries would probably reveal a similar pattern. Beyond Europe, the Chinese and Mughal empires fought wars continuously for most of the seventeenth century, and the Ottoman empire enjoyed only ten years of peace."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-1",
      "id": "nr2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The ‘Conflict Catalogue’ compiled by Peter Brecke, a sociologist, shows that, on average, wars around the world lasted longer in the seventeenth century than at any time since 1400 (when his survey begins); while, looking only at Europe, Jack S. Levy, a political scientist, considered the sixteenth and seventeenth centuries ‘the most warlike in terms of the proportion of years of war under way (95 per cent), the frequency of war (nearly one every three years), and the average yearly duration, extent, and magnitude of war’. The ‘index of war intensity’ proposed by Pitirim Sorokin, another sociologist, rose from 732 in the sixteenth century to 5,193 in the seventeenth – a rate of increase twice or three times greater than in any previous period."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-2",
      "id": "nr2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In addition to these interstate conflicts, the mid-seventeenth century also witnessed more civil wars than any previous or subsequent period. For six decades, supporters of the Ming and Qing dynasties fought for control of China. The rebellion of large parts of the Stuart and the Spanish Monarchies unleashed internal conflicts that lasted over two decades in the former and almost three in the latter. The states of Germany, with powerful foreign support, fought each other for 30 years. France endured a civil war that lasted five years; the Mughal empire suffered a succession war that lasted two years. Several other countries (including Sweden, Denmark, the Dutch Republic and the Swiss Confederation) experienced political upheavals that only just stopped short of civil war (see "), _c('a', {
    attrs: {
      "href": "#/009Prologue_Did_Someone_Say_x2018Climate_Changex0027#fig_01"
    }
  }, [_vm._v("Fig. 1")]), _vm._v(" above). War, rather than peace, had become the normal state of human society.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p27"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p27"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_04"
    }
  }, [_vm._v("4. Frequency of wars in Europe 1610–80."), _c('br'), _vm._v("In the six decades between 1618 and 1678, Poland was at peace for only 27 years, the Dutch Republic for only 14, France for only 11, and Spain for only 3. Some states fought wars on several fronts at once. Virtually no European state avoided war during the 1640s.")])]), _c('a', {
    attrs: {
      "id": "fig_04"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_04"
    }
  }), _c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("Although the business of the military in war has always been killing people and breaking things, many in the seventeenth century believed that the wars of their day were not only more frequent but also more harmful to both people and property. When, around 1700, Richard Gough researched the history of his village, Myddle (Shropshire, England), he found that 21 men (one-tenth of the community's adult males) had left to fight in the Civil War, of whom only seven returned. Of the other 14, six died in battle, one perished in a brawl over plunder, another was hanged for horse theft and the other six disappeared without trace. Some no doubt succumbed to war-related diseases (such as typhoid, revealingly known as ‘camp fever’) or suffered war-induced accidents (such as freezing to death on sentry duty); but whatever their fate, and wherever their unmarked grave, their families never saw them again – ‘and if so many died from Myddle,’ Gough speculated, ‘we may reasonably guess that many thousands died in England in that war’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-3",
      "id": "nr2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Gough was right – the catalogue of 645 ‘military incidents’ fought in England and Wales between 1642 and 1660 compiled by historian Charles Carlton reveals that at least 80,000 men died in action – but they formed only part of the trail of destruction caused by war. As Patrick Gordon, a Scottish veteran, noted in the 1650s: ‘One can scarse be a souldier without being an oppressor and comitting many crimes and enormityes’, because those who failed to take what they needed by violent means ‘were sure to be destroyed by vermine, or dy with hunger or cold’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-4",
      "id": "nr2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Hans Heberle, a German shoemaker, recorded in his "), _c('i', [_vm._v("Journal")]), _vm._v(" how the failure of civilians to appreciate this dynamic could destroy lives and livelihoods. In 1634 the Protestant army of Bernard of Saxe-Weimar approached Heberle's village but, since they too were Protestants, he and his neighbours ‘did not regard him as our enemy’ and so took no precautions. Nevertheless Bernard's troops ‘plundered us completely of horses, cattle, bread, flour, salt, lard, cloth, linen, clothes and everything we possessed. They treated the inhabitants badly, shooting, stabbing and beating a number of people to death.’ As they left, ‘they set the village alight and burnt down five houses’. Heberle and his surviving neighbours had learned an important lesson: in the mid-seventeenth century, every soldier was an ‘enemy’. Henceforth, ‘we were hunted like wild beasts in the forest,’ he wrote bitterly in his journal, and whenever troops approached, the villagers fled with whatever they could carry to Ulm, the nearest fortified city. Their sufferings did not end there, because Ulm lacked the resources to sustain the sudden influx of thousands of refugees. On at least one occasion water became so scarce that ‘almost everybody drank their own urine, or the urine of their children … The thirst grew so intense that we did not care about being hungry.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-5",
      "id": "nr2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("To quote the lugubrious Thomas Hobbes again, ‘warre consisteth not in battell onely, or the act of fighting, but in a tract of time, wherein the will to contend by battell is sufficiently known’. War, Hobbes argued, was like the climate: just ‘as the nature of foule weather lyeth not in a showre or two of rain, but in an inclination thereto of many days together: so the nature of warre consisteth not in actuall "), _c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("fighting, but in the known disposition thereto during all the time there is no assurance to the contrary.’ This led to widespread insecurity. When he returned to England from the continent in 1660, Charles II observed that the Civil War ‘had filled the hearts of the people with a terrible apprehension of insecurity’, and therefore worked hard on ‘extinguishing this fear, which keeps the hearts of men awake’. Three years later, in Germany, a comedy by Andreas Gryphius made the same point with a joke, beginning one of his plays with the boast of ‘Captain Daradiridatumtarides Farter of a Thousand Deaths’ that")])]), _c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("The Great Shah of Persia trembles when I walk on the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The Turkish emperor has several times sent ambassadors to offer me his crown.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The world-famous Mughal (emperor) knows his fortress is vulnerable to me …")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The princes of Europe ever more courteously become my friends –")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But more through fear than through true affection.")])])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("Looking back in 1683, ex-Queen Christina of Sweden wrote that ‘In the present century, the whole world is at arms. We threaten each other, we fear each other. Nobody does what they want, or what they could do. No one knows who has lost or who has won, but we know well enough that the whole world lives in fear.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-6",
      "id": "nr2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In China war became so common that a special word emerged to describe military atrocities: "), _c('i', [_vm._v("binghuo")]), _vm._v(", ‘soldier calamity’. According to the eminent sinologist Lynn Struve, ‘no locale in China escaped some sort of “soldier calamity”’ during the Ming-Qing transition."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-7",
      "id": "nr2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" As in Europe, the worst atrocities occurred when soldiers took a town by storm. A seventeenth-century Chinese play, "), _c('i', [_vm._v("The Miraculous Reunion")]), _vm._v(", compared the treatment of a captured town or city with ‘pounding fresh onion and garlic to pieces in a bowl'; while an eye-witness account noted that civilians who survived a successful storm ‘had scorched pates, pulpy foreheads, and broken or otherwise injured arms and legs. They had sword gashes all over their bodies, the blood from which had clotted in patches, and their faces were streaked with trickles of blood like tears from burning red candles.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-8",
      "id": "nr2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This description came from a chronicle kept by a scholar, Wang Xiuchu, of the six-day sack of Yangzhou, a large city north of the river Yangzi, by Qing forces in 1645. According to Wang, at one point ‘through the compound wall I heard the voice of my youngest brother shrieking and the sound of a sabre hacking – three strikes and all was silent. After a short while I also heard my elder brother say pleadingly “I have silver at home in an underground vault. Let me get it and bring it to you.” One strike, and again silence.’ Somewhat later, a soldier caught another of Wang's brothers and ‘cut him with his sabre to make him talk'; he died of his wounds a week later. His sister-in-law, nephew and niece also perished, and both Wang and his wife were badly beaten. Before the soldiers stormed Yangzhou ‘there were eight of us,’ Wang wrote, but ‘now there are only three’. Another eye-witness claimed that 80,000 inhabitants perished in the sack; and because so much of the city lay in ruins, poets referred to it as the ‘Weed-covered city’. Its fate in 1645 is still familiar to every Chinese schoolchild."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-9",
      "id": "nr2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The European equivalent of the sack of Yangzhou was the sack of Magdeburg in 1631. Even in the nineteenth century, "), _c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("Protestant preachers still used its fate as a warning in their sermons and for a time it gave a new verb to the German language: "), _c('i', [_vm._v("Magdeburgisieren")]), _vm._v(", to ‘make a Magdeburg’ of somewhere."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-10",
      "id": "nr2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("For women, war presented additional dangers: the high risk of being raped or abducted. Some suffered through a deliberate effort by the victors to dishonour a community, to prove it could not ‘protect its women'; others became the victims of lust. At Yangzhou in 1645, Wang Xiuchu watched a group of soldiers argue over the fate of five women whom they had captured:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Suddenly one of them hoisted one of the women and copulated with her under a tree. Then the two other younger ones were sullied while the two older ones wailed and begged to be spared. The three younger ones shamelessly thought nothing of it when about a dozen men took turns raping them before handing them over to the two soldiers who'd run up later.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Thousands of Chinese women committed suicide after they had been raped."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-11",
      "id": "nr2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Rape also featured prominently during the sack of Magdeburg. Some monks watched horrified as six Catholic soldiers gang-raped a 12-year-old girl until she died in the courtyard of their convent; while Otto von Guericke, an eyewitness who survived to become a skilled inventor, reported that ‘Things went very badly for many of those women, girls, daughters and maids who either had no men, parents or relatives who could pay a ransom on their behalf, or could not appeal to high officers for help or advice. Some were defiled and disgraced, and some were kept as concubines.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-12",
      "id": "nr2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The diary of a Catholic soldier, Peter Hagendorf, shows what might happen next. He described how at the sack of a Bavarian town in 1634, ‘Here I got a pretty girl as my booty as well as 12 thalers in cash, some clothes and a lot of linen.’ A few weeks later, he participated in the sack of another town ‘and here again I got a young girl out of it’. If the rest of the ‘enlisted men’ received similar ‘booty’, a very large number of ‘women, girls, daughters and maids’ from these two towns must have been abducted and, presumably, ‘defiled and disgraced’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-13",
      "id": "nr2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Hagendorf's ‘girls’ were relatively lucky: he released each of them when the army moved on. Three years later, 20 Swedish soldiers rode into the small village of Linden, in central Germany, one afternoon, and violently demanded food and wine. Two of them, a ‘fat soldier’ from Finland and a ‘white-haired young soldier’, broke down the door of a farmer's cottage, where they raped his wife and then chased her, screaming, through the village. During the Irish rebellion of 1641, a Protestant prisoner claimed to have heard his Catholic captors")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Often in the night tyme with their pistolls come into the Chamber where the women servants were, and attempted their chastities, making them skrike and cry out; and, as the said woman affirmed, threatened to pistoll them if they wold not consent to their lustfull desires; and this deponent thincketh that those wicked rebells did assault them untill they had forced them to their lustful wills.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("In Poland, finally, after the town of Graudiądz was ‘taken by storme’ in 1659, many inhabitants managed to swim across a river to safety but the ‘others of all sexes and ages were taken to the leaguer (the besiegers’ camp) and stripped of all, and the women abused’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-14",
      "id": "nr2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The victims of such violent acts suffered psychological as well as physical damage. In Germany, soldiers raped Anna Hurter of Hawangen in 1633, and when she died in 1657 her parish priest noted in the burial register that ‘for twenty-four years "), _c('i', [_vm._v("she had not had one sane hour until suddenly she expired")]), _vm._v("’. In Ireland in 1641, during a brutal rape of a young woman, ‘to prevent her crying out, one of (the) souldjers thrust a napkin into her mowth and held her fast by the haire of her head till the wicked act was performed’. Afterwards the victim could not move ‘for three or four days’, and even four years later ‘thought shee should never bee well nor bee in her right mynd againe, the fact was soe fowle and grievous unto her’. Four years later, Wang Xiuchu noted that ‘one of the younger women’ he had watched being gang-raped at Yangzhou ‘couldn't even get up to walk’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-15",
      "id": "nr2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Although in all ages and in all places war produces personal tragedies like these, the proliferation of conflict in the seventeenth century multiplied them. The profoundly disturbing alabaster sculpture by Leonhard Kern, which shows an officer abducting a naked girl, significantly called ‘Scene from the Thirty Years War’, no doubt commemorates a common occurrence (Plate 2).")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("‘Feeding Mars’")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Contemporaries also blamed war for the cost to them of maintaining the armies and navies of their rulers. The expenses associated with fighting wars, whether against neighbours or rebels, constantly increased – and not just because of their duration. Europe's Atlantic states built huge fleets of ‘floating fortresses’: sailing warships, each of them larger than a country house and carrying as many guns as a fort on land, that cost £33,000 each to build and £13,000 to keep at sea for a campaign. Europe's naval wars during the second half of the century saw battleships deployed in lines that stretched for 10 miles, with 3,000 heavy guns firing broadsides at each other, sometimes for several days – an enormous financial outlay. Naval arsenals and dockyards were the largest industrial plants in early modern Europe, whether they produced sailing ships or, as in the Mediterranean, galleys. Mediterranean warfare was labour-intensive. Each galley carried about 400 oarsmen and soldiers, so that (in the words of a French sailor) ‘an infinite number of villages are far from having as large a number of inhabitants’ as a single galley."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-16",
      "id": "nr2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Normally, land warfare cost even more than naval operations. Apart from raising and maintaining soldiers, most states also invested heavily in fortifications. The two largest states in the world, China and Russia, constructed continuous defences along their most vulnerable frontiers. The late Ming emperors extensively rebuilt the Great Wall of China in stone to take account of gunpowder technology, and although the Manchus breached it in both 1629 and 1642, it still reduced small-scale raiding. Meanwhile, the Russian empire constructed a ‘Great Wall’ consisting of fortified towns linked by earthen ramparts which, by 1658, ran for 800 miles "), _c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("along the steppe frontier from the Dnieper to the Volga (see ")]), _c('span', {
    attrs: {
      "href": "#/0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386#fig_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19")]), _vm._v("). As in China, although the fortified line did not bring complete security, it compelled invaders from the south – whether Crimean Tatars or Cossack rebels – to follow certain paths where the tsar's troops could more easily intercept them.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Other European states eschewed ‘lines’ but invested in a network of ‘artillery fortresses’: each one a star-shaped complex with extremely thick walls protected by angled bastions, moats and outposts. When in a good state of repair, and defended by sufficient heavy guns and an adequate garrison, such positions could seldom be taken by assault, and so sieges played a crucial role in conflicts: the Russo–Polish wars of 1632–4 and 1654–5 hinged on control of the bastions around Smolensk, while the turning point in the Habsburg–Turkish wars came with the failed Ottoman blockade of Vienna in 1683. Further west, artillery fortresses proliferated in many contested areas: the north Italian plain; the borders of France; the lands around the Baltic; within the Iberian Peninsula as well as in Britain and Ireland after the civil wars began; and above all in the Netherlands, which contained by far the largest density of artillery fortresses anywhere in the world. When the Dutch Revolt against Spain began in 1572, 12 towns already possessed a complete set of the new defences, while 18 more had been partially updated; but when the Revolt ended in 1648, the same area boasted at least 50 artillery fortresses and a further 60 towns with partially modernized walls. Each one cost millions of pounds to construct.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Laying siege to these state-of-the-art fortifications formed the largest engineering enterprise of the age – trenches might stretch for 25 miles and operations could last for months – and their outcome dominated most campaigns. ‘Battles do not now decide national quarrels, and expose countries to the pillage of conquerors, as formerly,’ observed an Irish general who learned his craft during the wars of the mid-century, ‘for we make war more like foxes, than lions; and you will have twenty sieges for one battle.’ ‘One scarcely talks any more about battles,’ a German military instructor concurred: ‘Indeed, the whole art of war now consists only of cunning attacks and good fortification.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-17",
      "id": "nr2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The Spanish and Dutch governments each maintained around 100,000 soldiers in the Netherlands from the moment war between them resumed in 1621 until they made peace in 1648 – and yet the two sides never fought a pitched battle. Instead, each year's campaign consisted of sieges.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Perhaps one million men served simultaneously in the various armies and navies of seventeenth-century Europe. Philip IV of Spain boasted that ‘In the year of 1625 just past, we can count around 300,000 infantry drawing wages and more than 500,000 militiamen’. Louis XIII of France ordered the mobilization of over 150,000 men when he declared war on Spain in 1635, and he and his successor maintained at least 100,000 soldiers in arms until making peace 24 years later. Between 1672 and 1678, Louis XIV commanded about 250,000 troops."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-18",
      "id": "nr2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" In Germany, some 300,000 troops took part in each campaign between 1631 and 1634; and at least 200,000 men remained in arms when the Thirty Years’ War ended in 1648. Over 100,000 soldiers fought the civil wars in England, Scotland and Ireland during the 1640s, and throughout the 1650s over 50,000 men served in the army and navy of the British Republic.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("All these soldiers required training and equipment, as well as food and clothes. From the 1620s onwards, up to half of each army in western Europe carried muskets, and fought in parallel lines firing repeated ‘broadsides’ at their enemies. This tactic called for a level of proficiency and discipline from each individual soldier that only prolonged training could provide, leading to the creation of a ‘standing army’ of veterans who would form the backbone of the larger forces required in wartime. Some of the regiments raised by Emperor Ferdinand II to suppress the Bohemian revolt in 1618 remained in the imperial Habsburg army until the dynasty fell three centuries later; General George Monck's regiment of foot, formed in 1650 and now known as the Coldstream Guards, boasts the longest continuous service of any unit in the British Army (or indeed any army) today.")])]), _c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("Many non-Western states adopted at least some of these expensive European innovations. Both the Ottoman and the Russian empires recruited infantry armed with muskets: the Janissaries (literally ‘new troops’) fought for the sultan in ranks with muskets; while Western instructors recruited by the tsars trained New Formation Regiments. Although the Mughal and Chinese emperors also made use of Western firearms and Western military experts, they normally fought wars that were labour-intensive (by mobilizing overwhelming numbers) rather than capital-intensive (by investing in new technology). Shah Jahan normally travelled with an army of 200,000 cavalry and 40,000 infantry, 50–60 heavy guns and numerous war elephants; the last Ming emperors, at least in theory, could call on 500,000 men and 100,000 cavalry horses; while to repress the Three Feudatories rebellion in the 1670s the Kangxi emperor mobilized over 150,000 ‘bannermen’ (elite Manchu troops) seconded by 400,000 loyal Chinese troops. Even in times of peace, the Qing maintained 80,000 bannermen as a rapid reaction force, garrisoned in citadels specially created in China's major cities. All of them had to be paid.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The ‘unit cost’ of waging war rose inexorably. The Italian political theorist Giovanni Botero complained in 1605 that ‘[Nowadays] war is dragged out for as long as possible, and the object is not to smash but to tire, not to defeat but to wear down the enemy. This form of warfare is entirely dependent upon money.’ ‘The manner of making war at the present time,’ echoed a Spanish commander in the 1630s, ‘is reduced to a sort of traffic or commerce, in which he who has most money wins.’ Six decades later, an English pamphleteer made exactly the same point:")])]), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p33"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("War is quite changed from what it was in the time of our forefathers; when in a hasty expedition, and a pitch'd field, the matter was decided by courage. But now the whole Art of War is in a manner reduced to money; and nowadays that prince who can best find money to feed, cloath and pay his army, not he that has the most valiant troops, is surest of success and conquest."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-19",
      "id": "nr2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("All this had crushing financial consequences for civilians. In France, the tax burden on a family of four rose from the equivalent of 14 days’ output a year to 34 days’ output by 1675; the Ottoman empire spent 75 per cent of its total budget on war; while, in Muscovy, ‘one-eighth of [all] productive resources went just to pay for the army’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-20",
      "id": "nr2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("Naturally, the diversion of so many resources to the pursuit of ‘success and conquest’ also involved indirect (or ‘opportunity’) costs. States that spent so much on war had little left for anything else – whether official salaries; goods and services; or welfare. Philip IV of Spain, who spent at least £30 million to finance his foreign wars between 1618 and 1648, claimed that he lacked the money to set up a national banking system; Charles I of Great Britain, whose wars between 1625 and 1630 cost £6 million, decided he could not afford to create public granaries for famine relief; and so on. Ming China offers perhaps the most graphic case of the ‘opportunity costs’ of prodigious military spending. After Manchu raiders broke through the Great Wall in 1629, the emperor's drastic reductions in non-defence spending included the closure of perhaps one-third of all courier and postal stations. Some of those who lost their livelihoods began to prey on those who used the routes they had once serviced: one of them was Li Zicheng, who became the leader of a bandit alliance and, briefly, emperor of all China."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-21",
      "id": "nr2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The Fiscal-Military State")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Early modern governments resorted to a wide variety of expedients to fund their wars. The fiscal history of England, a relatively small country, was both striking and typical. Between 1605 and 1625, the government of James I (much criticized for its extravagance and corruption) raised and spent some £10 million, roughly 25 per cent of which went on military and naval spending; by contrast, between 1642, when the Civil War began, and 1660, when all soldiers and sailors then on foot laid down their arms, the London government raised and spent £34 million. The central government's defence spending thus rose twelve-fold – from an annual average of £117,000 in 1605–25 to an annual average of £1.5 million in 1642–60. Even so, debts of about £2 million remained unpaid in 1660, leaving subsequent generations of English taxpayers to amortize the cost of the Civil Wars."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-22",
      "id": "nr2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Such debts reflected the fact that, then as now, few governments can fund their wars from current revenues alone. In Europe, most states raised loans to bridge the gap between income and expenditure – but borrowing created a new set of problems, because bankers normally demanded a specific source of revenue as security for each loan, compelling governments to create new taxes. This vicious circle explains the apparently senseless fiscal decisions of so many rulers. Some stifled economic activity by taxing industrial production or exports just when conditions called for economic stimuli and ‘tax breaks'; while others taxed items in general use, such as foodstuffs, which not only reduced the disposable income of most consumers but also provoked both widespread hardship and resistance. Many revolts began with rioting at the point of sale when a new tax unexpectedly increased the price of everyday items such as a loaf of bread or a basket of fruit. Other revolts materialized when rulers increased taxes on areas that they believed to be unusually prosperous. Thus when war broke out with Spain in 1635, the French government abruptly doubled the "), _c('i', [_vm._v("taille")]), _vm._v(" (the principal direct tax) payable by the area around the thriving port of Bordeaux from one million "), _c('i', [_vm._v("livres")]), _vm._v(" to two. In 1644, although poor harvests had "), _c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("caused grain prices to soar, the government increased the "), _c('i', [_vm._v("taille")]), _vm._v(" to three million "), _c('i', [_vm._v("livres")]), _vm._v(" and then in 1648, coinciding with the worst harvest of the century, to four million "), _c('i', [_vm._v("livres")]), _vm._v(". Not surprisingly, Bordeaux supported the Fronde revolt that year and before long considered secession as an independent republic (see chapter 10).")])]), _c('a', {
    attrs: {
      "id": "p35"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("Apart from imposing excise duties and increasing direct taxes, early modern governments at war frequently exploited and extended state monopolies (often known as ‘regalian rights’), such as extracting minerals obtained from the sea or under the ground (including salt and coal, silver and copper), or maximizing the profits from minting coins. Currency manipulation became particularly common in the seventeenth century, with governments from Spain, through Russia, to China either adulterating silver coins with base metals, or issuing copper or paper money with little or no intrinsic value. Forcible devaluation could ruin whole societies. In 1634 in exile Pavel Stránský recalled the devaluation in Bohemia a decade earlier as the most traumatic experience of his life: ‘Neither plague, nor war, nor hostile foreign incursions into our land, neither pillage nor fire however atrocious, could do so much harm to good people as frequent changes and reductions in the value of money’. Several major revolts broke out when governments manipulated the currency, notably in central Europe in 1621–3, in Spain in 1651, and in Russia in 1661–3."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-23",
      "id": "nr2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, as the Swedish historian Jan Glete reminds us, in early modern Europe ‘Wars were not decided by the existence of resources but by how these resources were organized’. The key to improved organization, Glete argues, was ‘the fiscal-military state’: a polity dedicated to extracting, centralizing and redistributing resources to finance the use of violence."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-24",
      "id": "nr2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Only its superior ability to organize available resources enabled Sweden, with scarcely a million inhabitants, to hold 20 million Germans to ransom during and after the Thirty Years War; and allowed the Dutch Republic, also with scarcely a million citizens, to defeat the Spanish Habsburgs, with over 30 million subjects. Yet even the Dutch Republic, the most successful fiscal-military state of the early modern world, experienced difficulties in funding its wars. The debt of the federal government rose from 5 million florins in 1618 to 16 million in 1670, and that of the richest province (Holland) from 5 million to 147 million. At the same time taxes, especially sales taxes, rose to dizzying levels both to pay for current wars and to service the debts created during previous wars: in the university town of Leiden, by the 1640s taxes accounted for 60 per cent of the price of beer and 25 per cent of the price of bread. When provinces fell into arrears with their quotas of the overall budget, the federal government imprisoned their citizens as hostages until the shortfall was made good.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Only such draconian measures enabled the Dutch government, at war for most of the seventeenth century, to maintain its credit intact while paying its army and navy regularly; other governments did not even try. Calculations in 1633 by the Swedish chancellor, Axel Oxenstierna, responsible for funding all Protestant troops fighting in Germany, show the magnitude of the problem. On paper, each of the 78,000 soldiers fielded by the allies earned an average of 125 thalers per year, or almost 10 million thalers for the entire army. Oxenstierna knew that this was far beyond his means. If, however, he provided each soldier with full wages for just one month, a "), _c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("small cash advance for the other 11, and one pound of bread every day, then the total annual cost fell to 5.5 million thalers, or 55 per cent of the original cost."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-25",
      "id": "nr2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" But what of the other 45 per cent? Oxenstierna, like other warlords of his day, expected two fiscal expedients to make up the shortfall. He expected his officers to use their own credit to supply their troops with essential items. It was no secret that his principal adversary, Albrecht von Wallenstein, had borrowed five million thalers (five times his personal fortune) between 1621 and 1628 to sustain his army until a victorious peace would bring reimbursement and rewards; and that most of the 1,500 or so colonels who raised regiments to fight in the Thirty Years War did much the same (albeit on a lesser scale). It was also no secret that Wallenstein had introduced a ‘contributions system’ that forced civilians living near his army to provide it with food and other necessities. His quartermasters worked out with the local magistrates of each community the precise quantities and the exact timetable for delivery, threatening that any shortfall or default would trigger the arrival of a detachment of soldiers who would burn everything to the ground. Oxenstierna expected his quartermasters to do the same.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Although it is hard to assess the precise financial impact of war on civilians, the records of the principality of Hohenlohe in southwest Germany show that in each year from 1628, when hostile soldiers first arrived, until the demobilization of 1650, its inhabitants paid at least double what they had done before the war, and that in some years they paid three, four or even five times as much. Yet even this did not suffice to ‘feed Mars’. Just before his regiment was demobilized, one officer complained that he did not ‘earn enough daily bread to support my wife and poor children’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-26",
      "id": "nr2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Troops elsewhere seldom fared much better. In China, a Manchu Bannerman named Dzengšeo recorded in his campaign diary for 1680 that on some days he did not eat, but instead ‘wept with sorrow under the blanket'; while on one desperate occasion he ‘even sold a woman’ whom he had received as booty at the capture of a town, to buy horses and food. Usually, however, like early modern soldiers elsewhere, when he was hungry Dzengšeo exploited the civilian population: when ‘the food supplies for the whole army had been used up’, he sent his servants to ‘search for food in every single village’ and to take what they found by force."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-27",
      "id": "nr2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Doing God's Work")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Rulers in the mid-seventeenth century could not plead ignorance about the economic hardships that their wars inflicted on soldiers and civilians alike. In China, officials deluged their superiors with memoranda that pointed out (to quote one missive), ‘The present dynasty commands the largest area of land in history. But land without people is worthless, and people without wealth are valueless; and in the present dynasty we find that the poverty afflicting the whole population is unprecedented in the history of China.’ Likewise, in 1640, just before the outbreak of revolt in Catalonia and Portugal, a tract published in Madrid perceptively warned Philip IV of the dangers inherent in overtaxing his subjects:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("The horror of civil unrest is more to be feared than the weapons of the enemy. The common people will prefer rebellion in order to avoid destitution. Hardship causes desperation; constant rigour incites hatred … Subjects are more obedient when they are less taxed. A prince who in time of war avoids spending on himself will make the word ‘tax’ acceptable, and avoid being called ‘ambitious’.")])]), _c('a', {
    attrs: {
      "id": "p37"
    }
  })]), _c('a', {
    attrs: {
      "id": "p37"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("If the king read this, he paid no attention – just as, 12 years later, he ignored the protests of his spiritual advisor, Sor María de Ágreda, ‘that, for the love of God, Your Majesty should introduce as few innovations as possible and avoid oppressing the poor, lest their misery leads them to revolt’. Instead Philip loftily assured Sor María that, although ‘everything possible will be done for the relief of my poor vassals’, nevertheless ‘"), _c('i', [_vm._v("the requirements of the army pull in the opposite direction")]), _vm._v("’. Spain's wars therefore continued."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-28",
      "id": "nr2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Why, exactly, did so many seventeenth-century rulers raise taxes to satisfy ‘the requirements of the army’ instead of taking steps to ‘avoid oppressing the poor'? One reason lay in the lack of any restraint. In China, the emperor claimed to possess the ‘Mandate of Heaven’ for all his actions, and his subjects revered him as "), _c('i', [_vm._v("Tianzi")]), _vm._v(", ‘Son of Heaven’, possessing supreme power in all things:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("He judged whether a given offender should be punished severely or not at all. He judged the qualifications of candidates for high offices and for the civil service examination degrees. He validated or refused requests to do anything non-routine, such as whether to issue amnesties or disaster relief, or modify a ritual or bureaucratic procedure, or mount an attack against [foreign enemies] … The outside world could not function without imperial decisions. No one else in the realm was empowered to make authoritative rulings."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-29",
      "id": "nr2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Every aspect of the emperor's official life proclaimed his unique status and untrammelled authority. At audiences he alone faced south and everyone else faced north; no one else could wear clothes designed like his; he alone used red ink (everyone else used black); the character for ‘emperor’ received a line of text to itself; no one else could use the character for each emperor's given name or the word he used for ‘I’ ("), _c('i', [_vm._v("chen")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Other Asian rulers also claimed to embody divine power on earth, which conferred the right to make war at will. Korean kings held that they both embodied the state and acted with divine sanction to bring the purposes of heaven and of human beings into harmony. In the words of a scholar and minister in 1660: ‘The ruler regulates things in place of Heaven, and causes them to find their appointed places’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-30",
      "id": "nr2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Political rhetoric in South Asia also presented rulers as endowed with superhuman powers. Successful Buddhist monarchs claimed to be "), _c('i', [_vm._v("chakhravarthi")]), _vm._v(" (‘world conquerors’), just as India's Mughal emperors projected themselves as "), _c('i', [_vm._v("Sahibkiran")]), _vm._v(" (the ‘Shadow of God on Earth’). India's Hindu rulers claimed to be not only the incarnation of one of the gods but also sexual heroes: court poems and dance-dramas, the preferred media for political propaganda in southern India, "), _c('a', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("portrayed the capital as a city of erotic delights and war as a sexual adventure. None of these political visions left room for restraint."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-31",
      "id": "nr2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Indonesian rulers likewise acknowledged no limits to their power. Thus in the 1640s the sultan of Mataram assembled 2,000 of his senior clerics shortly after his accession, accused them of disloyalty, and executed them all. A generation earlier, according to a foreign visitor, whenever Sultan Iskandar Muda of Acheh heard about an attractive ‘woman, either in city or country, he sends for her to the court. Although she be married, she must come and if her husband seem unwilling or loath to part from her, then [the Sultan] presently commands her husband's prick to be cut off.’ Iskandar Muda did not stop at ‘pricks’: he also (according to another foreign visitor) ‘exterminated almost all the ancient nobility’ in the course of his reign. Therefore by 1629 no one had the authority to restrain the sultan when he decided to lead the entire military and naval strength of his state to attack Portuguese Melaka, or to remind him of the need to fortify his own siege works – with the result that a Portuguese relief army destroyed almost all his army, his fleet and his guns."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-32",
      "id": "nr2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Most Muslim political writers extolled a powerful monarchy as both the only alternative to anarchy and the best way to advance the cause of Islam, often citing a paradigm known as the ‘Circle of Justice’:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("There can be no government without the military;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("There can be no military without wealth;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The subjects produce the wealth;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Justice preserves the subjects’ loyalty to the sovereign;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Justice requires harmony in the world;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The world is a garden, its walls are the state;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The "), _c('i', [_vm._v("Sharî'a")]), _vm._v(" [Islamic law] orders the state;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("There is no support for the "), _c('i', [_vm._v("Sharî'a")]), _vm._v(" except through government."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-33",
      "id": "nr2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("A treatise of advice presented to Ottoman Sultan Murad IV in 1630 by a learned palace official, Mustafa Koçi Beg, ascribed the problems facing the empire to the failure of the sultan to use his divinely sanctioned arbitrary power to overcome anarchy and advance the cause of Islam. To implement this advice, Murad addressed a stream of requests to the Chief Mufti ("), _c('i', [_vm._v("Şeyhulislam")]), _vm._v(") of Istanbul to certify (usually in the form of a written opinion, or "), _c('i', [_vm._v("fatwā")]), _vm._v(") that a proposed action or edict conformed to the "), _c('i', [_vm._v("Sharî'a")]), _vm._v("."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-34",
      "id": "nr2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" In 1638 Murad even took the "), _c('i', [_vm._v("Şeyhulislam")]), _vm._v(" with him on campaign, so that he could ensure that his military as well as his civilian decisions conformed to God's will. Occasionally the "), _c('i', [_vm._v("Şeyhulislam")]), _vm._v(" might defy a sultan – in 1648 one even issued a "), _c('i', [_vm._v("fatwā")]), _vm._v(" to legitimize the sultan's deposition (see chapter 7 below) – but normally the shoe was on the other foot: sultans deposed (and occasionally executed) a "), _c('i', [_vm._v("Şeyhulislam")]), _vm._v(" who challenged their authority.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The tsars of Russia likewise claimed divine status and encouraged writers and artists to portray them as the secular version of the transfigured Christ, as paragons of Old Testament kingship (especially David), and as the ‘Image and likeness of God’, while their subjects became the Chosen People, their country the Earthly Paradise, and their capital the New Jerusalem. The state apartments in the Kremlin "), _c('a', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("sported paintings that interspersed the victories of Moses, Joshua and Gideon with the leading events of Russian history and portraits of the biblical ‘tsars’ with the princes of Russia. The main Moscow churches displayed icons in which an archangel and the heavenly host led the tsar and his troops on campaigns of conquest. When the tsar ‘wishes to wage war or make peace with any state,’ an experienced minister explained in the 1660s, ‘or when he wishes to decide any other great or small affairs, it is in his power to do what he wishes’. As with the rhetoric of absolutism in Asia, the ‘Paradise myth’ fostered by the tsars left no room for discussion or dissent, let alone for loyal opposition."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-35",
      "id": "nr2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The equivalent of the ‘Mandate of Heaven’, the ‘World Conqueror’, the ‘Shadow of God on Earth’ and the ‘Paradise Myth’ for rulers in Latin Christendom was the ‘Divine Right of Kings’. Many early modern European rulers claimed both that their power was "), _c('i', [_vm._v("absolute")]), _vm._v(" (a term derived from Roman law to describe the authority of one ‘absolved’ from obeying the laws he had made) and that their actions enjoyed divine approval. In 1609 James I of Great Britain boasted that ‘The state of monarchy is the supremest thing upon earth, for kings are not only God's lieutenants upon earth and sit upon God's throne, but even by God himself they are called god.’ Therefore, James continued, ‘They exercise a manner or resemblance of divine power upon earth’ because ‘they make and unmake their subjects, they have power of raising and casting down, of life and of death, judges over all their subjects and in all causes and yet accountable to none but God only.’ A generation later, the funeral oration for a German prince echoed the same sentiments. ‘Just as the sun in the heavens above is made and fashioned by God, and is truly a wondrous work of the Almighty, so are kings, princes and lords placed and ordered by God in the secular estate. For that reason, they may themselves be called gods.’ In France, a treatise written by a royal minister likewise argued that the king's commands must always prevail:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("One can ask the question, if a man's conscience tells him that what the king has ordered him to do is unjust, is he bound to obey? To this I respond that, if there are considerations for and against, he must follow the king's will, not his own … One must pay attention to circumstance, because if [a measure] relates to a pressing necessity for the public good … "), _c('i', [_vm._v("Necessity knows no law")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Later still, ex-queen Christina of Sweden wrote that ‘Only monarchs must rule: everyone else must obey and execute their orders.’ Specifically, she continued, a royal decision to wage war – even a war of aggression – obliged everyone to obey because sovereigns could discern the true interests of the state better than their subjects."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-36",
      "id": "nr2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Most European monarchs received an education crafted explicitly to reinforce these attitudes. They studied history (national, Classical and occasionally foreign) primarily ‘to examine how each prince had acted well or badly’ and to learn how to ‘ascertain what our subjects are hiding from us’. Thus on hearing that France had signed the peace of Westphalia in 1648, Louis XIV's preceptor seized the chance to give his 10-year-old charge a crash course in German history, and especially on the "), _c('a', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("history of the Rhineland (which Louis would later spend vast resources trying to annex); while during the Fronde revolt of 1648–53, Louis read chronicles that described how his predecessors had overcome rebellious nobles."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-37",
      "id": "nr2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Princely instruction in language and geography was also utilitarian. Louis XIV, his son and his grandsons all studied Spanish history and literature, and learned to speak Spanish, in case they might one day succeed their ailing cousin, Carlos II. They likewise learned the principles of architecture and mathematics explicitly so that they would better understand how to attack and defend fortified towns; and Louis XIV commissioned a set of huge relief models of frontier fortresses so that his son could follow the progress of his wars until he was old enough to participate in person."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-38",
      "id": "nr2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Above all, seventeenth-century rulers believed that ‘religion is the most important element in what must be taught to a young prince destined to wear the crown’ – and this meant not only private but also public devotions. Throughout the Fronde, the official "), _c('i', [_vm._v("Gazette de France")]), _vm._v(" recorded not only the zeal and humility of the young Louis XIV during sermons but also his participation in pilgrimages; while between 1654 and 1663 it chronicled the 42 occasions on which he ‘touched’ (and, according to popular tradition, cured) subjects afflicted with scrofula – some 20,000 individuals in all – perhaps the most striking public demonstration of divinely delegated power in the early modern world."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-39",
      "id": "nr2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" French monarchs proudly styled themselves ‘The Most Christian King’, while their Spanish counterparts used the style ‘The Catholic King’ and English monarchs were Supreme Governors of the Established Church. Catholic and Protestant rulers alike appointed the prelates of their state (the former with papal concurrence) and expected their subjects to follow their theological opinions – or, in the formula that prevailed in the Holy Roman Empire, "), _c('i', [_vm._v("Cuius regio, eius religio")]), _vm._v(": ‘Rulers determine religion’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The overlap of politics and religion influenced foreign as well as domestic policy. In the words of the governor of Louis XIV's heir, Christian princes must not only ‘love and serve God’ but also ‘make others honour Him, avenge His injuries, and take up His causes'; and in 1672 the Dauphin, aged 11, composed a campaign history that justified his father's invasion of Holland because it advanced the Catholic faith."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-40",
      "id": "nr2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Religion often served as a pretext for war in Europe in the first half of the seventeenth century. Thus when in 1619 the Bohemians offered their crown to the German Protestant leader, Frederick of the Palatinate, he accepted because, he claimed, it ‘is a divine calling that I must not disobey. My only end is to serve God and his Church’. A similar confidence motivated Frederick's brother-in-law Charles I, who steadfastly refused to negotiate with his rebellious subjects because, as his wife Henrietta Maria put it in a confidential letter of 1642, on the eve of the English Civil War, ‘This is no longer mere play. You must declare yourself; you have testified your gentleness enough, you must show your justice. Go on boldly: God will assist you.’ The king complied. A few months later he informed a close colleague that ‘no extremity or misfortune shall make me yield, for I will either be a glorious king or a patient martyr’. Even after his catastrophic military defeat at Naseby in 1645 Charles refused a suggestion that he should seek the best terms possible from his adversaries because")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("If I had any other quarrel but the defence of my religion, crown, and friends, you had full reason for your advice; for I confess that, speaking either as a mere soldier or statesman, I must say that there is no probability but of my ruin. Yet as a Christian, I must tell you that God will not suffer rebels and traitors to prosper, or this cause to be overthrown … A composition with them at this time is nothing else but a submission, which, by the grace of God, I am resolved against, whatever it cost me; for I know my obligation to be, both in conscience and honour, neither to abandon God's cause, injure my successors, or forsake my friends."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-41",
      "id": "nr2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Charles continued to reject all compromise until, on 30 January 1649, he became a ‘martyr'; yet even from the grave he continued to claim divine sanction for his actions. A posthumous volume of his prayers and meditations on recent events, "), _c('i', [_vm._v("Eikon Basilike")]), _vm._v(" (‘The king's image’), circulated almost immediately, with a frontispiece that showed the king looking like Christ, putting aside his earthly crown and grasping a crown of thorns as he prayed (Plate 3).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Charles's uncle, Christian IV of Denmark, also stressed his special relationship with God. While championing the Protestant cause in Germany, he claimed to have seen a vision of Christ wearing a crown of thorns and, to make the most of this signal mark of divine favour, the painting commissioned to commemorate it made Jesus look strikingly like Christian himself. In similar vein, the Catholic emperor Ferdinand II claimed that, during the siege of Vienna by his rebellious subjects in 1619, as he knelt in prayer before a crucifix, Christ spoke from the Cross: ‘Ferdinande, non te deseram’ – ‘Ferdinand, I will not desert you’. Shortly afterwards, a contemporary print depicted him as Christ on the Mount of Olives, surrounded by his sleeping noblemen. Many of Ferdinand's contemporaries also had themselves portrayed as characters from the Gospels (Anne of Austria and her son Louis XIV as Madonna and child; and, more remarkably, together with Louis XIII as the Magi); as Old Testament figures (Gustavus Adolphus as Judas Maccabeus; Philip IV as Solomon; Frederick Henry of Orange as David); or as saints (Louis XIII as his ancestor, St Louis; Anne of Austria and her sister-in-law Henrietta Maria of England as Saints Helena and Elizabeth)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-42",
      "id": "nr2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Most Christian rulers admitted only one restraint on their absolute power: like their Ottoman contemporaries, they consulted spiritual experts before taking controversial decisions. Thus in Russia, ‘when discord and warfare break out with neighbouring powers, the tsar at that time consults with the patriarch, metropolitans, archbishops, bishops and with other hierarchs of the prominent monasteries'; while many Catholic rulers routinely asked their confessors to certify that they might ‘in conscience’ adopt a controversial policy. In addition, the kings of France and Portugal created a ‘council of conscience’ to advise them on more complex issues; while other Catholic monarchs periodically consulted theologians. Thus in the 1620s Philip IV asked a ‘committee of theologians’ to decide whether his sister should marry the Protestant Charles Stuart; whether he could send assistance to the French Protestants; whether he might intervene in the Mantuan succession; whether he should send troops into the Valtelline; whether he needed to honour concessions "), _c('a', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("made to rebels; and so on."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-43",
      "id": "nr2-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" Later in his reign, Philip even convened a ‘summit’ of men and women from his European dominions credited with prophetic powers, and asked them for advice on policy. Although he never repeated this experiment, for the next 25 years the king wrote a letter once every two weeks seeking advice and prayers from one of the spirit mediums at the ‘summit’, Sor María de Ágreda, who thus became the most influential woman in Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Secular ministers, too, might try to convince their masters that even the most costly and destructive policies enjoyed divine favour. In a memorial of 1626 that listed the various successes of his ministry, Philip IV's chief adviser the count-duke of Olivares assured his master triumphantly: ‘Sire, God has placed the armed forces of Your Majesty in this situation, with no other assistance or ally. I would be lying to Your Majesty, and a traitor to you, if I claimed that all this stemmed from human provision. No: God alone has done it, and only God "), _c('i', [_vm._v("could")]), _vm._v(" have done it.’ A quarter of a century later, Philip himself attributed his ability ‘to overcome not only my enemies but also storms at sea, epidemics on land and the domestic unrest of the towns of Andalusia’ to the support of ‘God's most mighty hand’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-44",
      "id": "nr2-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Pride and Prejudice")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("It is, of course, possible that early modern rulers used such rhetoric and imagery as propaganda without actually believing it. Queen Christina of Sweden asserted as much in 1649, when she debated with her council whether or not to support English royalists after Charles I's execution. Marshal Jakob de la Gardie argued that, since ‘such a giddy spirit has arisen’ in Europe, rulers of the same faith should support one other; but Christina (still officially a Lutheran) disagreed. ‘People use religion as a pretext,’ she replied, ‘and it is used by us against Calvinists and Catholics alike.’ ‘The Pope, the Spaniards and the rest of the House of Austria have always sought to make use of religion,’ de la Gardie reminded her. ‘Like a raincoat when it's wet,’ the queen quipped. In similar vein, three decades later (and now a Catholic), Christina noted that although princes should allow their confessors ‘to speak freely to us, we must not blindly obey all that they tell us. We must be well aware that it is not always God who speaks to us through them.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-45",
      "id": "nr2-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Such overt cynicism was extremely rare in the seventeenth century. More typical was the providential vision of Philip IV of Spain, who in 1629 told a senior minister that ‘I seek salvation, and want to placate God by obeying His laws and by making sure that others obey them, without exception’ because then, ‘even if misfortunes rain upon us, you need have no fear that they will harm us.’ Therefore, the king explained, ‘I desire the fear of God and executing his commands and doing Justice to be my guiding principle’. He still felt the same three decades later. Upon hearing in 1656 that Britain had joined France, Portugal and the Catalans in making war on him, Philip confided to Sor María de Ágreda that, although ‘The risk is apparent and the distress is greater than any that this Monarchy has ever seen, particularly since we lack the means to withstand even one part of such a great storm’, he intended to keep on fighting because ‘I have firm faith that, unless our sins make us unworthy, "), _c('a', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("Our Lord will deliver us from this great storm without allowing these kingdoms, so loyal to the Catholic Church, to be brought down by heretics.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-46",
      "id": "nr2-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Naturally, a providential vision did not preclude secular motives for waging war. Many seventeenth-century rulers, like their medieval predecessors, saw waging war as a rite of passage to be performed at the outset of every reign. Thus, three months after his accession, when Charles I asked the English Parliament to vote funds for war with Spain, he said ‘I pray you remember "), _c('i', [_vm._v("that this being my first action")]), _vm._v("’ as king ‘what a great dishonor it were both to you and to me’ if it ‘should fail for [lack of] that assistance you are able to give me’. A few years later, when Philip IV heard that Louis XIII had just invaded Italy, he scribbled on a ministerial memorandum that ‘My intention is to get my revenge on France for its recent behaviour’, and to that end ‘I shall be there in person. "), _c('i', [_vm._v("Fame, after all, cannot be gained without taking personal part in some great enterprise")]), _vm._v(". This one will enhance my reputation, and I gather it should not be too difficult.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-47",
      "id": "nr2-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" All three kings – just like their contemporaries Gustavus Adolphus and Charles X of Sweden, Christian IV and Frederick III of Denmark, Emperor Ferdinand III and Tsar Alexei – not only commanded their armies in person but also claimed to relish military life. The same was true of their children. Louis XIV personally participated in over 20 sieges, starting in 1650 when he was 12, and ending in 1692, when he ceded the role to his heir, noting that ‘If my son does not go on campaign every year, he will be totally despised and will lose all respect’. His cousin, the future James II, started the second Anglo-Dutch war in 1664 almost single-handed because, according to his secretary, ‘Having been bred to arms’ he sought ‘an occasion to show his courage on sea as on land’. James eventually ‘broke the measure of those ministers who should otherwise have preserved the peace at any price’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-48",
      "id": "nr2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Several seventeenth-century rulers also advanced strategic arguments to justify starting (or prolonging) their wars. Thus in 1642 the French Court watched a ‘heroic comedy’ in five acts commissioned by Cardinal Richelieu in which ‘Ibère’ (Iberia: Spain) tries to win the love of ‘Europe’ but then, having failed, starts to place shackles on her until ‘Francion’ rushes in, exclaiming")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Europe, it is better to perish than be enslaved.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Liberty must be bought with blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Francion warns Ibère to ‘keep within your just boundaries'; and when Ibère pays no attention, Francion declares")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("In the end we must have war, and I am driven to it")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("Not by ambition but by necessity")]), _vm._v("."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-49",
      "id": "nr2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("‘Necessity’ served to justify many foreign wars. Thus, in 1624, despite much public rhetoric about Britain's dedication to upholding ‘the Protestant cause’ in Germany, a diplomat coldly informed his Palatine counterpart that ‘England has no other interest in Germany apart from the Palatinate; "), _c('i', [_vm._v("it does not matter to them whether all Germany is set in flames, provided they might have the Palatinate")]), _vm._v(".’ The diplomat justified this with a ‘domino theory’: ‘if we lose the Palatinate first, next we "), _c('a', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("lose the Low Countries, then Ireland, and finally ourselves’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-50",
      "id": "nr2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" Spanish ministers constructed a similar ‘domino theory’ to justify their numerous wars. For example, in 1629 they warned Philip IV that ‘once the Netherlands are lost, America and other kingdoms of Your Majesty will also immediately be lost with no hope of recovering them'; a point repeated four years later by a Spanish official in Brussels: ‘If we lose the Netherlands, we will not be able to defend America, Spain or Italy’. A few years later a veteran diplomat extended the argument yet further: ‘We cannot defend the Netherlands if we lose Germany’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-51",
      "id": "nr2-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Spanish troops therefore continued to fight on all fronts until 1648. Sweden's leaders likewise claimed that (initially) invading Germany and (later) occupying large parts of it were essential to Swedish security. ‘Pomerania and the Baltic Coast are like an outwork of the Swedish crown; our security against the Emperor depends on them,’ wrote Chancellor Axel Oxenstierna; Sweden was a fortress ‘whose walls are its cliffs, whose ditch is the Baltic, and whose counterscarp is Pomerania,’ echoed Ambassador Johan Adler Salvius."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-52",
      "id": "nr2-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Failure to retain any territorial gains would imperil national security – so Sweden, too, continued to fight until 1648.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These various factors threatened to eternalize many conflicts. Ending the Thirty Years War required sixty months of negotiations, with scarcely a break; talks to end the Eighty Years War between Spain and the Dutch took twenty months; those to end the Thirteen Years War between Russia and Poland required 31 sessions over the course of a year – and even then ended only in a truce. Such longevity also reflected other factors that tend to prolong all conflicts. First, it is always easier to start than to finish a war. The nobles of Russia made this point in 1652, when Tsar Alexei sought their approval to attack the Ottoman sultan: 'It is indeed easy to pull the sword from the scabbard, but not so easy to put it back when you want, since the outcome of war is uncertain.’ Second, objectives changed. As the clergyman and cryptologist John Wallis observed when he looked back on the English Civil War, its ultimate objectives ‘proved very different from what was said to be at first intended. As is usual in such cases; the power of the sword frequently passing from hand to hand, and those who begin a War, not being able to foresee where it wil end.’ A generation later, another English clergyman noted that ‘the ends that those who begin a war designe to themselves are seldome obtained, but oftentimes that which is contrary thereunto and dreaded by them is brought to pass’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-53",
      "id": "nr2-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Finally, in the seventeenth century as today, the more resources invested, and the more lives sacrificed, the more total victory seems the only acceptable outcome. As Arthur Hopton, Britain's ambassador in Madrid, observed in 1638 concerning Spain's struggle against France:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The end of all these troubles (unless they outlast Time) must be peace, which nevertheless comes on so slowly as I cannot say appearances thereof are visible. That which I "), _c('i', [_vm._v("can")]), _vm._v(" discover is that on both sides they have reason to be weary of the war, and … they would be glad of any good occasion to treat of a peace; "), _c('i', [_vm._v("but they are so entangled on both sides, partly out of jealousy and partly out of avarice, being "), _c('a', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("unwilling to forgo what they have gotten (and indeed have dearly enough paid for) as I find the way to begin a treaty to be very difficult.")])])]), _c('a', {
    attrs: {
      "id": "p45"
    }
  })]), _c('a', {
    attrs: {
      "id": "p45"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("At this point, the war was only three years old. Eight years later, when France's diplomatic delegation in Westphalia asked permission to conclude a settlement, Cardinal Mazarin made much the same point as Hopton. ‘"), _c('i', [_vm._v("After all the many expenditures that the war has cost")]), _vm._v("’, he insisted that his diplomats must ‘find pretexts for delaying the signature of a peace treaty’ in order to ‘profit from the remainder of the campaigning season’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-54",
      "id": "nr2-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In addition, according to another British ambassador in Madrid, the Spaniards ‘are not frendes to part with any thinge they have once gott'; and their rhetoric to postpone peace invoked reputation as often as religion."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-55",
      "id": "nr2-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" A notorious example occurred in 1656 when secret talks with France took place. After three months of hard bargaining, the parties agreed that France would end all assistance to Portugal and in return would retain all its remaining conquests in Catalonia and the Netherlands; but Spain would not abandon the prince of Condé, Louis XIV's cousin, who had defied Mazarin and entered Spanish service (see page 285 below). Philip IV's chief minister, Don Luis de Haro, refused to countenance any peace that failed to restore Condé ‘to the rank, dignities and positions’ that he had previously held. ‘We have considered first the question of honour,’ Haro told a French envoy grandiloquently, ‘and only in second place the conservation of the state, because without honour every state will eventually collapse.’ The war continued for three more years."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-56",
      "id": "nr2-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Finally, negotiating while hostilities continued made peace more elusive because, as Cardinal Mazarin put it in April 1647, each state's demands reflected ‘how much the military situation has changed in our favour recently’. The count of Peñaranda, the chief Spanish negotiator at the Westphalian peace congress, agreed. In June of that year, he informed a colleague: ‘You believe that the war will last many years, but you are entirely mistaken … My lord, the vassals of both kings (of France and Spain) find themselves so exhausted that asking them for more could lead either monarch to complete ruin … Whether we win or lose, we both must have peace.’ News of the revolt of Naples deepened Peñaranda's pessimism yet further: ‘The Naples rising has been widespread. For God's sake, Sir, we have to settle in some way’ with France. Yet one month later, Peñaranda hailed news that the French siege of Lleida had failed as ‘the most important and pleasing news I have ever had in my life because it shows that Our Lord in his mercy smiles upon us and wishes to remove the scourge from us’. He therefore urged the king to fight on. Philip duly obliged."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-57",
      "id": "nr2-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Minorities and Tanistry")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Succession struggles also increased the frequency of civil wars. Early modern states often experienced anarchy whenever a ruler died leaving no capable and universally recognized successor – and minorities proved unusually common in the seventeenth century. France experienced civil war soon after the accession of "), _c('a', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("Louis XIII at the age of nine in 1610, and again after his death in 1643 when he left an heir aged only five. Civil War also broke out in Russia when Tsar Alexei died in 1676 leaving three young sons. On the death of Charles IX (1611), Gustavus Adolphus (1632) and Charles X (1660) of Sweden, each of whom left a minor to succeed them, their nobles swiftly reduced the powers of the crown; while those of Denmark did the same in 1648 when Christian IV died before he could secure parliamentary acceptance for his heir (see chapter 8).")])]), _c('a', {
    attrs: {
      "id": "p46"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("Instability was also endemic in elective Monarchies. Although the House of Habsburg retained the title of Holy Roman Emperor throughout the seventeenth century, the Electoral College only chose Ferdinand II in 1619 after a bitter contest that unleashed the Thirty Years War; and only voted for his grandson Leopold in 1658 after a year of intrigue and bargaining for concessions. Likewise, although Sigismund Vasa and his two sons occupied the Polish throne for almost a century, the death of each monarch gave rise to an interregnum while the federal Diet bargained for concessions before choosing a successor. The Dutch Republic suffered a constitutional crisis in 1650 when, on the death of William II of Orange, the States-General denied the title of Stadholder to his posthumous son; while in Japan the following year, the death of the autocratic Shogun Tokugawa Iemitsu, leaving only a child to succeed him, unleashed plots to overthrow the dynasty. China's Ming dynasty also experienced succession difficulties in the first half of the seventeenth century. The Wanli emperor (1573–1620) refused to recognize his eldest son as his heir, instead intriguing to gain recognition for the claims of another of his offspring; and although the eldest son eventually succeeded, he died shortly afterwards, leaving a young heir who suffered from what today would be called ‘Attention Deficit Disorder’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This instability paled in comparison with the succession disputes that characterized some other Asian dynasties. The distinguished historian Joseph Fletcher observed that nomadic peoples such as the Mongols, as well as dynasties like the Qing, the Mughals and the Ottomans who claimed descent from Mongolian forebears, determined each transition of power through a practice he called ‘bloody tanistry’, after the Celtic practice in which each ruler had a recognized heir (the "), _c('i', [_vm._v("Táinste")]), _vm._v("), who nonetheless had to prove himself by defeating, and often killing, all challengers before assuming the full powers of his predecessor. Tanistry created serious political instability, because everyone took part in succession disputes (there were no ‘civilians’ in nomad societies, only warriors) and so everyone had to guess which of the various potential successors would emerge victorious in the next generation and position themselves accordingly – knowing that those who had supported the victor would monopolize the spoils.")])]), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("Perhaps tanistry made sense on the steppes of Central Asia – because the principal requirement of each clan leader was military talent, Fletcher observed, ‘what better way for a nomadic nation to choose the best qualified scion of their royal clan than to see which son, brother, uncle, grandson, or nephew of the deceased ruler would win the grand khanship in an internal war?’ – but the practice ")]), _c('a', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("often brought more complex states to the brink of extinction."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-58",
      "id": "nr2-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" On the death in 1626 of Nurhaci, ‘great ancestor’ of the Qing, his relatives fought among themselves for several years before a clear successor emerged: his eighth son, Hong Taiji. When he died in 1643, another bitter struggle broke out between his brothers and uncles until the survivors agreed to recognize the late emperor's ninth son, who became the Shunzhi emperor. In the end, half of the sons of Nurhaci who survived to adulthood were executed, forced to commit suicide or posthumously disgraced. When the Shunzhi emperor died in 1661, his only stipulation was that his successor should have already contracted and survived smallpox (the disease that killed him) and for this reason the throne passed to his third son, the Kangxi emperor, although he was only eight years old. For the next decade his ambitious relatives struggled to dominate the regency government.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the seventeenth century, Ottoman sultans sought to avoid such chaos by confining their male relatives within the Istanbul palace in sealed apartments known as the "), _c('i', [_vm._v("kafes")]), _vm._v(" (‘cage’). Even the crown prince rarely left the ‘cage’ to visit the world outside, but immediately after his accession he killed all his male relatives – both siblings and younger sons – in an attempt to avoid succession disputes. The system changed in 1617, when Sultan Ahmad died leaving only two young sons. The Ottoman elite allowed them and Ahmad's brother to live, but in 1622 palace factions murdered a sultan they deemed incompetent. When Ahmad's son Murad IV reached manhood, he executed three of his brothers so that, at his death in 1640, only one male member of the House of Osman survived: his youngest brother Ibrahim, who had never left ‘the cage’. After eight years of erratic rule, he too was murdered, but the Ottoman elite once again allowed all his young sons to live because they were the only surviving male members of the dynasty (four of them would reign; the last of them would be deposed in 1687). These succession protocols may have been slightly less disruptive than the civil wars among male members of the Qing, but they destabilized the Ottoman state all the same."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-59",
      "id": "nr2-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Mughal emperors also faced repeated succession disputes. When Jahangir's heir rebelled the emperor impaled 300 of his supporters alive to form an avenue through which his son had to pass to beg forgiveness, yet a year later the heir conspired against his father again. This time Jahangir had the young man blinded and entrusted to his younger son, Shah Jahan, who himself rebelled in 1622–3. Once again the revolt failed, and once again Jahangir pardoned the miscreant so that Shah Jahan survived to succeed his father when he died a few years later – and promptly had all other male members of his family killed or blinded. This left Shah Jahan and his four sons as the only surviving male members of the dynasty. Each prince built up a powerful following until 1658 when, believing that their father was on the point of death, three of them rebelled and fought a civil war that lasted two years. Aurangzeb, the eventual victor, murdered all his rivals just as his father had done. Later he tried to partition his inheritance, hoping to avoid another succession war, but his ambitious sons refused to accept anything less than the whole empire – and fought each other after he died in 1707 until only one remained.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("The Curse of the ‘Composite State’")])]), _c('a', {
    attrs: {
      "id": "p48"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("Although tanistry never took root in early modern Europe, over half the major seventeenth-century revolts occurred in ‘Composite States’ comprising a well-integrated core territory linked by loose and often contested bonds to other more autonomous regions, some of them far away. These composite states included Denmark (whose monarch also ruled Norway, Greenland, Iceland, Holstein and many Baltic islands) and Sweden (which included Finland, Estonia, Ingria and several Polish enclaves). Similarly, the Russian state included several areas annexed by treaties, many with distinct religious and ethnic groups, even before the annexation of Ukraine and Siberia in the seventeenth century; while the Ottoman empire likewise incorporated territories that contained disparate religious and ethnic groups (above all, Shi'ites, Christians of various creeds and Jews) as well as several provinces with separate legal codes and local traditions (notably the Crimea, the Balkan principalities and the North African states)."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-60",
      "id": "nr2-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" But the most volatile composite states were those created by earlier dynastic unions: the Stuart and Spanish Monarchies, and the lands of the Austrian Habsburgs.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These composite Monarchies were politically unstable for two reasons. First, they owed their origin to repeated endogamy among monarchs, which reduced the gene pool of the dynasty and therefore the viability of their offspring. This seems to have produced both more minorities and more disputed successions. For example, the intermarriage of several generations of his progenitors meant Philip IV of Spain boasted only 8 great-grandparents instead of the normal 16; and after he married his niece in 1649, he became the great-uncle as well as the father of his children, while their mother was also their cousin. This created the same genetic inheritance as the child of siblings, or of a parent and child. Only two of the couple's six children survived infancy, and although their son Carlos II lived to be 39, he was physically deformed, mentally challenged and sterile. His death unleashed a prolonged succession war between the various claimants that resulted in the dismemberment of the Spanish Monarchy."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-61",
      "id": "nr2-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The second weakness of the composite Monarchies lay in the fact that many territories preserved their own institutions and collective identity, sometimes re-inforced by a separate language or a distinct religion. An English pamphlet of 1641 noted the vulnerability of both the Stuart and Spanish Monarchies on this score: the former stood, it argued, on the brink of disintegration ‘because there was not heretofore a perfect union twixt England and Scotland, incorporating both into one body and mind'; while in the latter the same ‘reason has caused Portugal and Catalonia to revolt from the king of Spain’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-62",
      "id": "nr2-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Diversity created instability because every political organism has a distinct ‘boiling point’ – or, as Francis Bacon put it in an essay entitled ‘Of seditions and troubles’: ‘discontentments’ are ‘in the politique body like to humours in the natural, which are apt to gather a preternaturall heat, and to enflame’. When either natural disaster (such as famine) or human agency (such as war), ‘enflame’ the parts of a composite state, it becomes unstable and its ‘discontentments’ soon emerge. Not only was the political ‘boiling point’ unusually "), _c('a', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("low in composite states, it was lowest on their peripheries, making them the least stable component."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-63",
      "id": "nr2-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("At first sight this may seem surprising: after all, global cooling, failed harvests and lethal epidemics affected the core as well as the periphery of each composite state. Indeed, cores often endured more intense government pressure – taxpayers in England and Castile paid far more than their neighbours in peripheral territories – and yet England was the last of Charles I's kingdoms to rebel against him, while (except for Andalusia) Castile did not rebel at all. The paradox has three explanations. First, the core of each state often escaped the worst consequences of war, and thus the full synergy between human and natural disasters. Thus the villages of Castile contributed soldiers and taxes to the wars, and also suffered from extreme weather, poor harvests and high food prices, but most of them remained safe from the devastation of war. Their inhabitants were rarely robbed or raped; troops seldom burnt their property or spread disease; and normally they even escaped billeting. By contrast, at a time of failed harvests and epidemics, the need to feed garrisons as well as the local population created a crisis in frontier regions like Catalonia long before enemy troops wrought further devastation. Second, several parts of Europe's composite states retained not only their own institutions and identity, but also their own economic, defensive and strategic agendas. The priorities of the local elite in Barcelona (as well as in Lima, Mexico, Manila, Naples, Palermo, Milan and Brussels) often differed from those of the imperial government in Madrid (just as the priorities of Edinburgh, Dublin, Jamestown and Boston often differed from those of the central government in London). Third and finally, diversity frequently led to ‘sub-imperialism’. Peripheral parts of each composite state often possessed extensive privileges, permanently guaranteed by the sovereign, and whenever conditions became difficult, whether through war or weather, regional elites invoked their constitutional guarantees (often termed ‘fundamental laws’, ‘charters’ and ‘constitutions’), while the central government sought to override them. Such confrontations could and did lead to rebellion. Thus in 1638, when his Scottish subjects refused to accept a new liturgy mandated by Charles I, the king told one of his ministers that ‘I would rather die than yield to those impertinent and damnable demands’ because ‘it is all one, as to yield, to be no king in a very short time’. The following year, in Spain, the count-duke of Olivares, Philip IV's chief minister, reached the end of his patience with the insistence of the Catalan elite that he must respect their ‘Constitutions’. He exclaimed: ‘By now I am nearly at my wits’ end; but I say, and I shall still be saying on my deathbed, that if the Constitutions do not allow this, then the Devil take the Constitutions.’ In both cases, within a few months intransigence led to armed insurrection."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-64",
      "id": "nr2-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Favourites")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Olivares's insensitivity reflected his distinctive status: he was not only Philip IV's chief minister but also his ‘Favourite’ – a courtier who gained total control of his master's affairs. Favourites abounded across the early modern world and, like "), _c('a', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("minorities and sub-imperialism, their existence made war and rebellion more common. Only the Ottoman empire made the position permanent, in the person of the Grand Vizier. Elsewhere, many Favourites gained a privileged position through the extreme youth of a new ruler: Philip IV and Tsar Alexei came to the throne aged 16; Louis XIV of France succeeded aged four (and only started to exercise his powers at 23). In each case, the monarch relied initially upon a much older man, often a member of his household as heir to the throne, to run the government for them (respectively Olivares, Boris Morozov and Jules Mazarin). Likewise, in China, the Tianqi emperor ascended the throne aged 14 and immediately surrendered his powers to one of the palace eunuchs who had helped to raise him: Wei Zhongxian. But youthful inexperience cannot explain why each ruler continued to rely on their Favourite after (often long after) they became adults, or why the institution (although not new) became so much more common during the first half of the seventeenth century than at any other time."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-65",
      "id": "nr2-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The continued prominence of Favourites is all the more surprising in view of the hatred they provoked. The duke of Buckingham, who dominated policy and patronage under both King James I of Great Britain and his son Charles, was compared with Sejanus, the tyrannical adviser of the Roman Emperor Tiberius – a parallel deeply resented by Charles – and when the duke was murdered in 1628 songs, poems and pamphlets compared the murderer with the biblical David."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-66",
      "id": "nr2-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" The fall and suicide of the eunuch Wei the previous year likewise caused rejoicing throughout China, as did the fall of most Grand Viziers in the Ottoman empire (an event that occurred every four months, on average, in the 1620s). Similar rejoicing would no doubt have greeted the success of any of the numerous assassination plots against Richelieu; or had Tsar Alexei bowed to popular demands and surrendered Morozov to the mob that screamed for his blood in the Kremlin in 1648. According to one of Charles I's more thoughtful English critics, ‘The king's favour is tyrannie, when by that favour a man rules over them in fact, that can plead neither election nor succession to that power'; and, he concluded ruefully, if such men were truly deemed necessary, ‘a king should have more than one Favourite, [because] emulation will make them walke the fairer wayes’. Charles paid no heed."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-67",
      "id": "nr2-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The rise of the Favourites in part reflected the relentless increase in the administrative burdens that weighed upon monarchs. In the aphorism of Queen Christina of Sweden: ‘If you knew how much princes have to do, you would be less keen to be one’. Copies and minutes of some 18,000 letters survive from the office of France's secretary for war between 1636 and 1642, an average of 2,500 a year; but by 1664 the total had risen above 7,000, and by 1689 above 10,000. In the Mughal empire, ‘The state records and documents pertaining to the reign of Shah Jahan (1627–57) must have numbered in the millions'; while, in China, the Shunzhi emperor complained in the 1650s that ‘The nation is vast and affairs of state are extremely complex. I have to endorse all memorials and make decisions by myself without a minute of rest.’ His son, the Kangxi emperor, read and returned 50 memorials on normal days, but when on campaign the total rose above 400. He later recalled that "), _c('a', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("the amount of paperwork generated by a rebellion in 1674 forced him to stay up until midnight."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-68",
      "id": "nr2-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Favourites not only reduced the bureaucratic burden on their masters, they also simplified the process of decision-making by operating outside the traditional institutional channels. Each of them sought to monopolize both the people and the information reaching their master; and to this end they promoted their own relatives and clients, excluding all potential rivals. Cardinal Richelieu built up a network of "), _c('i', [_vm._v("créatures")]), _vm._v(", literally people he had ‘created’: men ‘who would be faithful to him and only to him without exception and without reservation’. The ‘creatures’ worked as a team: whether at court or in the provinces they exchanged information and did each other favours. They also took every opportunity to praise Richelieu to the king and made sure that their advice and proposals coincided with his, since they knew that their own political survival depended on the cardinal monopolizing Louis's confidence. Likewise, in Spain, as Philip III lay dying in 1621, his Favourite the duke of Uceda came face to face with Olivares, who enjoyed the complete confidence of the heir apparent. ‘Now everything is mine,’ Olivares gloated. ‘Everything?’ asked the doomed duke. ‘Yes, without exception,’ Olivares replied. He immediately set about replacing all Uceda's appointees with his own men."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-69",
      "id": "nr2-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The reliance on Favourites promoted revolts and civil dissension for several reasons. First, rival courtiers excluded from power might lose patience and rebel, especially when the fall or death of a Favourite failed to change the status quo. Thus the duke of Híjar in 1648 began to plot against Philip IV not merely through resentment that Olivares had excluded his entire family from power because they had been allies of the duke of Uceda, but also because he had hoped to regain royal favour as soon as Olivares fell – whereas Philip now relied on the late Favourite's nephew, don Luis de Haro, who likewise excluded Híjar from court. Second, discontented subjects who hesitated to challenge the ‘Divine Right of Kings’ found it far easier to justify their disobedience by claiming that the ruler had been deceived by his wicked ministers; and the cry ‘Long live the king; down with the evil ministers!’, common in earlier rebellions, became a constant refrain in the mid-seventeenth century because the monopoly of power by a Favourite made it all the more plausible. Ming scholar-officials claimed that the orders issued by Wei Zhongxian lacked imperial sanction; opponents of Philip IV in Portugal and Catalonia claimed that they strove to free the king from the snare or satanic spell cast by Olivares; opponents of both Tsar Alexei and King Charles I demanded the sacrifice of unpopular ministers who, they claimed, had bewitched their master.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Absolutism and the ‘willingness to wink’")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Circumventing the checks and balances of traditional governments encouraged ‘mission creep’ on the part of the state. As Sheilagh Ogilvie has astutely observed, the new style of absolutism introduced by monarchs and their Favourites in the mid-seventeenth century ‘affected more than taxation and warfare’:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("The administrative instruments developed for "), _c('i', [_vm._v("these")]), _vm._v(" purposes could also regulate activities previously inaccessible to government, and they could offer redistributive services to a wide range of favoured groups and institutions. Resistance to these "), _c('i', [_vm._v("new")]), _vm._v(" forms of redistribution, and competition to control them, were central elements in the ‘crisis’ of the mid-seventeenth century.")])]), _c('a', {
    attrs: {
      "id": "p52"
    }
  })]), _c('a', {
    attrs: {
      "id": "p52"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("Whereas the traditional bureaucracy of most early modern states contained mechanisms (however rudimentary) by which subjects could legally protest (however deferentially), the ‘alternative administrations’ invented by Favourites – whether Buckingham, Richelieu, Olivares, Morozov or Wei – brooked no challenge. The imposition of government initiatives by proclamations, often resurrecting or extending a ‘regalian right’, enforced by royal judges with instructions to stifle any opposition in the courts, left those affected without legal redress. Everywhere, ‘absolute’ rulers displayed both inflexibility and ruthlessness in enforcing "), _c('i', [_vm._v("all")]), _vm._v(" government policies – not just those related to war."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-70",
      "id": "nr2-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("David Cressy has explained this phenomenon brilliantly in the context of Stuart England. Whereas the officials of James I ‘were inclined to avert their gaze from local difficulties,’ he has written, those of his son Charles ‘went looking for trouble’. England, like most (if not all) early modern states, was rife with conflicts; but until the 1630s ‘these conflicts were continually being resolved or mitigated by an overriding insistence on peace’. ‘The famed “consensus” of Jacobean England consisted not in mutual agreement on issues but rather a determination to prevent divisive issues from disrupting the body politic. It was a social rather than an ideological consensus, and it worked by winking at the gap between theory and practice.’ In the 1630s this ‘willingness to wink’ disappeared. Instead, Charles and his ministers (especially his bishops) developed a ‘remarkable gift for seeing mild irregularity as intransigence, moderate nonconformity as sectarianism, and all disagreement as refractoriness or rebellion’. Eventually, ‘in forgetting how to wink they tore the country apart’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-71",
      "id": "nr2-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" By way of example, Cressy cited the insistence that women wear veils when they came to church for the first time after giving birth; the demand that ministers make the sign of the cross at every baptism; and the requirement that communion tables in the centre of the church give way to altars at the east end. Earlier generations had regarded each of these as ‘trifling matters’ or ‘things indifferent’ and so, over time, each parish had developed its own ritual to which the congregation became strongly attached. Then, in the 1630s, the central government proscribed all three former practices (along with many others) and excommunicated those who would not conform, measures that affected literally thousands of churchgoers each year. Therefore, when the need to pay for war forced Charles in 1640 to return to the traditional institutional channels and summon Parliament, he faced an avalanche of grievances that paralysed the transaction of public business.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Some Asian rulers also seem to have gone ‘looking for trouble’ on matters previously regarded as peripheral. Sultan Murad IV forbade both smoking tobacco and drinking coffee throughout the Ottoman empire and had many offenders executed. A seventeenth-century ruler of Borneo forbade his subjects to")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("Dress like people from abroad, such as the Hollanders, the people from Keiling, the Biadju, the Makassarese, the Buginese. Let no one follow any of the Malay dressing customs. If foreign dressing-customs are followed this will unavoidably bring misery over the country where this is done … [There will be] disease, much intrigue and food will become expensive because people dress like those in foreign countries."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en2-72",
      "id": "nr2-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Most spectacular of all, in China, the Qing insisted that all their male subjects shave their forelocks, braid the rest of their hair in a pigtail, and adopt Manchu dress, on pain of death. Initially, the head-shaving edict made sense because it immediately distinguished friend from foe: the long hair of Ming loyalists could be shorn in a few minutes. Shaving the forelocks therefore seemed a perfect test of loyalty; but it also created constant provocation because compliance required constant repetition as each man's hair grew. Nevertheless the Qing refused to back down and instead decreed ‘Keep your head, lose your hair; keep your hair, lose your head’ (chapter 5 below).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Not one of these contentious issues – wearing a veil at the ‘churching of women’, smoking tobacco, dressing like Dutchmen, head-shaving and so on – threatened the integrity or security of the state; and not one of them arose from the problems created by the Little Ice Age. With goodwill, statesmanship, or just the ‘willingness to wink’, each of them could have been peacefully resolved; but the exalted rhetoric and claims of those leaders who believed in the Divine Right of Kings or the Mandate of Heaven prevented such an outcome. On the contrary, they produced crises out of trifles and exacerbated tensions created by more serious problems, thereby increasing the sum of human misery.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Untangling the connections between these distinctive and disruptive aspects of seventeenth-century government (Divine Right, Tanistry, Composite States, Favourites and Absolutism), and the increased frequency of war and rebellion, is nevertheless complicated by two factors: contingency and feedback loops. Thus, a well-informed English minister later believed that the Anglo-Dutch war that began in 1664 ‘arose by strange accidental things concurring from several parts and parties without any intent to help each other’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en2-73",
      "id": "nr2-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Documenting feedback loops is more difficult, but the success of Favourites in removing checks and balances made it easier for monarchs to go to war; while war made Favourites more necessary, because monarchs needed to curtail checks and balances in order to extract more resources. A similar feedback loop existed between war and rebellion. On the one hand, interstate war frequently caused intrastate rebellions by driving governments to extract resources from their subjects more aggressively. On the other hand, intrastate rebellions could turn into interstate wars when alienated subjects secured foreign intervention. It is therefore impossible to assert that one aspect was always the cause while the other was always the effect: the relationship between them varied according to time and place.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, one part of the feedback loop remained constant: war seemed uniquely capable of uniting opponents of a regime. The imperative to ‘feed Mars’ "), _c('a', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("eventually led governments to impose burdens on every social group and all geographical regions, which often alienated everyone at the same time. To be sure, the heaviest burdens normally fell on the lower ranks of each state, but governments desperate to win a war also trampled on the rights of those with corporate rights such as cities, nobles and clergy in their efforts to extract resources, and upon certain regions that the Little Ice Age rendered particularly vulnerable.")])]), _c('a', {
    attrs: {
      "id": "p54"
    }
  })])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("3")])]), _c('a', {
    attrs: {
      "id": "p55"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("‘Hunger is the greatest enemy’: The Heart of the Crisis")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p55"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("N ONE OF HIS CELEBRATED")]), _vm._v(" "), _c('i', [_vm._v("E")]), _c('span', {
    staticClass: "fsc"
  }, [_c('i', [_vm._v("SSAYS")]), _vm._v(", PUBLISHED EARLY IN THE SEVENTEENTH")]), _vm._v(" century, the English politician and philosopher Francis Bacon warned rulers to ensure that their subjects, unless ‘mowen downe by wars, "), _c('i', [_vm._v("doe not exceed the stock of the kingdome that should maintain them")]), _vm._v("’, because a prolonged imbalance between the production and consumption of food sooner or later produces famine, disruption and revolt."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-1",
      "id": "nr3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Subsequent writers agreed. In 1640 a historian ‘embedded’ with the army of Philip IV as it passed through the drought-parched fields of Catalonia noted ominously: ‘Amid the distress to which human misery reduces us, "), _c('i', [_vm._v("there is almost nothing men would not do")]), _vm._v("’. Seven years later, the minister responsible for law and order in Castile warned his master that ‘The population [of Madrid] is very volatile and every day becomes more insolent … because "), _c('i', [_vm._v("hunger respects no one")]), _vm._v(" ["), _c('i', [_vm._v("la ambre a ninguno respecta")]), _vm._v("]. The people are so licentious that no day is safe’ from the threat of violence. In case Philip missed the point, other ministers reminded him that ‘"), _c('i', [_vm._v("Hunger is the greatest enemy")]), _vm._v(". Even the most frugal person cannot cope with it … and in many states the shortage of bread has provoked unrest that ended in sedition’. In 1648, as several Italian towns faced the worst harvest of the century, officials reported ‘murmurs among the people saying that “"), _c('i', [_vm._v("it was always better to die by the sword than to die of hunger")]), _vm._v("”’; while in London ‘the cryes and teares of the poore, who professe they are almost ready to famish’ led some to fear that ‘"), _c('i', [_vm._v("a sudden confusion would follow")]), _vm._v("’. Finally in Scotland, during the last famine of the century, an acute observer reminded his compatriots that ‘Poverty and want emasculate the mindes of many, and make those who are of dull natures, stupid and indisciplinable’, whereas ‘those that are of a firy and active temperament, it maketh them unquiet, rapacious, frantick or desperate. Thus, "), _c('i', [_vm._v("where there are many poor, the rich cannot be secure in the possession of what they have")]), _vm._v(".‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-2",
      "id": "nr3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, although the Little Ice Age afflicted almost the entire northern hemisphere, some areas suffered more than others. This should cause no surprise. Europe west of the Urals covers four million square miles, ranging from arctic to subtropical and containing hundreds of ethnic, cultural, economic and political divisions: naturally, developments did not take place uniformly in all regions. Even within Spain, different areas suffered at different times. Galicia in the northwest and Valencia in the southeast experienced population decline from about 1615 to the 1640s; but in the centre, although the decline around Toledo also began in 1615, it "), _c('a', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("lasted until the 1670s, while around Segovia, where the decline also ended in the 1670s, it began only after 1625. Ming China, covering 1.5 million square miles, and also ranging from subarctic to tropical conditions, likewise experienced the Little Ice Age in many different ways. Thus low-lying Shandong in the northeast often experiences both droughts and floods, so that the province rarely generates a surplus – let alone a reserve on which to draw in bad years. Urgent petitions calling for food loans and tax relief therefore emanated from Shandong on an almost annual basis, in the seventeenth century as at other times. By contrast Sichuan province in the west enjoys a mild climate which in most years permits abundant crops of rice, wheat, cotton, sugar, silk and tea – thus reducing vulnerability to global cooling.")])]), _c('a', {
    attrs: {
      "id": "p56"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("Amid the diversity, three broad economic ‘zones’ stand out as particularly exposed to climate change: marginal farming lands; cities; and macro-regions. Marginal lands were vulnerable because they produced enough to feed all their inhabitants only during years of optimal harvests. Cities, by contrast, were vulnerable because their prosperity made them strategic targets, which in turn led to the construction of a fortified perimeter that promoted overcrowding, poor hygiene and the spread of diseases inside the walls and, in wartime, exposed the inhabitants to the risk of extensive human and material damage. Finally ‘macro-regions’ – complex regional economies consisting of several adjacent towns and their overlapping hinterlands – were vulnerable because their prosperity rested on the ability to import the food on which their population depended and to export the specialized goods which they produced. Disruption of either activity, whether at home or abroad, caused almost immediate hardship.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Although the inhabitants of these three economic ‘zones’ formed a small minority of the global population, they featured disproportionately in the Global Crisis. On the one hand, they suffered earlier, longer and more intensely than others, because government policies exacerbated to a unique degree the disruption created by climatic adversity and overpopulation; on the other hand, they harboured a large number of articulate men and women eager to publicize their predicament at home and, whenever they could, abroad. These voices resonated longer and louder than those of others whose experiences may have been more typical.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Agriculture on the Margin")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("For most of the sixteenth century, warmer weather permitted the expansion of farming throughout the northern hemisphere and a good part of this process took place on lands already close to the limits of viable cultivation. The farmers who cultivated these lands initially reaped spectacular harvests, thanks to the nitrogen and phosphorus that had accumulated in the earth during the centuries when they lay fallow; but once this natural bounty expired, even in ‘good’ years they became trapped in a high-risk, high-input, low-yield operation that required constant attention to produce even a mediocre crop. In northerly latitudes, as noted in chapter 1, each fall of 0.5°C in the mean summer temperature decreases the number of days on which crops ripen by 10 per cent, doubles the risk of a single harvest failure, and ")]), _c('a', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("increases the risk of a double failure sixfold. Moreover, for those farming 1,000 feet or more above sea level, a fall of 0.5°C in the mean summer temperature increases the chance of two consecutive failures a hundredfold.")])]), _c('a', {
    attrs: {
      "id": "p57"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("This cruel calculus applies throughout the northern hemisphere. In Scotland, where the majority of all farmland is marginal, the benign climate of the sixteenth century encouraged the cultivation of fields at higher altitudes and on poorer soils than before, but the cold and wet summers of the 1640s, which drove down mean temperatures by up to 2°C, brought disaster. In the Lammermuir Hills near the English border, three-quarters of the farms were abandoned; while on the Mull of Kintyre, in the west, four-fifths of all townships were abandoned because ‘Farmers were not able to plant nor crofters to dig. The corn when it came up did not ripen … People and cattle died, and Kintyre became almost a desert‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-3",
      "id": "nr3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/#fig_05"
    }
  }, [_vm._v("Fig. 5")]), _vm._v("). In southern Europe, Sicily saw the foundation of some 70 ‘new towns’ in the sixteenth and early seventeenth centuries, specifically to produce grain for the fast-growing cities of the island. At first many farmers harvested up to ten grains for each grain of wheat sown, and more than ten for each grain of barley sown, but the extreme weather of the 1640s drove yield ratios down on some lands of the new towns to 1:2 – a reduction of 80 per cent, and the lowest recorded in the entire early modern period. Leonforte, one of those new towns, grew from zero to over 2,000 inhabitants between 1610 and 1640, but the drought of 1648, which produced the poorest harvest ever recorded, brought catastrophe. The town's parish register recorded 426 burials but only 60 births."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-4",
      "id": "nr3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig_05"
    }
  }, [_vm._v("5. Farms in south-east Scotland abandoned in the seventeenth century."), _c('br'), _vm._v("Fourteen of the fifteen farmsteads that existed in the Lammermuir hills (south-east Scotland) in 1600 had disappeared by 1750, and three-quarters of the cultivated land reverted to permanent moorland. Global cooling, which increased the number of failed harvests, bears part of the blame, but the troops crossing between Scotland and England during the Civil War between 1639 and 1660 also contributed to the general insecurity of the region.")])]), _c('a', {
    attrs: {
      "id": "fig_05"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_05"
    }
  }), _c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("Clearing fields for cultivation led to a pernicious practice that could soon make even the most fertile land marginal: clear-cutting forests. A historian living in Shaanxi province in northwest China recalled that ‘flourishing woods’ used to cover its hills so that rainfall flowed down in gentle streams, and villagers cut ‘canals and ditches which irrigated several thousand [acres] of land’. But as prosperity in the region grew,")])]), _c('a', {
    attrs: {
      "id": "p58"
    }
  }), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p58"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("People vied with each other in building houses, and wood was cut from the southern mountains without a year's rest. Presently people took advantage of the barren mountain surface and converted it into farms. Small bushes and seedlings in every square foot of ground were uprooted. The result was that if the heavens send down torrential rain, there is nothing to obstruct the flow of water. In the morning it falls on the southern mountains; in the evening, when it reaches the plains, its angry waves swell in volume and break through the embankments, frequently changing the course of the river."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-5",
      "id": "nr3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("New and old farms alike ceased to be viable.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The ‘urban graveyard effect’")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Although the decision to give up a farm – for whatever reason – is always heart-wrenching, the Little Ice Age forced many farmers on marginal lands to flee to the towns with their families in the hope of finding work or at least bread. Most of them met with bitter disappointment, in part because their flight helped to fuel unsustainable urban expansion.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The mid-seventeenth century was a ‘metropolitan moment’: never before had so many people lived in such close proximity. Beijing, the largest city in the world, had in excess of one million inhabitants, with almost as many in Nanjing. Six other Chinese cities numbered 500,000 citizens or more, while a score had 100,000 or more. Mughal India, the most urbanized area in the world after China, included three cities with 400,000 or more inhabitants and another nine with over 100,000. By 1650, 2.5 million Japanese, perhaps 10 per cent of the total population, lived in towns. By contrast, in the Americas, only Mexico and Potosí (the silver-mining centre of Peru) exceeded 100,000 inhabitants; while Africa's only metropolis was Cairo, with perhaps 400,000 residents. In Europe, the population of Istanbul, the capital of the Ottoman empire, may have approached 800,000, but no other city came close: only London, Naples and Paris exceeded 300,000. Ten other European cities numbered 100,000 inhabitants or more, while in Holland over 200,000 people lived in ten towns within a 50-mile radius of Amsterdam.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Every one of these metropolitan areas required prodigious quantities of housing, fuel, food and fresh water, as well as schemes to manage traffic, fight fires and keep "), _c('a', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("public spaces clean. Failure to provide these essential services created the ‘urban graveyard effect’. In the 1630s William Ince, a Dublin preacher, delivered a sermon that poured scorn on the desire of Abraham's brother Lot (in the Book of Genesis) to flee from Sodom to another city, where he hoped to find ‘plentie, societie, and safetie’, believing that in a ‘Citie all these three concurre to make life securely happy’, whereas, in fact, Ince reminded his audience, Lot found that urban living brought only ‘povertie and solitarienesse’. And, indeed, as the French social historian Jean Jacquart observed, all early modern cities were ‘a "), _c('i', [_vm._v("mouroir")]), _vm._v(", a demographic black hole, accounting for disproportionately fewer marriages, fewer births and more deaths’. In London, which preserves particularly precise demographic records, burials in the seventeenth century were often twice as numerous as baptisms and both maternal and infant mortality were particularly high. Only massive immigration from other communities prevented major cities from shrinking in size, which meant that each capital exerted a pronounced ‘dampening’ effect on the population of the kingdom as a whole"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-6",
      "id": "nr3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/#fig_06"
    }
  }, [_vm._v("Fig. 6")]), _vm._v("). As early as 1616, King James I predicted with alarm that ‘all the country is gotten into London, so as, with time, England will only be London, and the whole country be left waste with everyone living miserably in our houses, and dwelling all in the city’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-7",
      "id": "nr3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig_06"
    }
  }, [_vm._v("6. The ‘dampening effect’ of London on England's overall demographic growth."), _c('br'), _vm._v("Although other areas of England registered a surplus of some 120,000 births over deaths between 1650 and 1674, London accrued a deficit of 228,000 over the same period and only strong immigration allowed the capital to keep growing.")])]), _c('a', {
    attrs: {
      "id": "fig_06"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_06"
    }
  }), _c('a', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("One of King James's subjects, Ben Jonson, published a satirical poem about the ‘urban graveyard effect’ created by the shortage of shelter, food and water, as seen through the eyes of a brave trio who travelled through the sewers of London, where")])]), _c('a', {
    attrs: {
      "id": "p60"
    }
  }, [_c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Hung Stench, Diseases, and old Filth, their Mother,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With Famine, Wants, and Sorrows many a Dozen,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The least of which was to the Plague a Cozen.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But they unfrighted pass, tho’ many a Privy")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Spake to them louder than the Ox in "), _c('i', [_vm._v("Livy")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("According to Jonson's contemporary James Howell, Paris was no better: it ‘is alwayes dirty, and ‘tis such a dirt, that by perpetual motion is beaten into such black onctious oyl, that wher it sticks no art can wash it off’. In addition, ‘besides the stain this dirt leaves, it gives also so a strong scent, that it may be smelt many miles off, if the wind be in one's face as he comes from the fresh air of the countrey. This may be one cause why the plague is alwayes in som corner or other of this vast citie, which may be call'd, as once Scythia was, "), _c('i', [_vm._v("Vagina populorum")]), _vm._v("’. Another contemporary, Xie Zhaozhe, made much the same complaints about Beijing:")])]), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p60"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("The houses in the capital are so closely crowded together that there is no spare space, and in the markets there is much excrement and filth. People from all directions live together in disorderly confusion, and there are many flies and gnats. Whenever it becomes hot it is almost intolerable. A little steady rain has only to fall and there is trouble from flooding. Therefore malarial fevers, diarrhoea and epidemics follow each other without stopping."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-8",
      "id": "nr3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Of course, city-dwellers at virtually all times and in virtually all places have made similar complaints; but in the mid-seventeenth century the problems they faced intensified. For example, by the 1630s population and building densities in the City of London both reached levels that ‘have probably not been witnessed in Britain either before or since’. In some parishes, almost 400 persons squeezed into each acre, many of them living in six-storey houses, in one case with ‘six rooms let to sixty-four persons’ (an average of 11 per room). At least 30 per cent of London households lived at or below the poverty line."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-9",
      "id": "nr3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In many seventeenth-century cities, growing dependence on fossil fuels created new problems. Any disruption in supply soon produced general misery. Beijing welcomed the Manchu invaders in 1644 in part because they promised to restore the supply of coal from Shanxi on which householders and industrialists alike depended, disrupted for two years by civil war. Likewise, when that same year military operations interrupted the supply of Tyneside coal required by London's industries, an observer predicted ‘there will be riots this winter’. However, fossil fuels damaged the health of city-dwellers through pollution. In 1656 the English poet Sir William Davenant published an ‘entertainment’ that complained that in London ‘the plentiful exercise of your chimneys makes up that canopy of smoke which covers your city’ and included a song that began:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("London is smother'd with sulph'rous fires.")])]), _c('a', {
    attrs: {
      "id": "p61"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Still she wears a black hood and cloak")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Of sea-coal smoak")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("As if she mourn'd for brewers and dyers."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-10",
      "id": "nr3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Since the sea-coal used by brewers, dyers and other manufacturers contained twice as much sulphur as that used today, its smoke darkened the air, dirtied clothes and curtains, stunted trees and flowers, blackened buildings and statues, and choked and killed the inhabitants. In an early condemnation of air pollution, published in 1661, John Evelyn compared the ‘columns and clouds of smoke which are belched forth from the sooty throats’ of London's chimneys with ‘the picture of Troy sacked by the Greeks’. The capital's inhabitants, he claimed, ‘breathe nothing but an impure and thick mist accompanied by a fulginous and filthy vapour’. Ladies used ground almonds to clean their complexion, while preachers in churches had to compete with the constant coughing and spitting of their congregations."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-11",
      "id": "nr3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The situation was even worse in those Dutch towns where industrial plants burned peat for brewing, dyeing, soap factories and brick kilns, because (although far cheaper than coal) peat created toxic fumes.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The presence of industrial enterprises in the heart of cities greatly increased the risk of fire; so did the use of wood and other flammable material to build cheap and shoddy high-density housing for the influx of immigrants. In East Asia, the use of wood not only for residences and shops but also for temples, government offices and covered markets further increased the risk; so did the use of palm and bamboo for roofs and floors and the practice of cooking on an open brazier, using oil lamps for light, and setting off fireworks during celebrations. Even the occupants of stone and brick temples, tombs, fortresses and merchant warehouses remained nervous. ‘Oh, this word "), _c('i', [_vm._v("fire")]), _vm._v("!’ wrote an English merchant in Java. ‘Had it been spoken near me, either in English, Malay, Javanese or Chinese, although I had been sound asleep, yet I should have leaped out of my bed.’ He recalled that while the merchants slept, ‘our men many times have sounded a drum at our chamber doors and we never heard them; yet presently after, they have but whispered to themselves of "), _c('i', [_vm._v("fire")]), _vm._v(" and we all have run out of our chambers.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-12",
      "id": "nr3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("As Christopher Friedrichs has noted: ‘Of all the elements, it was not earth, water or air that most persistently threatened the well-being of the early modern city. The most dangerous element was fire’ – and, in the mid-seventeenth century, major fires became both more frequent and more destructive. A ‘gazetteer’ of accidental urban fires in England listed over one hundred between 1640 and 1689, at least ten of which consumed over a hundred buildings. London experienced so many fires in 1655 that many thought they presaged the Last Judgement; while six years later, when faced after the Sunday sermon for the fifteenth consecutive week with pleas for charity from those whose homes had burned down, Samuel Pepys became irritated and ‘resolve[d] to give no more to them’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-13",
      "id": "nr3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" He changed his mind in 1666, when the ‘Great Fire’ of London destroyed St Paul's Cathedral, the Guildhall, the Royal Exchange, 84 churches and 13,000 houses, leaving 80,000 people homeless and "), _c('a', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("causing £8 million of damage. Although Londoners blamed the Lord Mayor, who had initially jested that ‘a woman might piss it out’ and failed to create fire breaks, the true culprit was the climate: after an unusually hot and dry spring, temperatures in the summer of 1666 rose 1.5°C above normal, and a precipitation shortfall of 6 inches turned London into a tinderbox. The same conditions prevailed in much of north-western Europe, giving rise to fires in a score of German cities. Only the spectacular destruction of so much of London has overshadowed the frequency of urban fires elsewhere in 1666."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-14",
      "id": "nr3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig_07"
    }
  }, [_vm._v("7. The fires of Istanbul 1600–1700."), _c('br'), _vm._v("Three maps show the areas of the Ottoman capital destroyed by fire in 1600–50, 1650–75 and 1675–1700. Note that the third quarter of the century experienced the worst damage, with major conflagrations in 1652, 1660, 1665 and 1673.")])]), _c('a', {
    attrs: {
      "id": "fig_07"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_07"
    }
  }, [_vm._v("London was not the only capital city where unusual drought in the mid-seventeenth century produced a ‘Great Fire’. In Moscow in 1648, after several months without rain, ‘within a few hours more than half the city inside the White Wall, and about half the city outside the wall, went up in flames'; while a large part of the new Mughal capital Shahjahanabad (now Delhi) burnt down in 1662. Istanbul suffered more (and more devastating fires) in the seventeenth century than in any other period of its history: one in 1660, once again after a prolonged drought, burned down 280,000 houses and several public buildings"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-15",
      "id": "nr3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/#fig_07"
    }
  }, [_vm._v("Fig. 7")]), _vm._v("). Major blazes also regularly devastated Edo, the largest city in Japan, notably the Meireki fire of 1657 – which, like those in Moscow in 1648, Istanbul in 1660 and London in 1666, broke out after an abnormal drought. Three separate "), _c('a', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("conflagrations combined to destroy three-quarters of Edo, including 50,000 homes of merchants and artisans, almost 1,000 noble mansions and over 350 temples and shrines. Even the shogun's magnificent new castle, the tallest building in Japan, ‘which can be compared to one of the largest walled cities in Europe, has been completely destroyed by this horrendous fire’. Perhaps 160,000 people died. In the words of a Japanese contemporary account: ‘When the fire drew upon them, burning up completely all that was near at hand, some people could no longer bear the heat and they formed themselves into a human shield to try to ward off the fire, but they were choked by the billowing smoke. Others were consumed by the fire, their limbs burned to ashes.’ A Dutch eyewitness described how ‘with horror and dread I saw this immense city ablaze, like Troy'; and how, the next day, ‘passing through the streets’, he saw ‘innumerable burnt people, either completely or partly consumed, of which at least a third were small children, spread all over and lying dead on each other’. He also captured the desolation in a striking painting that showed empty city blocks, charred trees and scores of dead bodies in the streets"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-16",
      "id": "nr3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" (Plate 4). No sooner had rebuilding commenced than another major fire ‘destroyed an area about 1.5 miles in circumference’, followed by a third in 1661 and a fourth in 1668 which ‘devoured so many houses of nobles and civilians that it is estimated that two-thirds of the city of Edo has been destroyed’. According to one Dutch visitor, ‘it seems that it has become customary for that all-consuming element (fire) to rage there around Japanese New Year’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-17",
      "id": "nr3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It is possible to demonstrate the extraordinary intensity of the four Edo fires of the mid-seventeenth century. A ‘core’ of earth excavated in 1975 at a building site in Hitotsubashi, not far from the shogun's castle, revealed three prominent layers of ash. The most recent, representing the firestorm caused by the bombing of Tokyo in 1945, measured 4 inches; the second, caused by the fire that followed the Kanto earthquake of 1923, measured 6 inches; the third, representing the fires of the mid-seventeenth century, measured 8 inches. The fact that the burned debris from 1657–68 was twice as thick as that created by the most advanced pyrotechnics of the twentieth century is both striking and sobering."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-18",
      "id": "nr3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("All these urban fires were apparently accidental; many more occurred because of wars. Thus during the 1640s, although 13 English towns experienced ‘accidental’ fires, soldiers deliberately caused at least 80 more, some of them large (over 80 houses destroyed in Birmingham and almost 250 in Gloucester, both in 1643). War also destroyed towns in other ways: constructing or extending fortifications, preparing for a siege, and fire from siege artillery brought down many buildings. At Exeter, the third largest city in England, between 1642 and 1646 the defenders deliberately razed all the suburbs, where one-third of the pre-war population had lived, while bombardment during two sieges left ‘whole streets converted to ashes’. Although Exeter successfully resisted capture, it did not attain its pre-war extent for 60 years."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-19",
      "id": "nr3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The prevalence of war meant that every urban space needed walls – indeed, the Chinese character most commonly used for ‘city’ ("), _c('i', [_vm._v("cheng")]), _vm._v(": "), _c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/page_63.jpg"
    }
  }), _vm._v(") literally signifies ‘city walls’ because it is made up of the characters that signify ‘earth’ ("), _c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/page_63a.jpg"
    }
  }), _vm._v(") plus ‘complete’ "), _c('a', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("("), _c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/page_64.jpg"
    }
  }), _vm._v(") – but they did not always save the community within. Mainz, in western Germany, which surrendered without a struggle in 1631, over the next five years lost 25 per cent of its houses, 40 per cent of its population and 60 per cent of its wealth while it served as the headquarters of the Swedish expeditionary force. Although its massive walls allowed Pavia (Lombardy) to withstand an eight-week siege in 1655, success still ruined the city: lack of demand destroyed its industries; buying flour before and subsidizing bread prices during the siege bankrupted its treasury; and the besiegers’ destruction of all municipal assets beyond the walls seriously impeded economic recovery. Nonetheless, Mainz and Pavia were lucky: cities taken by force during the mid-seventeenth century suffered far greater losses and might take over a generation to recover. The siege and sack of Mantua in 1629 reduced its population from 29,000 to 9,000; by 1647 it still had only 15,000 inhabitants and in 1676 only 20,000. The population of Warsaw, the capital of the Polish-Lithuanian Commonwealth, numbered perhaps 30,000 in the 1630s (and up to 100,000 whenever the Diet met there), but this fell below 6,000 after occupation by Transylvanian and Swedish forces in 1655–7. They also left over half its buildings ruined."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-20",
      "id": "nr3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Perhaps the worst man-made urban catastrophe of the period occurred in 1642 when, after a siege that lasted a year, the Chinese rebel leader Li Zicheng decided to force the surrender of Kaifeng (capital of Henan province) by breaching the dikes on the nearby Yellow river. By a fateful coincidence, at exactly the same time the defenders broke another set of dikes hoping to flood Li's encampment and thus drive him off. According to a contemporary, water from both breaches poured through one of the city's gates, creating floods that ‘suddenly rose twenty feet’. The following day Li sent men into the city on boats in search of ransoms and plunder, but they found not a living soul."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-21",
      "id": "nr3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Floods also contributed to the ‘urban graveyard effect’. Because many cities grew up beside rivers and lakes, even without military intervention higher precipitation could cause immense flood damage. The worst inundation in the history of Mexico City occurred in 1629, when a combination of torrential rains and inadequate drainage caused the surrounding lakes to rise suddenly, submerging considerable parts of the city for five years. The catastrophe led some to consider relocating the capital, and although on this occasion the Spanish central government rejected the option, 30 years later repeated flooding led it to approve abandoning the regional capital of Santa Fé la Vieja, Argentina, and relocating it to higher ground. In Europe, the Seine burst its banks and flooded Paris 18 times in the seventeenth century, with particularly serious inundations in 1649, 1651 and 1658; towns in the low-lying province of Holland suffered even more frequently because storms in the North Sea periodically drove water over or through the dikes (as in 1651, flooding Amsterdam)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-22",
      "id": "nr3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A final cause of the ‘urban graveyard effect’ was the dependence of early modern cities on food produced far away. A Chinese magistrate near Shanghai foresaw with absolute clarity the danger inherent in this situation:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Our county does not produce rice, but relies for its food upon other areas. When the summer wheat is reaching ripeness and the autumn crops are already rising, "), _c('a', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("the boats of the merchants that come loaded with rice form an unbroken line … [But] if by chance there were to be an outbreak of hostilities … such that the city gates did not open for ten days, and the hungry people raised their voices in clamour, how could there fail to be riot and disorder?")])]), _c('a', {
    attrs: {
      "id": "p65"
    }
  })]), _c('a', {
    attrs: {
      "id": "p65"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("His fears turned into reality in 1641–2 when, even without ‘an outbreak of hostilities’, global cooling destroyed the rice harvest throughout South China. Perhaps 500,000 people starved to death and public order collapsed."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-23",
      "id": "nr3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The ‘Palace cities’")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("‘Palace cities’, those with a large population of otherwise unproductive government officials to feed, were most vulnerable because they normally had to import a high proportion of their food, and therefore sought supplies farther afield – and the longer the supply chain, the more susceptible it was to disruption. Thus, every year, huge convoys of barges carried 450,000 tonnes of rice (as well as vast quantities of wheat, millet, beans and other foodstuffs) to Beijing along the Grand Canal, which stretched almost 1,200 miles down to the fertile rice paddies of the Yangzi valley. In 1641 drought in Shandong caused the Grand Canal to dry up (for the only time in its history); while, after 1642, fear of bandit attacks interfered with routine maintenance (dredging, diking and repairing the locks) and disrupted the sailing of the convoys. Since most of the imported rice nourished the 300,000 inhabitants of the Inner City, the failure of the last Ming emperor to feed his own people no doubt contributed to their decision to surrender his capital, scarcely firing a shot, in 1644.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The provisioning of seventeenth-century Istanbul, another ‘palace city’, strikingly resembled that of Beijing. The Ottoman capital imported thousands of sheep and lambs, over 500 cattle and 500 tonnes of bread daily, because the sultan (like the Chinese emperor) needed to feed not only the imperial family, bureaucrats, eunuchs, artisans, guards, merchants, and their households, but also students in the colleges and medreses attached to the imperial mosques. Like Beijing, Istanbul also boasted a proven supply network – Egypt, the Balkans and the lands around the Aegean and Black Seas all regularly sent food to the city, some of it as tribute, just as they had done since Roman times – but this network too was subject to disruption by natural and human agency. Thus in 1620–1, the Bosporus froze over, while in 1641–3 unusually weak Nile floods caused an epic drought in Egypt: both climatically induced events dramatically reduced the supply of food shipped to Istanbul. War likewise disrupted the supply of food: between 1645 and 1658, when enemy fleets repeatedly prevented ships from passing through the Dardanelles, food prices in the Ottoman capital soared. On each occasion, whatever the cause, as in Beijing the households of those normally fed by the state suffered first and most – which helps to explain why palace personnel led the revolts that culminated in regicide in both 1622 and 1648."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-24",
      "id": "nr3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In Madrid, the capital of the Spanish Monarchy, magistrates imposed a daily schedule according to which each nearby village had to deliver a specified amount "), _c('a', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("of wheat to the special granary maintained to feed the court. When supplies dwindled during the disastrous harvest of 1630, the magistrates extended the tribute system to include over 500 communities within a radius of 60 miles. Every house in each of these communities became responsible for providing a fixed share of the court's total requirement of 30 tonnes of wheat a day."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-25",
      "id": "nr3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" In 1647, when ‘the torrential and persistent rain made traffic impossible on the roads to Madrid’, a senior minister warned the king that ‘The stocks of flour have almost run out and people cannot get into the countryside to find dry firewood to heat the ovens. Very few mills still have a wheel that works, because of the floods.’ The city's granaries soon emptied and the minister worried that ‘if the bread supply fails for a single day, instead of the 100 people who are protesting today, Your Majesty will find the entire population in front of the palace’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-26",
      "id": "nr3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" To avert disaster, the government once again unilaterally extended the grain tribute system, rescinded all exemptions, dismissed all appeals from oppressed villages for relief, and sent agents 120 miles and more from the capital to requisition bread. Thanks to these rapid and radical responses, Philip IV never did ‘find the entire population in front of the palace’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-27",
      "id": "nr3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("‘Palace cities’ were not alone in creating a sophisticated but vulnerable supply network. When other urban centres outgrew the capacity of their immediate hinterland to feed them, they too became dependent on distant market forces. Thus the burgeoning populations of the largest port cities around Europe's Atlantic and North Sea coasts (including London, Amsterdam, Antwerp, Lisbon and Seville) depended for their daily bread on importing large quantities of grain from the Polish-Lithuanian Commonwealth, which boasted fertile soil, cheap labour and easy access to water transport. By the early seventeenth century, between 150,000 and 200,000 tonnes of grain came down the Vistula annually for sale at Danzig, where an average of 1,500 ships loaded and shipped it to western Europe. Any interference in this commerce – for example when war broke out between Poland and Sweden in the 1620s, or when the Danish Sound froze over early in 1658 – caused the price of bread immediately to soar in the leading cities of Atlantic Europe, where the poorer members of their populations starved.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The Macro-Regions")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("No early modern settlement was entirely self-sufficient: all of them needed to import at least some items. Even the inhabitants of upland villages isolated for part of each year by winter snows or monsoon rains periodically trudged to the nearest market town to sell handicrafts or surplus agricultural produce and acquire such essentials as salt for food preservation and iron for tools. As population density increased in the sixteenth century, the number of market towns multiplied spectacularly. In China, the number of markets in Zhangzhou prefecture (Fujian) increased from 11 in 1491 to 38 in 1573, and to 65 in 1628. In Japan, market towns in most parts of the coastal plains stood by the 1630s between two and four miles apart; while by then, in England, men and women had to travel an average of only eight miles to the nearest market.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("Markets achieved their greatest density around major cities – in the counties around London, markets were on average less than a mile apart – because they formed part of a zone of economic activity that contained the best arable land, the densest population, the hubs of communication and transport, and the largest capital accumulations. Economists call them ‘macro-regions’. Ming China contained eight macro-regions, each one centred on a river system and separated from the others by natural barriers. The Indian subcontinent also included several macro-regions, including Gujarat and the Ganges valley; the Ottoman empire boasted Egypt, the lands around the Aegean, and the Black Sea region; in the Americas, Mexico City lay at the centre of a macro-region; so did the Kinai and Kantô plains in Japan. The macro-regions of Europe included the Genoa–Turin–Venice–Florence quadrilateral in Italy; the Home Counties in southeast England; the adjacent provinces of Holland, Zealand and Utrecht; and the Île-de-France. Many of the settlements within these macro-regions adopted a high-risk, high-reward economic strategy: they concentrated on producing cash crops which they sold to merchants and manufacturers, and imported the food they needed from farther afield."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-28",
      "id": "nr3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When times were good, the macro-regions created three golden economic opportunities for farmers – but at a high risk. First, thanks to rising external demand and stable transport costs, many individual agriculturists made the transition from generalist to specialist, investing in the tools, raw materials and labour required to produce a single crop, or a small range of crops, for the market. Thus in the duchy of Württemberg (southwest Germany), by 1622 many farmers and even entire communities had ceased to grow grain and converted all their land to producing the fine wines for which the area is still famous. This rendered almost everyone dependent on imported grain to bake their daily bread, and so when the harvest in most of Germany that year produced scarcely half the normal yield, much of Württemberg starved."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-29",
      "id": "nr3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" In many parts of eastern China, a lot of farmers likewise switched to producing cash crops for the market, such as sugar, tea, fish, silk and cotton. Initially, these shifts involved little disruption. On the one hand, rice requires intensive cultivation in March, May and July, whereas cotton requires most attention in April, June and between August and October; so the same labour force could produce both crops. On the other hand, fish ponds had long existed in the southern river deltas, with fruit trees planted on the surrounding embankments; the fish (mainly carp) fed on the organic matter that fell from the trees, and the muck scooped from the ponds fertilized the trees and the surrounding rice paddy. But as growing demand inflated the price of silk, farmers began to replace their fruit trees with the mulberries on which silkworms feed, and they also converted rice paddy into fish ponds with mulberries on the embankment. At first sight this formed a sustainable ecosystem, because almost all the necessary mineral and energy resources were recycled. It was not, however, a closed system: those who concentrated on producing fish and silk could no longer feed themselves and instead now depended totally on rice produced miles (sometimes hundreds of miles) away. The same dilemma faced Chinese farmers who abandoned cereals to plant cotton, at first in dry fields or on the ridges between their paddy, and then in their entire holding. Although smallholders could "), _c('a', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("make a fortune from cotton in some years, the crop required twice as much fertilizer as rice and was more vulnerable to floods, droughts and high winds. Since no one stored the annual crop, its market value immediately reflected variations in the climate and the price of fertilizers, as well as in the demand for cotton itself – all of them factors over which farmers had no control. Sooner or later, therefore, either the ‘miracle crop’ would fail or the market would collapse. In both scenarios, its producers would starve.")])]), _c('a', {
    attrs: {
      "id": "p68"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("The second golden opportunity for farmers that accompanied the growth of macro-regions in the sixteenth century was the chance to reclaim flooded land. In North Holland, the growth of Amsterdam and other adjacent cities encouraged entrepreneurs to reclaim 220,000 acres of lake, estuary and marsh between 1590 and 1640, creating 1,400 large new farms. In China, the sixteenth century saw the completion of over 1,000 new water-control projects, twice as many as the preceding century, while repairs brought many more abandoned projects back into service. In Japan, major land-reclamation projects between 1550 and 1640 more than doubled the area of rice paddy. Nevertheless, all these hydraulic projects were vulnerable. On the one hand, they needed constant maintenance: any inundation, however caused, requires immediate remedial action, because the longer the water is left, the harder it is to drain. On the other hand, hostile troops could easily destroy dikes and dams, and prevent repairs. Such action brought the risk of perpetuating a cycle of disorders, both because peasants who lost their land faced few alternatives to joining the aggressors, and because the floods created excellent redoubts where those aggressors could thrive (see chapter 5 for some Chinese examples)."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-30",
      "id": "nr3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The third golden opportunity associated with macro-regions was that the warmer climate of the sixteenth century, which reduced the risk of frosts that killed early or late crops, allowed more intensive cultivation of crops to satisfy the increased demand for food from a growing population. The most spectacular increases occurred in southeast China, where the land tax varied according to acreage rather than output, encouraging farmers to plant two and even three crops per year. Many incredulous contemporaries in the 1620s described this system – some of them Chinese (‘in Guangdong there are fields which get three harvests; the reason is the warm climate’) and others European (‘they obtain three consecutive harvests in one year, two of rice and one of wheat’)"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-31",
      "id": "nr3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/#fig_08"
    }
  }, [_vm._v("Fig. 8")]), _vm._v("). In both China and Japan, farmers experimented with different types of rice – quicker ripening (even if lower in yield); resistant to salt (for use near the sea); resistant to cold – until over 150 varieties were in use in Fujian alone, over two-thirds of them found in only one location.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Taken together, these improvements almost doubled rice yields in good years – but only in good years. Drought, cold and any other factor that prevented double-cropping impoverished farmers whose livelihood depended on selling the surplus crops. They also caused shortages or even starvation for their consumers, whether from lack of food or from inability to purchase it – often with long-lasting results. In India, the famine and floods of 1627–31 ended the production of indigo and cotton in Gujarat because, lacking both a market for their goods and food to eat, the weavers fled and never returned. Similarly at Luzhou, a once prosperous town in Shanxi province (northwest China) where until the disastrous harvest of 1640–2 ‘over 3,000 looms’ wove imported raw silk, thereafter")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p69"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_08.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p69"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p69"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_08"
    }
  }, [_vm._v("8. The double-cropping cycle in Liangnan, south-east China. Rice price series reveal two distinct patterns: warm years (such as the 1620s) saw generally lower prices with two ‘peaks’, in April–May and again in July (just before each harvest reached the market); colder years (such as the 1640s) saw higher prices with only one peak, in June–July.")])]), _c('a', {
    attrs: {
      "id": "fig_08"
    }
  }, [_c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("All the weavers had to take out loans and their debts piled up and ruined them, so by 1644 there were only two or three hundred looms left. Although the weavers worked hard for themselves and for official exactions, toiling day and night with their wives and children, they had to pay all their expenses out of their own pockets and accumulated only debts – how could they go on? Now in 1660 they are thinking of burning their looms and repudiating their debts and, in great sorrow, running away.")])])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "fig_08"
    }
  }, [_vm._v("The collapse of weaving also, of course, affected those who produced the raw silk: sericulture vanished from the neighbouring province of Shaanxi, despite a tradition that went back 2,000 years. Those who ceased to grow foodstuffs, and instead concentrated on other commercial crops produced for export, such as sugar, tea, indigo, or the wide variety of artefacts made from bamboo (writing brushes, rain-hats, umbrellas and so on), all shared the same vulnerability: when the supply of staples failed, they lost both their market and their capacity to feed their family."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-32",
      "id": "nr3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("Malevolence and the Macro-Regions")])]), _c('a', {
    attrs: {
      "id": "p70"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("Besides the catastrophes caused by climate change, the macro-regions (just like cities) were also extremely vulnerable to human malevolence. To begin with, agricultural innovations and commercial crops normally required a substantial investment in fixed assets. Thus sugar production needed roller mills to crush the cane, pans to boil the juice, and trays to dry the crystals; silk manufacture required mulberry trees (each of which took six years to mature), vats for dyeing, and looms for weaving; making cotton fabrics required gins and looms."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-33",
      "id": "nr3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" Such fixed assets could be looted and burned by enemies, just like traditional crops and simple farm equipment – but the damage cost far more and took far longer to repair. Moreover, as with hydraulic projects, what marauders could destroy once they could destroy again.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A second way in which human agency could cause serious damage to macro-regions arose from the fact that, although they formed the largest coherent economic units of the seventeenth century, they did not form a single market ("), _c('a', {
    attrs: {
      "href": "#/#fig_09"
    }
  }, [_vm._v("Fig. 9")]), _vm._v("). Instead, in the felicitous image of economic historian Kishimoto Mio, they resembled")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig_09"
    }
  }, [_vm._v("9. A simple model of early modern economic systems."), _c('br'), _vm._v("Japanese historian Kishimoto Mio has suggested that economic systems in the early modern world resembled an interconnected series of shallow pools, some deeper than others. Full integration of the ‘pools’ (")]), _c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State#fig_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 52")]), _vm._v(" below) took place slowly.")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Numerous shallow ponds connected one to another by channels. Because of their shallowness, the ponds were vulnerable to changes in external economic conditions. For example, too little inflow or too much outflow of money "), _c('a', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("or commodities could easily flood or dry up these ponds and paralyze local economies … Even if we could calculate the ‘total’ size of an economy by aggregating the water stock of these ponds, it would not have real meaning in economic history until these ponds are organically integrated into a single economy. More meaningful, perhaps, is to study the flow of money and goods in and out of the ‘shallow’ local markets from the viewpoint of local inhabitants, listening to their complaints about the destructive effects of external market conditions."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-34",
      "id": "nr3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In the seventeenth century such complaints multiplied whenever wars and rebellions closed down markets and trade routes. Thus in 1621 two simultaneous wars – between the Dutch Republic and Spain, and between Sweden and Poland – involved blockades specifically intended to halt the export of Baltic grain: the former because Dutch ships carried most of it, the latter because its profits sustained the Polish war effort. Grain exports through the Danish Sound accordingly plunged from over 200,000 tonnes in 1618 to 60,000 in 1624 and 1625. Just as the blockaders intended, this fall both ruined Polish farmers and pushed food prices in the Dutch Republic to their highest level of the seventeenth century. Riots broke out in several towns and an alarmed Dutch politician wrote in his journal that ‘the plague of God’ lay on the land."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-35",
      "id": "nr3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A decade later, in East Asia, another blockade crippled those whose economic survival depended on selling Chinese silks in Japan. In the 1630s Shogun Tokugawa Iemitsu first ordered all Japanese residing abroad to come home and forbade all emigration; he then prohibited the construction of large ships in the archipelago; finally he forbade all trade with the Portuguese. Iemitsu had prepared carefully for the economic impact of these measures upon Japan. On the one hand, he issued new ‘frugality and sumptuary laws’ designed to reduce the consumption of imported products such as silk; on the other, he encouraged Dutch, Korean and Chinese merchants to increase their silk imports in order to maintain a steady supply."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-36",
      "id": "nr3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" But he miscalculated: although the Portuguese of Macao lost ‘the most lucrative trade that His Majesty [Philip IV] has over here’ (just as Iemitsu intended), the Dutch, who expected to gain, also lost because when they imported large quantities of silk, as requested by the shogun, they found that the new ‘frugality and sumptuary laws’ had decimated demand."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-37",
      "id": "nr3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" For the same reason the Chinese, too, could not sell their cargoes in Japan: the price of raw silk in the Yangzi valley therefore fell sharply and its producers starved. Finally, the native Japanese importers also suffered because they forfeited the capital – at least 800,000 "), _c('i', [_vm._v("taels")]), _vm._v(" of silver – previously sent to Macao to buy silks. Many went bankrupt, some fled and a few committed suicide in order to escape their creditors."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-38",
      "id": "nr3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Everyone involved in the Sino-Japanese silk trade thus experienced serious losses, some of it terminal, because of a political decision over which they had no control and against which they had no defence."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-39",
      "id": "nr3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Those living in the macro-regions were also defenceless against other government initiatives. For example, since they normally used cash to settle commercial transactions, currency manipulation affected them far more than communities which continued to rely on barter. Currency in the early modern world came in two forms. One, used by "), _c('a', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("merchants, monarchs and others who engaged in high-value transactions, consisted of silver and gold coins that had an intrinsic value like any other commodity. Therefore, by changing the amount of precious metal contained in each coin, governments could manipulate its exchange value against the coins of other states that contained precious metal. During the mid-seventeenth century, an unprecedented number of governments around the world tampered with the currency, both to "), _c('i', [_vm._v("make")]), _vm._v(" money when they re-minted existing coins at inflated values and to "), _c('i', [_vm._v("save")]), _vm._v(" money when they had to make payments (much as some governments today welcome currency devaluation because it reduces the real cost of their debts and increases the competitive edge of domestic products). The Spanish government took the lead, issuing cheap copper coinage (known as "), _c('i', [_vm._v("vellón")]), _vm._v(") in 1618. Within eight years it had almost completely replaced silver in domestic transactions. Serious inflation took place, and the government first halted further issues of "), _c('i', [_vm._v("vellón")]), _vm._v(" and then halved the face value of all copper coins. Four more times between 1636 and 1658 the Spanish Mints called in all existing coins and re-stamped them at a higher value (two, three, or even four times their face value) – only to retreat after a few months in the face of public outcry and restore the earlier value.")])]), _c('a', {
    attrs: {
      "id": "p72"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("Many Muslim rulers also resorted to currency debasement, causing similar economic dislocation. In the Ottoman empire, the weight and silver content of the standard silver coin, the "), _c('i', [_vm._v("akçe")]), _vm._v(", dropped in a series of devaluations from 0.7 grams in the 1580s to 0.3 grams in 1640 and it all but disappeared as a medium of exchange. In Iran, an irate draper described in verse what he called the ‘monetary revolution’ of 1653–4, in which creditors feared payment in the shah's abundant but debased silver coins bearing a lion's head:")])]), _c('div', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p72"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Money is in plenty, but beggars refuse it,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As if its lion were a man-eater …")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The creditor flees the borrower,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Never did the world see such ways …")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "poem"
  }, [_vm._v("At the time of the monetary revolution")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("I was worried by both dearth and plenty."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-40",
      "id": "nr3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In China, the subjects of the last Ming emperors also worried as mounting defence spending led first to the issue of large quantities of copper fiat money and then, once copper supplies ran short, to coins adulterated with base metals. The exchange rate of silver to copper coins fell to 1:1700 in 1638 and to 1:3000 in 1643. At this point, the desperate Chongzhen emperor started to issue paper currency, but (understandably) no one believed the notes would ever be redeemed, and so that expedient also failed. Worse followed: the Qing refused to accept Ming copper currency as legal tender and so the exchange rate between silver and copper coins fell to 1:5000 in 1646, and to 1:6000 in 1647. Eventually, as in central Europe during the 1620s (page 35 above), copper coins became worthless: in the words of a contemporary, ‘a hundred coins piled up hardly measured an inch in thickness and when they were thrown on the floor they broke into pieces’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-41",
      "id": "nr3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("Economic historians still debate the extent to which such drastic changes in liquidity affected the early modern world. Obviously, the importance of silver and gold currency to each geographical area and to each social group increased in proportion to its reliance on cash as opposed to barter; and, predictably, barter spread in many parts of the seventeenth-century world. Nevertheless, trade – and especially foreign trade – exerted a ‘multiplier effect’ on currency variations. To use another insight of Kishimoto Mio, unlike other commodities,")])]), _c('a', {
    attrs: {
      "id": "p73"
    }
  }), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p73"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("Sooner or later money creates added income for others through spending. The silver that flowed annually into one regional market in turn created demand in other regional markets through chain-like successions of exchange. For example, producers of raw silk would sell their silk to outside merchants and obtain silver, with which they could buy foods from farmers in the neighbourhood. Those who obtained silver from the sale of food would buy cotton cloth or other miscellaneous commodities with that silver, and so on. If the inflow of silver was to stop for some reason, the silk producers would have no money to buy food, and food producers would also have no money to buy cotton cloth. The decrease of income spreads through a chain reaction."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-42",
      "id": "nr3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Kishimoto's ‘model’ explains why contemporaries paid special attention to the ‘flow’ of silver and other commodities, rather than to stock: what mattered was not the ability to amass goods, but the ability to sell them. In the 1650s, after three decades of war, disease and famine had drastically lowered demand in Jiangnan, a series of warm summers produced bumper rice harvests – but this spelled disaster for rice farmers. According to one of them, ‘This year the price of rice was very low, at a level not seen for several decades. The humblest people in the poorest hamlets all ate fine rice and made cakes, while in my house we ate no midday meal on the last day of the year [traditionally a Chinese feast day].’ During the following decade, the decision of the Qing government to forbid all maritime trade, cutting off Jiangnan from its traditional overseas export markets, again caused supply to exceed demand. According to a local source,")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Even the rich with much property rarely have any silver, so they are not able to buy grain, meal and cloth – all of which are cheap. Consequently the sellers of these commodities [have no business, lack money], and are also unable to consume goods … As a result, grain and hundreds of other unsold commodities pile up at the market centres in Suzhou. Good merchants lose their funds and the wealthy become penniless.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Or, more concisely, in a Chinese aphorism of the day, ‘The rich become poor; the poor die.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-43",
      "id": "nr3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("‘The haves and the have-nots’")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In the second part of "), _c('i', [_vm._v("Don Quixote")]), _vm._v(", published in Madrid in 1615, Miguel de Cervantes attributed to the phlegmatic squire Sancho Panza a now famous proverb: "), _c('a', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("‘My grandmother used to say that there are only two families in the world: the haves and the have-nots.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-44",
      "id": "nr3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" When Cervantes wrote, the village of Navalmoral de Toledo, in central Spain, had a population of around 250 families, of which 50 were ‘have-nots’ who owned no property. Instead they lived in shacks, sometimes without a single piece of furniture – the inventory of their property when they died recorded no chair, no table, no bed – and survived on what they earned from working for the ‘haves’. In addition, 20 widows lived alone in the village without any apparent source of income; and 17 individuals, described as paupers, lacked even a permanent dwelling place of their own, sleeping in a barn or an attic in winter and under a hedgerow in summer ("), _c('a', {
    attrs: {
      "href": "#/#fig_10"
    }
  }, [_vm._v("Fig. 10")]), _vm._v("). In the early decades of the century, whenever a meagre harvest forced up the price of food but required fewer labourers, these ‘have-nots’ went hungry but they rarely starved because the ‘haves’ provided alms, while the church used the tithes (a 10 per cent share of the harvest) to provide charity. If dearth continued, however, not only did the number of have-nots increase but the yield of the tithe simultaneously decreased. Thus in 1618, a year of good harvest (and therefore of good tithes), the church of a Spanish village near Navalmoral distributed 12,000 "), _c('i', [_vm._v("maravedis")]), _vm._v(" (£5) in alms; but in the 1630s, as harvest yields fell, the sum declined to 2,000 "), _c('i', [_vm._v("maravedis")]), _vm._v(" annually; while in 1645, 1647 and 1649, the years that saw the worst harvests of the century, the parish priest wrote sadly in his account-book: ‘No charity has been given, since there is nothing to give.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-45",
      "id": "nr3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig_10"
    }
  }, [_vm._v("10. The social structure of Navalmoral, Spain, in the early seventeenth century."), _c('br'), _vm._v("Of 243 families living in a remote upland village south of Toledo, 11 families owned one-third of the village's land, 22 families owned half of it, and 108 families owned all of it. The rest of the inhabitants were ‘have-nots’, many of them homeless.")])]), _c('a', {
    attrs: {
      "id": "fig_10"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_10"
    }
  }), _c('a', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("The lot of the have-nots was little better elsewhere. Even in England, the only European state that boasted an obligatory welfare system (the Poor Law), a failed harvest would double, triple or even quadruple the amount required from the rich to save the poor from starvation so that, in the words of social historian Steve Hindle, it is ‘difficult to understand how the agricultural labourer and his family got through the year’ in the mid-seventeenth century. Paid farm work was no longer ‘a living in itself, but simply a vital cash supplement to a subsistence based on the cultivation of cottage gardens and the exploitation of common rights’, occasionally augmented by poor relief; and this precarious situation ‘rendered imperative the participation of all family members in the production endeavours of the household economy’. Unless prevented by disability or weakness, until the later seventeenth century most ordinary English men and women started to earn their living at age six or seven and ‘literally worked themselves to death’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-46",
      "id": "nr3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The situation of ‘ordinary men and women’ was, of course, even worse in war zones. In the Maas valley of the South Netherlands, the magistrates of St Truiden cancelled their annual fair in 1630 on account of ‘these times of war, of shortage of grain, of contagious disease, and of misery’. Four years later the parish priest at neighbouring Emael wrote in his diary: ‘This year, we have been tested in astonishing fashion by sickness, war, famine and fire. First a violent plague struck the village during the months of June and July, taking seventeen victims. Immediately afterwards, war unexpectedly came to us’ when three Spanish regiments (that is, troops sent to defend them) ‘lodged here. They behaved worse than barbarously: they destroyed everything; they cut trees, completely demolished many houses, and trampled whatever grain they could not steal, not even leaving enough to appease the hunger of the poor farmers. For that reason, we did not collect the tithe this year.’ Although none of these individual disasters was unprecedented, they had rarely if ever coincided: throughout the Maasland, in 1634 tithe receipts (which mirrored agricultural production and, as in Spain, provided the principal form of relief for the poor) sank to the lowest level ever recorded between 1620 and 1750."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-47",
      "id": "nr3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In China, too, agricultural production fell to its lowest levels in the mid-seventeenth century and, once again, brought about the collapse of traditional forms of charity. Each county town maintained (at least in theory) a state-run ‘Ever Normal’ granary, with smaller additional repositories elsewhere to ‘nourish the people'; but by the seventeenth century many lay empty, either through corruption or incompetence. In an attempt to avert disaster, groups of concerned citizens therefore created ‘voluntary societies for sharing goodness’. Some distributed aid to impoverished widows, padded winter jackets to the poor, and coffins in which to bury unclaimed corpses; others set up soup kitchens and advanced money to small businesses in trouble; others still established orphanages, medical dispensaries and schools for the poor. Most voluntary societies, however, only provided assistance to a select few. Some conducted a ‘background check’ before issuing approved "), _c('a', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("supplicants with a ‘Ration Card'; others helped only those recommended by members (including their own relatives, in order to escape responsibility for maintaining them). Private charity therefore only scratched the surface of poverty. In 1641, on the eve of the great famine, the founder of a benevolent society in Zhejiang province claimed that although it now helped ‘three to four hundred people’ (compared with only a few dozen a decade before), he feared that ‘the number of persons who are kept alive or given burials is still less than 10 to 20 per cent’ of the total poor."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en3-48",
      "id": "nr3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Even this limited charity often ceased during the Ming-Qing transition. In Tancheng county (Shandong), the local elite informed a newly arrived magistrate in 1670 that the area ‘has long been destitute and ravaged. For thirty years now fields have lain under flood water or weeds.’ Famine, disease and bandits had depopulated the county in the 1630s; the Manchu army ravaged the county and sacked its capital in 1642; torrential rain caused the local rivers to flood, destroying the harvest, four times between 1649 and 1659. The county's assessment for forced labour therefore fell from just over 40,000 able-bodied males in the 1630s to under 33,000 in 1643 and to under 10,000 in 1646. By 1670, the new magistrate learned, ‘many people held their lives to be of no value, for the area was so wasted and barren, the common people so poor and had suffered so much, that essentially they knew none of the joys of being alive’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-49",
      "id": "nr3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The people of Shandong were not alone in believing that they had faced horrors of unprecedented severity. Others, especially those living on marginal lands, in towns, or in macro-regions, wrote similar laments. Enomoto Yazaemon, a Japanese official who lived near Edo, thought that ‘the world was in flames from the time I was 15 [1638] to the time I was 18’. In Europe, a German cloth merchant lamented that ‘there have been so many deaths that the like of it has never been heard in human history'; while a chronicler in Burgundy saw ‘everywhere the face of death’ when war, plague and harvest failure struck simultaneously. ‘We lived from grass taken from the gardens and the fields,’ he wrote. ‘Posterity would never believe it.’ A German pastor expressed the same resignation: ‘Our descendants will never believe what miseries we have suffered'; while one of his Catholic clerical colleagues asked rhetorically: ‘Who could have described so many vile knaves, with all their evil tricks and wicked villainies? … I would not have had time or opportunity, nor could I have laid hands on enough pens, ink or paper.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en3-50",
      "id": "nr3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" The incredulity and pessimism of these writers become explicable only when we look more closely at the scale of the demographic catastrophe which they had witnessed – a catastrophe that may have reduced the size of the global population by one-third.")])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("4")])]), _c('a', {
    attrs: {
      "id": "p77"
    }
  }), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("‘A third of the world has died’: Surviving in the Seventeenth Century"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-1",
      "id": "nr4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("HE DRAMATIC REDUCTION IN FOOD SUPPLY IN THE MID-SEVENTEENTH")]), _vm._v(" century, whether through human or natural agency, forced many human communities to take urgent and extreme measures to reduce their food consumption. The easiest and most effective way to do this was to reduce the number of mouths to feed; and although this process took different forms in different parts of the globe, almost everywhere the population fell steadily from the 1620s until a new equilibrium emerged between supply and demand for basic resources – often not until the 1680s.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The exact scale of demographic contraction is hard to document. In 1654 the abbess of the convent of Port-Royal near Paris lamented that ‘a third of the world has died’, while, a generation later, the Chinese emperor asserted that during the transition from the Ming to the Qing dynasties ‘over half of China's population perished’. Many surviving statistical data support such claims. Thus the parish registers from Île-de-France, where Port-Royal stood, show that ‘almost one quarter of the population vanished in a single year’. In China, tentative reconstruction of population levels in Tangcheng county in Jiangnan between 1631 and 1645 shows that some areas suffered almost 60 per cent losses."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-2",
      "id": "nr4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The number of taxable households in western Poland also fell by more than 50 per cent between the census of 1629 and that of 1661 while, further east, tax registers in what is now Belarus showed falls of between 40 and 95 per cent in urban populations between 1648 and 1667 (see chapter 6 below). In Germany, parts of Pomerania and Mecklenburg in the north, like parts of Hessen and the Palatinate in the centre, apparently lost two-thirds of their population between 1618 and 1648. Württemberg, in the southwest, boasted a population of 450,000 in 1618 but only 100,000 in 1639.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Even when detailed demographic records chart a decline, they do not always reveal the exact causes. Thus London's ‘Bills of Mortality’, which printed the weekly totals of burials in each parish of the capital together with the causes of death, included such esoteric afflictions as ‘blasted’, ‘frighted’ and ‘headmouldshot’ as well as different types of homicide (‘murthered and shot’), recognizable diseases (‘smallpox’, ‘French pox’) and conditions (‘childbed’), as well as suicide (‘Hang'd and made away themselves’: Plate 25). Taken together, the ‘Bills’ and other available data nevertheless reveal three distinct mechanisms that reduced the global population during the seventeenth century:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("• More deaths through suicide, disease, or war;")])]), _c('a', {
    attrs: {
      "id": "p78"
    }
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• Fewer births, either through postponing or preventing marriage, or through infanticide and child abandonment;")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• More migration.")])])]), _c('a', {
    attrs: {
      "id": "p78"
    }
  }), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("I. Death: ‘Never send to know for whom the bell tolls‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-3",
      "id": "nr4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("Suicide")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("An unprecedented number of people in the mid-seventeenth century appear to have reacted to adversity by killing themselves. During a famine in Scotland in the 1630s, some clerics reviewed the grim alternatives that faced their parishioners: ‘The picture of death is seen in the faces of many. Some devour the seaware [kelp and seaweed]; some eat dogs … Many are reduced to that extremity that they are forced to steal and thereafter are executed; "), _c('i', [_vm._v("and some have desperately run into the sea and drowned themselves")]), _vm._v(".’ At much the same time, a Catholic at the court of Charles I gloated over an epidemic of suicides among Protestant clergymen: ‘a divine (and, they say, an excellent preacher)’ had ‘strangled himself with a garter, and the like did another minister lately in Manchester'; ‘a third minister … fell upon his owne sword’, while Dr Henry Butts, vice-chancellor of Cambridge University, ‘on Easter daye in the morning hanged himself’. In 1637 the preface to a comprehensive English treatise on suicide (326 pages plus index) asserted that ‘scarce an age since the beginning of the world has afforded more examples’ of people who ‘drowned themselves’ or committed suicide in other ways. ‘There are many more self-murderers than the world takes notice of,’ it announced. ‘Yea, the world is full of them.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-4",
      "id": "nr4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In England, suicide was not only a felony, and so came before the courts, but also the subject of ‘shaming’ rituals such as dragging the corpse through the streets and (at least in some counties) burial in unconsecrated ground with a stake through the heart. So many mid-seventeenth-century records have disappeared that it is almost impossible to document fluctuations, but the surviving evidence suggests that twice as many English men as women took their own lives; that almost one-third of them were under 20 years old; and that about one-fifth were over 60. Although we can only guess at their motives, the court testimony of witnesses, as well as accounts by those who attempted to kill themselves but failed, suggest two broad categories. Some felt overwhelmed by a direct threat to their psychological or physical survival, such as bereavement, family strife and fear. Thus several mothers and a few fathers killed themselves after their children died; a 9-year-old boy tried to drown himself because he no longer wanted to live in poverty and misery; a young woman took her own life because she could not marry the man she loved; and a 12-year-old apprentice hanged himself when, after running away from a brutal master, his parents sent him back. A second group of unfortunates killed themselves because they had lost their social standing and could not live with the shame, such as women who became pregnant outside wedlock (especially as the result of incest or rape); and those who had suffered a public humiliation, such as a clerk who shot himself in prison after his "), _c('a', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("arrest for debt."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-5",
      "id": "nr4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Meanwhile, in seventeenth-century Scotland more than three times as many men as women ‘made away with themselves’, and just over half were farmers while just over a quarter lived and worked in towns. Surviving data from Bavaria demonstrate the difficulty in achieving greater precision: of some 300 cases of suicide reported to the duchy's courts between 1611 and 1670, almost 90 per cent occurred before 1635 – a skewed distribution that presumably reflects the collapse of the judicial system during the Thirty Years War rather than an absence of suicides. But since surviving court records from other decades show that suicides often rose (or at least became more visible) during times of economic and political crisis, it seems highly likely that ‘self-killing’ increased during the mid-seventeenth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-6",
      "id": "nr4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Suicides in China certainly increased at this time, but not always for the same reasons. Although, as in Europe, motives included melancholy, economic misery and disappointment in love, as well as desperation during a period of turmoil, many also sought to humiliate, embarrass or harm someone else. This could be achieved relatively easily because Chinese law insisted that a dead body must remain untouched until the local magistrate came to make a full inquiry – one that often uncovered the provocations, the humiliating cruelties, the cheating and the insults that had forced the deceased to take their own life. To remove any possible doubt, many desperate people killed themselves at the exact site where the ill-treatment had taken place: the humiliated apprentice in his master's shop; the young childless bride outside the door of her abusive mother-in-law; the members of a starving family in the orchard of a local magistrate who had failed to ‘nourish the people’ – seen as the primary duty of government officials throughout imperial China (Plate 5).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Such ‘revenge’ suicides may have increased during the turbulent transition from Ming to Qing rule, as the shortage of resources exacerbated tensions and desperation within each family, but three other factors added significantly to the total of women who killed themselves. First, Confucian teaching encouraged virtuous women to commit suicide in two circumstances: those who had been raped or otherwise ‘dishonoured’ should kill themselves immediately to ‘avoid the shame’, while a virtuous widow should ‘follow her husband’ to the grave as soon as he died. The collapse of public order in the mid-seventeenth century dramatically increased the number of women affected by these precepts.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When Qing forces took Yangzhou by storm in 1645 (pages 29–30 above), many women in the city jumped into deep wells or hanged themselves while others burned themselves to death in their own home or slit their throats rather than fall into the hands of the soldiers and be raped, enslaved, or forced to watch the abuse and murder of their families."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-7",
      "id": "nr4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Some young women either slit their noses or cut off their ears, so that they could not be forced to remarry (Confucian rites required a ‘whole body’); others, before killing themselves, composed a brief autobiography in prose followed by a few verses expressing anguish at their plight: a new genre of literature: "), _c('i', [_vm._v("tibishi")]), _vm._v(", or ‘poems inscribed on walls’. The ‘suicide note’ left by Wei Qinniang, ‘a girl from Chicheng’ (Zhejiang province), seems typical. Just three months after she got married, soldiers captured her and carried her away from her "), _c('a', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("husband (whose fate she never discovered). Somehow she escaped and ‘disfigured my face and covered myself with dirt to obliterate my tracks. During the day I begged by the side of the road and at night I laid low in the blue grass. I swallowed my sobs and wept in secret, fearing that others might find me.’ At last she found shelter in an abandoned temple where ‘I look at my shadow and pity myself: my pretty face has been ruined by dust and wind, and my clothes have all been muddied.’ Eventually ‘With no news from home, I recite a few quatrains and in tears write them on the wall. If some compassionate men of virtue would pass them on to my family, it would suffice to make my lonely parents understand.’ She then killed herself. Her moving farewell, inscribed on the wall of her temple refuge, is all we know about her."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-8",
      "id": "nr4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Other elite women killed themselves out of loyalty to the Ming. Just before her death, the foster-mother of the scholar-official Gu Yanwu told him: ‘Although only a woman, I have received favour from the [Ming] dynasty; to perish with the dynasty is no more than my duty.’ When news arrived that Qing troops were approaching her home, she stopped eating and died 15 days later."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-9",
      "id": "nr4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many Chinese women killed themselves after war claimed the lives of their husbands. In 1621, for example, the wife of an official in a town in Liaodong heard that it had fallen to Manchu forces. Assuming that her husband had died heroically for the Ming cause, she ‘led more than forty household relatives and retainers into suicide, jumping into a well with her own granddaughter in her arms’. Some husbands expected no less. Just before Yangzhou fell in 1645, Shi Kefa, the Ming commander, wrote two letters of farewell to his wife, both of them enquiring pointedly: ‘[Since] sooner or later I must die, I wonder whether my wife is willing to follow me?‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-10",
      "id": "nr4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Even the junior scholar Wang Xiuchu expected his pregnant wife to commit suicide rather than survive alone, informing her: ‘“Enemy soldiers have entered the city. If things go awry, you should cut short your own life.” “Yes,” his wife replied: “Let me give you my few pieces of silver to keep.” And then she sobbed, “Women like me in situations like this no longer think to live in the human world.”’ Both the soldier Shi and the scholar Wang thus (in the words of Lynn Struve) ‘expected their wives to place the honour and well-being of their husbands and families above the preservation of their own lives. Times of acute disruption, such as the Ming-Qing conflict, demanded such sacrifices from hundreds of thousands of women.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-11",
      "id": "nr4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("‘Times of acute disruption’ also increased suicides among males. Many scholar officials of the Ming killed themselves in accordance with the Confucian adage: ‘the commanders of the troops have to die when they are defeated; the administrators of the state have also to die when the state is in peril’. Many did just that, especially in the south. As the Manchu army approached Yangzhou one young scholar declared that ‘matters having reached this point, I will read the sage's books and, retaining my honour, I will die’: accordingly, with the "), _c('i', [_vm._v("Book of Changes")]), _vm._v(" open in his hand he jumped into a well and drowned. One colleague killed himself next to the image of Confucius, while others hanged themselves after writing appropriate poems. Others still drowned themselves in the Yangzi, the Grand Canal, or a local well, and a few hid and starved themselves to death."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-12",
      "id": "nr4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("A few protested that such sacrifices were needless – in his "), _c('i', [_vm._v("Credible record of 1644")]), _vm._v(" the official Qian Xing argued (after shifting allegiance from Ming to Qing) that ‘if everyone dies at the time of national calamity, the whole country will be ruined; the monarch will be killed; and the whole world will be handed over on a silver platter’ – but suicide remained common. When in 1670 a new magistrate took up his post in Tancheng county, Shandong province, he noted that ‘many people held their lives to be of no value, for the area was so wasted and barren’ that ‘every day one would hear that someone had hanged himself from a beam and killed himself. Others, at intervals, cut their throats or threw themselves into the river.’ The practice remained common enough in 1688 to justify an imperial edict that forbade widows to ‘treat life lightly’ and kill themselves. Instead they must serve their parents-in-law and raise their children."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-13",
      "id": "nr4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Suicides rose notably during the mid-seventeenth crisis in two other societies: Russia and India. In the former, the practice mainly involved males. From the 1630s onwards, a group of Orthodox Christians became convinced that the end of the world was imminent and immured themselves in hermitages and convents. Some of them, later known as ‘Old Believers’, concluded that the tsar was the Antichrist whose mistaken religious innovations brought the apocalypse ever nearer; and from the 1660s they defied him. When the government sent troops against them, they killed themselves rather than submit. According to one study, ‘the total number of suicides ran into tens of thousands’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-14",
      "id": "nr4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In India, by contrast, suicide normally involved women. Hindus believe that a virtuous woman has the power to preserve and prolong her husband's life; and although this brought her great status while married, it brought blame if her husband died. Respectable Hindu widows were expected to expiate their 'guilt’ by committing "), _c('i', [_vm._v("suttee")]), _vm._v(" (from "), _c('i', [_vm._v("sati")]), _vm._v(", ‘a virtuous woman’), either by casting themselves onto their husband's funeral pyre or by being buried alive beside it. Conveniently for their in-laws, suicide resolved another issue. Hindu custom gave a widow the right both to a share of her late husband's goods and to support from his surviving family – and suttee irrevocably ended both obligations. Widows who refused suttee immediately became marginalized: they could not remarry, and many became either slaves or prostitutes (indeed in Marathi, ‘the word for widow and the word for prostitute were in some contexts interchangeable’). Although Muslim rulers (including the Mughals) tried to abolish suttee, many European visitors encountered it. Thus in 1630, in Gujarat, the Cornish world-traveller Peter Mundy watched in amazement as the beautiful widow of a Hindu trader climbed into a special structure atop the funeral pyre and took her husband's head on her lap before she herself set fire to the surrounding kindling."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-15",
      "id": "nr4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Although no official total of suttee survives, a Dutch merchant residing in the Mughal capital in the 1620s claimed that ‘in Agra this commonly occurs about "), _c('i', [_vm._v("two or three times a week")]), _vm._v("’. It seems reasonable to suppose that the pressure on widows to commit suicide grew in response to both the higher mortality among males caused by war and the increased pressure on resources caused by famine."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-16",
      "id": "nr4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_c('a', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("Sick to Death")])]), _c('a', {
    attrs: {
      "id": "p82"
    }
  }), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("Almost everywhere in the seventeenth-century world, the most lethal disease was smallpox. The smallpox virus spreads rapidly and directly between humans by inhalation, and before the introduction of preventive measures it killed around one-third of all those infected, and up to one-half of infected infants and pregnant women. In addition, according to an experienced French midwife, ‘almost all women with child that are attacked’ by smallpox ‘miscarry, and are in great danger of their lives’. Smallpox survivors, after several weeks in agony, often emerged with disfiguring scars, with deformed or stunted limbs, or with impaired sight. Smallpox spared no one: among the ruling dynasties of western Europe, it carried off Philip IV's brother the Cardinal-Infante in 1641 and his son and heir Balthasar Carlos in 1646; Prince William II of Orange in 1650; two siblings of Charles II of England in 1660 and his niece Queen Mary II in 1694; and Louis XIV's heir in 1711. The only ‘positive’ aspect of the disease is that those who survive it acquire a lifelong immunity."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-17",
      "id": "nr4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Smallpox appears to have become both more deadly and more widespread in the seventeenth century. An English tract of 1665 about ‘the tyranny of diseases’ devoted a whole section to their apparent ‘alteration from their old state and condition'; in particular, it claimed that smallpox was ‘very gentle’ until ‘about forty years ago and less’ and far more lethal thereafter."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-18",
      "id": "nr4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Three considerations support this contention. First, given its highly infectious character, once smallpox entered a community it spread fast; therefore the proliferation of areas of dense settlement, such as cities and macro-regions, increased mass deaths from epidemics. Second, the transportation of African slaves to both western Europe and America introduced new and apparently more lethal strains of the disease from another continent. Third, communities rarely exposed to smallpox always suffer unusually high mortality at first contact and, as previously isolated areas entered the global economy in the seventeenth century, virtually all their inhabitants succumbed at the same time. In England, a single smallpox carrier in 1627 infected over 2,000 people on the Isle of Wight, normally shielded from outbreaks on the mainland, and most of those infected died. In East Asia, the Manchus, who had previously lived in small and relatively isolated communities on the steppe, likewise suffered heavily when they invaded China and encountered smallpox for the first time. In 1622, shortly after their first incursion into Chinese territory, the Manchu leaders established a ‘Smallpox Investigation Agency’ to identify and isolate suspect cases; and they later created ‘Shelters for keeping smallpox at bay’, to which those not infected by the disease could escape. To preserve the military effectiveness of their armies they only entrusted senior commands to smallpox survivors. Nevertheless in 1649 smallpox killed one of the emperor's uncles as he directed the conquest of south China, and 12 years later it killed the emperor himself."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-19",
      "id": "nr4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the early modern world, only one other disease killed as many people as smallpox: bubonic plague. Although epidemics were less frequent, they too spared no one: men and women, children and seniors, saints and sinners, rich and poor all perished in agony – many within 24 hours and most within 48 hours of infection. "), _c('a', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("An epidemic could increase deaths in affected communities sixfold because, according to Geronimo Gatta, a doctor from Naples, whereas ‘in the countryside it is possible to keep a suitable distance between the infected and the healthy’, those living in towns had no escape. Gatta knew whereof he spoke: he had just survived a plague epidemic that in 1656 reduced the population of his native city from almost 300,000 to perhaps 150,000 in a matter of months. In the neighbouring town of Eboli, almost 1,000 families took Easter communion in 1656, but scarcely one-fifth knelt at their local altar unscathed one year later; the plague had totally eliminated over 80 families with one or two members, 27 families with three members, 15 families with four, and 14 more families with between five and seven."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-20",
      "id": "nr4-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" The same epidemic that devastated Naples and Eboli had already ravaged large parts of the Iberian Peninsula, creating what the eminent historian Antonio Domínguez Ortiz called ‘the worst demographic catastrophe to strike Spain in modern times'; and it went on to kill at least 39,000 people in Genoa. Many other port cities, including Seville and Naples, lost half their population. Some did not recover their pre-plague levels until the nineteenth century ("), _c('a', {
    attrs: {
      "href": "#/#fig_11"
    }
  }, [_vm._v("Fig. 11")]), _vm._v(")."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-21",
      "id": "nr4-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many cities of northern Europe also suffered catastrophic losses from plague in the mid-seventeenth century. In 1654 an epidemic struck Moscow with particular ferocity. Although we lack totals for the entire city, within the walls of the Kremlin, 26 people at the Chudov monastery survived but 182 died, while in three convents of nuns 107 survived but 272 perished. In 1663–4 another epidemic afflicted Amsterdam (where it killed 50,000 people), and other Dutch cities, before crossing to London, where it killed well over 100,000 people in 1665 – perhaps 15,000 in the single week 12–19 September, ‘the grimmest week for burials in London's long history’ with ‘between one and two thousand bodies’ thrown into graves and anonymous ‘plague pits’ every night."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-22",
      "id": "nr4-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Plague and smallpox, together with typhus, measles and fever, belong to a cluster of deadly diseases that correlate closely with harvest yields: that is, the number of victims in each epidemic to some extent reflected the food supply. It is therefore not surprising to find that both the frequency and the intensity of these diseases increased amid the famines caused by the Little Ice Age. England's demographic records, which have survived better than those of other European countries, show eight years of high mortality between 1544 and 1666 caused by plague, of which half occurred after 1625; while a survey of mortality crises in Italy between 1575 and 1886 shows more episodes between 1620 and 1660 than at any other time."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-23",
      "id": "nr4-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Climatic adversity promoted sickness everywhere. In China, acute drought caused epidemics as well as famines: a study of County Gazetteers in Jiangnan revealed over 100 locations affected by disease in the famine year 1641. Meanwhile in Serrès, Macedonia, an Orthodox priest left a particularly vivid account of the same catastrophic combination. The trouble began with the constant rains of summer 1641, which turned into snow during the grape harvest, so that many labourers perished of cold in the fields. The weather turned unusually mild until more unseasonable snow fell in March and April 1642, and during this climatic anomaly the plague took hold in the region with unsurpassed severity: not only did it afflict virtually every family in town and country alike but ‘of a hundred who fell ill, only one recovered’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-24",
      "id": "nr4-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p84"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_11.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p84"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p84"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_11"
    }
  }, [_vm._v("11. The Mediterranean plague epidemic of 1648–56."), _c('br'), _vm._v("After ravaging Andalucia, where it caused demographic losses that took two centuries to make good, the plague epidemic spread along Spain's eastern coast before crossing to Naples, and finally Genoa, where it killed half the city's population. Notably, Castile maintained an effective quarantine and escaped the epidemic.")])]), _c('a', {
    attrs: {
      "id": "fig_11"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_11"
    }
  }), _c('a', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("Climate, corruption, hoarding and war could all intensify the effects of epidemics. According to the English merchants in Gujarat, India, all these factors increased mortality from the disease in 1631. The Mughal emperor's campaigns prevented ‘the supplies of corne to these parts from those others of greatyr plenty; and the raynes hereabout having fallen superfluously; which, with bad government, is cause of the highest extreame of scarcity.’ And ‘to afflict the more,’ the merchants added, ‘not a family hath not been visited with agues, fevers and pestilentiall diseases’. In short, ‘Never in the memory of man [has] the like famine and mortality happened.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-25",
      "id": "nr4-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" Italy also experienced an unprecedented demographic catastrophe at this time – indeed, according to a recent study, ‘no other area of Europe came near to the overall losses suffered by the peninsula’. The crisis began in 1629 when torrential rains destroyed the harvest in northern and central Italy and so created serious overpopulation. Then large armies arrived from both Germany and France, where plague already raged, spreading the disease even as they consumed scarce resources and destroyed the fragile infrastructure. Cities and countryside were, it seems, equally affected, and of the six million people living in the north Italian plain in 1628, perhaps two million perished during the following two years."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-26",
      "id": "nr4-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" The Alpine passes that served as military corridors suffered worst. In 1630 the plague travelled through the Aosta valley between France and Italy so swiftly that when news reached the regional capital, the secretary of the council (then in session) dropped his pen in mid-sentence – ‘We further resolved to …’ – and fled. When he returned, of the valley's 90,000 inhabitants, no fewer than 70,000 had died."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-27",
      "id": "nr4-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Like smallpox, plague afflicted the young and pregnant women with especial severity. Thus in Barcelona, during the plague epidemic of 1651 a disproportionate number of infants died, because their mothers either perished or lacked milk to feed them, so they were left at the Foundlings’ Hospital ‘with a ribbon or tag around their arms or leg or neck with the names of their parents written on it’. Miquel Parets, the Barcelona tanner who recorded these details in his diary, observed that ‘hardly any’ of these foundlings survived, ‘because so many were sent there’ that it proved impossible to find wet nurses for them all. Parets also noted sadly that children who had once lacked for nothing now became orphans, ‘lost and wandering about the city begging … and in this fashion many children fell sick and never grew up'; while ‘of the poor women who were pregnant at this time … perhaps two among every hundred survived. If they were in the last days of their term all they could do was to commend themselves to God, as most of them simply gave birth and died and many of their babies died with them.’ Surviving parish records confirm this: far more women and children than men were buried in Barcelona in 1651 ("), _c('a', {
    attrs: {
      "href": "#/#fig_12"
    }
  }, [_vm._v("Fig. 12")]), _vm._v(")."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-28",
      "id": "nr4-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Parets himself watched his wife and three of his children die within a month (a fourth child contracted plague but recovered) and his strong religious faith began to waiver. ‘God knows why He does what He does,’ he wrote in his diary after recording these devastating losses; but worse was to come. Although the plague abated, Catalonia was afflicted by one of the longest droughts ever recorded (360 days: almost the entire year); and, in addition, the troops of Philip IV now arrived to besiege the city, in revolt since 1640. Many of those who had survived the plague died during the blockade, and by the time Barcelona surrendered in October 1652 half its population had died."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-29",
      "id": "nr4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p86"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_12.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p86"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p86"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_12"
    }
  }, [_vm._v("12. Mortality in Barcelona, 1650–4."), _c('br'), _vm._v("Drought had destroyed the Catalan harvest in 1650 and drastically reduced the seed corn available for 1651, when plague broke out. Then the troops of Phillip IV besieged the city, and by the time it surrendered, half the population of Barcelona had perished. The monthly burial totals in the parish of Santa Maria del Pi show that more women than men died in the summer of 1651, and unusually high infant mortality.")])]), _c('a', {
    attrs: {
      "id": "fig_12"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_12"
    }
  }), _c('a', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("Climate change increased the lethality of other diseases, too. In the early eighteenth century, the Icelander Mathias Jochumssen sought to explain why the local population had declined over the previous century: although he acknowledged the importance of smallpox and plague epidemics brought by foreigners, he blamed primarily the ‘unusually poor standard of living, and rotten food’ caused by the adverse climate, which promoted deficiency diseases such as scurvy and reduced fecundity. A correlation of the variations in the weekly death totals recorded in London's ‘Bills of Mortality’ with the prevailing temperatures supports this interpretation. A fall of 1°C in winter temperatures coincided with a 2 per cent increase in mortality and with a 1 per cent fall in marital fertility. Medical research suggests some reasons: lower temperatures increase deaths through cardiovascular disease, while ‘the elderly, the very young, [and] persons with impaired mobility’ are ‘disproportionately affected because of their limited physiological capacity to adapt’. In addition, the smoke from coal fires (a serious urban problem in the seventeenth century: see chapter 3 above) carries fine particles that exacerbate cardiac or respiratory diseases such as asthma or bronchitis. Finally, mortality from other common diseases such as mumps, diphtheria, influenza and malaria – all of which kill many people every year – no doubt rose whenever extremes of weather weakened bodily defences or social disruption compromised hygiene."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-30",
      "id": "nr4-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The Killing Fields")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Only wars can eliminate human populations faster than disease, and the greater frequency of armed conflict in the mid-seventeenth century sharply increased mortality. Thus burials in the English county of Berkshire during the seventeenth century show that although the plague epidemic of 1624–5 killed many, the armies who fought there in 1643 killed far more ("), _c('a', {
    attrs: {
      "href": "#/#fig_13"
    }
  }, [_vm._v("Fig. 13")]), _vm._v("). Battles, in particular, ended thousands of lives in a matter of hours if not minutes. Thus at Rocroi, France, in 1643 at least 6,000 Spanish veterans died in an evening as they tried to withstand a French artillery bombardment; while the following year at Marston Moor, England, the victorious Parliamentary-Scottish army cut down some 4,000 defeated Royalists in a little over an hour. Also in 1644 at Freiburg, Germany, according to the victorious commander, ‘In the twenty-two years that I have been involved in the carnage of war, there has never been such a bloody encounter.’ Perhaps 10,000 men perished."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-31",
      "id": "nr4-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Naval combat also killed many men. During the ‘Four Days Battle’ between the Dutch and English fleets in June 1666, ‘the most terrible, obstinate and bloodiest battle that ever was fought on the seas’, the Royal Navy lost over 4,000 men killed, wounded or captured – more than a fifth of those engaged. Seafaring in the age of sail was a dangerous occupation at the best of times, and some officers ‘reckoned there were four deaths by illness or accident for every one killed in action'; but life for sailors ashore could also prove lethal, because neither the government nor the local population could adequately support the men aboard a fleet that stayed in port for long. Just before the 1667 fighting season began, the commissioner at an English naval base was ‘Sorry to see men really perish for want of wherewithal to get nourishment. One [sailor] yesterday came to me crying to get something to relieve him. I ordered him 10 shillings. He went and got hot drink and something to help him, and so drank it, and died within two hours’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-32",
      "id": "nr4-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p88"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p88"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p88"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_13"
    }
  }, [_vm._v("13. Burials in Berkshire, England, 1538–1700."), _c('br'), _vm._v("Plague ravaged almost every parish in Berkshire in 1624 and 1625, but twice as many burials occurred in 1643, when rival armies struggled for control. Almost all of those buried in local churchyards were civilians, not soldiers.")])]), _c('a', {
    attrs: {
      "id": "fig_13"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_13"
    }
  }), _c('a', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("On sea as on land, battles were relatively rare in seventeenth-century Europe; but, one veteran estimated in 1677, ‘you will have twenty sieges for one battle’ (page 32 above) and sieges also claimed many lives. According to Lucy Hutchinson, an eyewitness of the siege of Nottingham Castle in 1644, ‘no one can believe, but those that saw the day, what a strange ebb and flow of courage and cowardice there was in both parties’ because, after the catharsis of passing through a killing ground, ‘the brave turn cowards, fear unnerves the most mighty, makes the generous base, and great men do those things they blush to think on’. Countless atrocities illustrate her point. Thus the previous year, when the Royalists captured Preston in Lancashire, ‘“Kill dead! Kill dead!” was the word in the town, killing all before them without any respect … their horsemen pursuing the poor amazed people, killing, stripping, and spoiling all they could meet with, nothing regarding the doleful cries of the women and children.‘"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-33",
      "id": "nr4-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Civilians everywhere suffered violence at the hands of soldiers. A verse play from the Maas valley in the 1630s stressed the unpredictability of the horrors that war could bring. A ‘farmer’ described how disaster struck just as he and his family sat down for a meal together:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("It was Wednesday, at dinner time,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("When Mansfeld's soldiers came.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("They had no warrant for lodgings or food,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But at our hearth they began")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To steal and to plunder,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Not saying a word, neither ‘to the death’ nor ‘on guard’,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Competing to see who could take the most.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The narrator went on to relate how, while ‘competing’, the soldiers murdered his father because he tried to resist, then raped his sister, and finally set fire to the farm. Only the smoke allowed him to escape certain death."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-34",
      "id": "nr4-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Similar outrages fill the powerful prints entitled ‘The misfortunes of the war’ by engraver Jacques Callot from Lorraine, just south of Liège, which show the sack of villages, the torture and murder of their inhabitants, and the revenge of the peasants against isolated detachments of troops.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Two factors increased the likelihood of such atrocities in the mid-seventeenth century. First, the prevailing military conventions (sometimes called the ‘Laws of War’) held that rebels who took up arms to oppose their ruler ‘ought not to be classed as enemies, the two being quite distinct, and so it is more correct to term the "), _c('a', {
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("armed contention with rebel subjects "), _c('i', [_vm._v("execution of legal process, or prosecution")]), _vm._v(", not war’. It followed that in ‘a war waged by a prince with rebels … all measures allowed in war are available against them, such as killing them as enemies, enslaving them as prisoners, and, much more, confiscating their property as booty’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-35",
      "id": "nr4-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" The worst military massacres of the age often occurred during civil wars or during the repression of those regarded by the victors as rebels; and the mid-seventeenth century, we know, saw a spate of civil wars and rebellions.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The involvement of protagonists from different religions likewise raised the risk of mass killing. As Blaise Pascal observed in his "), _c('i', [_vm._v("Pensées")]), _vm._v(": ‘Men never do so much harm so happily as when they do it through religious conviction’ – and the multiple conflicts of the mid-seventeenth century offer abundant examples. Thus in 1631 the Protestant city of Magdeburg in Germany refused to admit a Catholic garrison sent by its suzerain, Emperor Ferdinand II, made an alliance with his enemy and then derisively rejected Ferdinand's demand for surrender. When, after a long blockade, Magdeburg repudiated a final ultimatum, the besiegers launched a successful assault in which perhaps 20,000 men, women and children perished, while fire consumed all but the cathedral and 140 houses."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-36",
      "id": "nr4-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Few European military leaders in the mid-seventeenth century seem to have felt remorse about such massacres carried out in God's name: on the contrary, they often claimed scriptural warrant, urging their soldiers to follow the Old Testament example of Joshua and the Israelites at Jericho and ‘utterly destroy all that was in the city, both man and woman, young and old’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-37",
      "id": "nr4-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Thus in 1645, at the fall of Basing House, the heavily fortified mansion of a Catholic peer, Protestant preachers whipped up a religious fervour among the besiegers so that when they at last forced an entry no quarter was given. The victors murdered in cold blood six priests found within, shot a former Drury Lane actor (with the sanctimonious comment ‘Cursed be he that doth the Lord's Work negligently’), beat out the brains of a young woman who tried to stop a soldier from abusing her father, and stripped naked even those they spared (including the famous architect Inigo Jones, who escaped the slaughter clothed only in a blanket). A newspaper account reassured squeamish readers that such horrors were fully justified because the victims ‘were most of them Papists. Therefore our swords did show them little compassion.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-38",
      "id": "nr4-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Religious passion produced many other atrocities. The advance of a Cossack army through Ukraine in the Polish-Lithuanian Commonwealth in 1648 was accompanied by the massacre of at least 10,000 Jewish settlers; and six years later, as the Russian tsar prepared to invade the Commonwealth, he gave orders ‘to burn alive Poles or Belorussians subsequently captured "), _c('i', [_vm._v("who would not convert to Orthodoxy")]), _vm._v("’ (see chapter 6). The following year, in Ireland, English troops commanded by Oliver Cromwell carried out a major massacre after they stormed the city of Drogheda. Cromwell later claimed ‘I am persuaded that this is a righteous judgment of God upon these barbarous [viz Catholic] wretches, who have imbrued their hands in so much innocent [read: Protestant] blood'; and that accordingly, ‘in the heat of the action’ he had forbidden his troops ‘to spare any that were in arms in the town’. At least 2,500 soldiers and at least 1,000 civilians (including all Catholic priests) perished."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-39",
      "id": "nr4-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p91"
    }
  }, [_vm._v("Nevertheless, death in face-to-face violence rarely formed the largest category of mortality in early modern wars. Thus in the century 1620–1719, although some 500,000 Swedish and Finnish troops died in the almost continuous wars waged by their monarchs, only 10 per cent fell in battle (including King Gustavus Adolphus) and only 5 per cent in sieges (including King Charles XII). Of the rest, 10 per cent perished in prison while the remaining 75 per cent succumbed to the normal hardships of war. The stunning scale and impact of premature deaths among these troops emerge from two sets of demographic data. First, between 1621 and 1639, the parish of Bygdeå in northern Sweden provided 230 young men to fight in the ‘continental war’, where 215 of them died and five more received injuries that left them crippled: only ten of them remained in service in 1639 – and, since the war still had nine more years to run, the odds of their survival were slim. Thus of the 28 conscripts from Bygdeå who mustered in July 1638, all of them under 18 and many of them under 15 years old, all but one had died within three months of reaching the continent. The second set of data comes from the duchy of Finland between 1638 and 1648. These records list every one of the 14,000 local infantrymen conscripted in the duchy to fight in Germany, and reveal that two-thirds of them never came home. Throughout the Swedish Monarchy, military service had virtually become a sentence of death for males."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-40",
      "id": "nr4-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("II. Only Women Bleed")]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("The ‘bitter living’ of Women")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The increased frequency of wars during the seventeenth century also brought serious demographic consequences for women. Some were direct, in that they sometimes became a primary target. Thus the (Protestant) government in Dublin in 1642 instructed their troops fighting the Catholic insurgents not to spare the women they encountered ‘being manifestly very deep in the guilt of this rebellion, and, as we are informed, very forward to stir up their husbands, friends and kindred to side therein, and exciting them to cruelty against the English’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-41",
      "id": "nr4-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Wars also had some indirect adverse impacts on women. Notably, the departure of husbands and sons to fight (and perhaps die) in the wars forced increasing numbers of women either to support families alone or to live as spinsters or widows. In Württemberg, an area of Germany devastated by war, the number of households headed by single women rose to almost one-third of the total – an unprecedented number. In some ravaged villages in Burgundy (France) widows were the "), _c('i', [_vm._v("only")]), _vm._v(" householders. In the Swedish parish of Bygdeå, the ratio of men to women in 1620 already stood at 1:1.5, but 20 years of compulsory military service more than doubled the ratio to 1:3.6, while the number of households headed by women multiplied sevenfold. Many of them were ‘war widows’: the archives of the Swedish central government contain thousands of petitions desperately requesting payment of the wage arrears, or reimbursement of the expenses, due to deceased soldier-husbands, because the petitioner and her children were starving."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-42",
      "id": "nr4-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("A German widow in 1654 spoke for all these indirect victims of war: she was, she lamented, ‘a poor woman with only a small field or so to her name’ who must therefore ‘"), _c('i', [_vm._v("earn a bitter living")]), _vm._v("’. If she (or any other woman living alone) fell foul of the law, the males who ran the local courts would sentence her to hard labour; if she failed to behave in a subservient and docile way, her male neighbours would banish her; and, even if they allowed her to stay, they normally denied her the opportunity to learn or practise a trade (and thus compete with them)."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-43",
      "id": "nr4-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" A ‘bitter living’, indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The lives of most urban women in the seventeenth century were scarcely sweeter. In many European cities two-thirds of those receiving welfare were women, most of them former servants. Their predominance is easily explained. In a world without domestic appliances or prepared food, as Olwen Hufton has noted, ‘the first luxury that any family permitted itself was the services of a girl, a maid of all work, to take on the drudgery involved in carrying water – a major time and energy consumer – and coal or wood, going to market or performing laundry service’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-44",
      "id": "nr4-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" But as soon as a recession occurred, that ‘first luxury’ became the first casualty. Employers in ‘hard times’ had no scruples about getting rid of their maids; and even those who retained their jobs might have to forego wages and work in return for their keep. Either way, the chances of getting married and having children before the economy recovered remained slim. The fate of women who worked in industry was no better: unlike male apprentices, who enjoyed some job protection if their employer fell on hard times (or if women themselves fell ill or suffered injury), they would be thrown out of work without any ‘social security’ to sustain them.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A few Europeans fretted about the demographic consequences of economic recession. Thus in 1619, suspecting that the population in his region had recently declined, Sancho de Moncada, a priest from Toledo, Spain, examined local parish registers for proof (apparently the first person ever to use them in this way). He found that, in the wake of a severe episode of plague and famine in 1599, the registers recorded ‘not one half of the marriages that there used to be’, so that births in and around Toledo remained far lower than before. In Andalucía, half a century later, Francisco Martínez de Mata also consulted the parish registers and found, like Moncada, that both marriages and births had fallen catastrophically during the harvest failures of the 1640s. Subsequent research by demographers on parish registers has confirmed these findings – but also revealed another important consequence. In the words of E. A. Wrigley, throughout early modern Europe ‘Marriage was the hinge on which the demographic system turned'; and when bread prices doubled, marriages normally fell by one-fifth and the age of brides at first marriage rose."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-45",
      "id": "nr4-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Thanks to the expanding economy of the sixteenth century, European women married on average at age 20 and many gave birth to eight or nine children and some to ten or more. In the first half of the seventeenth century, however, brides were on average 27 or 28 when they married; few gave birth to more than three children; and an increasing number had no children at all. Equally important, more women remained celibate. In England, householders in the seventeenth century sometimes publicly objected at the reading of marriage banns, and after marriage refused to "), _c('a', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("allow couples to live together, if they seemed too poor to raise a family (the prevailing Poor Law system made householders responsible for supporting the local poor). Of Englishwomen born around 1566 who might have married in the 1590s, only 4 per cent failed to do so; but of those born around 1586, who might have married in the 1610s, over 17 per cent failed to do so; and of those born around 1606, who might have married in the 1630s, over 25 per cent failed to do so."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-46",
      "id": "nr4-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These developments reduced the total population in the seventeenth century more rapidly than they would do today because of remarkably high mortality among both mothers and children. In the words of a prominent (if somewhat patronizing) male midwife: ‘Going with child is a rough sea, on which a big-bellyed woman and her infant floats the space of nine months: and labour, which is the only port, is so full of dangerous rocks, that very often both the one and the other, after they have arrived and disembarked, have yet need of much help to defend them against divers inconveniences.’ Or, as the terse French proverb put it: ‘A pregnant woman has one foot in the grave’ ("), _c('i', [_vm._v("Une femme grosse a un pied dans la fosse")]), _vm._v("). Surviving records suggest that in Europe perhaps 40 women per 1,000 died as a result of childbirth (compared with 0.12 per 1,000 in much of western Europe today). The death of the mother became even more frequent if the child died in the womb (and since this becomes more frequent at times of scarcity and disease, it must surely have become more frequent during the 1640s). Moreover, as elsewhere in the early modern world, at least one-quarter of all children born in Europe died within their first year, and almost one-half died before reaching the age of reproduction. In the graphic phrase of the French demographic historian Pierre Goubert, in the seventeenth century ‘It took two children to make an adult’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-47",
      "id": "nr4-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Mothers in the early modern world needed to give birth to at least four children simply to maintain a given population level – "), _c('i', [_vm._v("at least")]), _vm._v(" four, because not all of those who survived to adulthood would marry and be fertile. Even in periods of prosperity, a woman who married when she was 27 or 28 would find it hard to give birth to four children, since fecundity waned in her late thirties; and periods of adversity triggered important biological and behavioural responses that reduced fertility. On the one hand, malnutrition leads to more spontaneous abortions and fewer conceptions (sometimes because ovulation has ceased), decreased libido, a rise in the age of menarche, and a fall in the age of menopause. On the other hand, a serious food shortage often reduced coital frequency (either through abstinence or increased spousal separation). At the same time, the greater prevalence of disease associated with famine increased deaths, especially among pregnant women and new mothers. For all these reasons, the birth rate in many if not most European communities in the mid-seventeenth century fell below – often far below – the level required to maintain the overall population ("), _c('a', {
    attrs: {
      "href": "#/#fig_14"
    }
  }, [_vm._v("Fig. 14")]), _vm._v(")."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-48",
      "id": "nr4-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The rising age of brides when they first married, together with the increase in female celibacy, had one further deleterious effect: an increased risk of illegitimate pregnancies. Mid-seventeenth-century parish registers reveal that between one-fifth and three-fifths of all births took place only a few months (and sometimes only a few weeks) after the parents’ marriage; while pregnancies also increased "), _c('a', {
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("among spinsters who never married. Urban court records throughout Europe are full of testimony from or about young women who came to town looking for work and, when they could not find it, were tricked or coerced into prostitution. One such newcomer to London was reassured by her landlady ‘that it is better to do so [become a prostitute] than to steal and be hanged’. Although perhaps true in the short term, this survival strategy seldom offered a permanent escape from poverty. Instead, it increased the risk of sexually transmitted diseases, and also created a cruel dilemma for single mothers if they became pregnant: either they aborted, abandoned or killed their babies at birth, or else they faced the shame and hardship of having to survive by begging – in which case they as well as their babies would probably die."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-49",
      "id": "nr4-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig_14"
    }
  }, [_vm._v("14. A subsistence crisis: Geneva 1627–32."), _c('br'), _vm._v("Burials increased and conceptions declined in step with the rise in the price of bread in Geneva, a city of 15,000. Similar patterns occurred in communities throughout early modern Europe (and, if similar serial date existed, probably elsewhere in the northern hemisphere).")])]), _c('a', {
    attrs: {
      "id": "fig_14"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_14"
    }
  }, [_vm._v("In most of East Asia, the birth rate also fell in the mid-seventeenth century, and although this decline also reflected a reduction in the reproductive capacity of women, it reflected different social pressures. In China, several generations of a family might live together in the same household – a proverb claimed that ‘five generations under one roof’ was optimal. Although this happened rarely, a typical Chinese household included one or more parents and one or more of their married sons and their families, forming a single economic, religious, social and demographic unit which could easily number 50 members from three generations. They produced and consumed in common; they performed collectively the appropriate rites for the well-being of family members both alive and dead; they shared the burden of caring for aged and needy relatives; above all, they discussed and determined family size together, because the purpose of marriage was production as well as reproduction. ‘Demographic decisions’ in many parts of China were ‘never individual’ but had to be ‘negotiated with co-resident kin according to collective goals and constraints’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-50",
      "id": "nr4-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("‘Negotiation’ was important because nearly all Chinese girls who reached puberty in the seventeenth century married, often while teenagers. Moreover, if a wife failed "), _c('a', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("to produce a son, husbands with sufficient means might take one or more concubines: a peasant girl purchased for the purpose, a household servant, an entertainer, a prostitute – almost anyone except a woman from their own neighbourhood or ‘name’. An active trade in concubines existed in the city of Yangzhou before the sack of 1645, where (according to one contemporary source) ‘daughters are as numerous as clouds’ and")])]), _c('a', {
    attrs: {
      "id": "p95"
    }
  }), _c('div', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p95"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("At age thirteen or fourteen,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("They are ready.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who cares if he is old,")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("If he has gold?"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-51",
      "id": "nr4-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("To ensure that early and widespread marriage, and the frequent resort to concubines, did not produce more children than each household could support, Chinese families employed one or more of four strategies. First, spouses started to reproduce late: the gap between marriage and becoming a mother for the first time averaged three years in China, compared with 18 months in western Europe. Second, wives stopped reproducing early: the mean age of Chinese women when they gave birth to their last child was 33 or 34, compared with 40 for their west European counterparts, and the average span between the first and last child was 11 years, against 14 in Europe. Third, Chinese mothers got rid of the children they (or their relatives) did not want. Many families either surrendered for adoption children they could not feed (especially boys, to families who lacked sons of their own) or sold them (especially girls, who became concubines or prostitutes). Many pregnancies were also either avoided or terminated. Early modern Chinese medical literature described many methods of contraception and abortion; Chinese physicians always placed the health of the mother before that of the foetus; and imperial law criminalized neither procuring nor performing an abortion. Finally, parents could and did murder their unwanted offspring – especially girls. Chinese families intensified their use of all four strategies for child limitation in the mid-seventeenth century – starting to reproduce later; ceasing to reproduce earlier; increasing birth intervals and giving up more children for adoption; and killing off more children at birth.")]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("Infanticide and Abortion")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In the words of Francesca Bray, an eminent historian of China: ‘Infanticide is the most effective way of controlling family size in response to sudden crisis. It is also a foolproof way of exercising sex selection if all other means fail.’ Overall, the ruling Qing dynasty (for whom remarkably precise data are available) killed perhaps 10 per cent of all their daughters, many of them at birth, but in the 1640s and 1650s poorer members of the dynasty ‘killed almost twice as many of their daughters’ as their richer relatives. Although no other family compiled figures of similar precision, it seems that in Manchuria, the Qing homeland, peasant families killed between one-fifth and one-quarter of their daughters at birth in ‘normal’ years, and more in "), _c('a', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("years of dearth; while in Liaoning, just to the south, the sex ratio among the "), _c('i', [_vm._v("last")]), _vm._v(" children born to peasant families stood at 500 boys for every 100 girls. No biological circumstance can account for such gender imbalance: widespread female infanticide is the only possible explanation."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-52",
      "id": "nr4-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" Female infanticide was also common in southern China. According to a county gazetteer from Fujian, ‘When a baby is born, the midwife holds it in her hands for examination. If it is a girl she just throws her into a tub and asks the mother, “Keep it or not?” If the answer is “No”, she calls for water and holds the baby upside down by the feet, dipping her head in the water.’ A poem from Jiangnan, written in the form of an appeal from one woman to others in the region, ended bitterly:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Even before you've heard me out, or sighed a few times in regret,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("In one town after another, "), _c('i', [_vm._v("girls are no sooner born than dead")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("At times of economic adversity, poor families in China may have killed as many as half their children at birth."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-53",
      "id": "nr4-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Infanticide was also widespread in Russia, where early modern households often consisted of three or four families (usually related) living together, and many women married at the age of 12 or 13. Children born out of wedlock and children born to the very poor seem to have been killed by their parents far more often than in the West – at least in part because both Church and State took a relatively lenient view of the matter. The medieval Russian version of St Basil's Rule forgave women who killed their children ‘from simplicity or ignorance, "), _c('i', [_vm._v("or because of scarcity of necessities")]), _vm._v("’; and although the comprehensive law code issued in 1649 decreed death for a mother who killed a child conceived in adultery, ‘If a father or mother kills [their legitimate] son or daughter’, the penalty was that ‘they shall be imprisoned for a year’, and after that ‘they shall not be punished’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-54",
      "id": "nr4-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The law said nothing about foundlings and orphans (a draft decree of 1683 establishing state orphanages remained a dead letter until 1712) – perhaps because Russia's harsh climate reduced their numbers anyway. The available records show that maximum sexual activity among the rural population took place just after the harvest, which produced a peak in births just before the next growing season. This in turn produced a peak in infant mortality because the short growing season made it essential for Russian women to work in the fields at seedtime and harvest, which meant that those who were still infants at that point might either receive solid foods too early or else get insanitary ‘pacifiers’ that killed them. As the Little Ice Age reduced the length of the growing season still further, the few surviving demographic records show an increase in infant mortality."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-55",
      "id": "nr4-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Abortion and infanticide were also common in western Europe. In 1660, according to the Dean of the Faculty of Medicine in Paris, the local clergy ‘have made a calculation that in the past year, six hundred women have confessed that they had killed and destroyed the fruit of their womb’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-56",
      "id": "nr4-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Throughout the seventeenth century, infanticide constituted the commonest capital crime tried by the "), _c('i', [_vm._v("Parlement")]), _vm._v(" of Paris, the law court with the largest jurisdiction in early modern Europe. Its cases show that virtually all those accused were women, half of them "), _c('a', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("spinsters and another quarter widows; and that their numbers rose in times of economic hardship. One quarter of the women tried for infanticide admitted that they had also attempted unsuccessfully to terminate their pregnancy."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-57",
      "id": "nr4-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The increasing frequency of abortion and infanticide in the seventeenth century led many European states to pass harsh legislation against offenders. An English statute against infanticide in 1624 explicitly targeted unmarried mothers (‘lewd women’), as even its title made clear: ‘Act to Prevent the Murdering of "), _c('i', [_vm._v("Bastard")]), _vm._v(" Children’. Studies of prosecutions brought under the new law show that all the victims were illegitimate (mostly born to young women in domestic service) and that almost all died on their first day of life (most through strangulation, suffocation, exposure or drowning, though a few had been beaten to death or thrown into a fire). In Germany, the government of Württemberg in 1658 issued a law that enjoined the denunciation of all women suspected of killing their offspring: almost 130 cases came to trial over the next 40 years: the average age of the mothers was 25; almost all were single; and almost all were sentenced to death."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-58",
      "id": "nr4-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, many infanticides in early modern Europe evidently went undetected, despite the diligence of neighbours (many of whom devoted considerable time to watching whether or not single women produced bloodstained laundry once a month). Perhaps the most striking evidence comes from the French city of Rennes, where workmen replacing old drains in 1721 found one that contained about 80 skeletons of infants – and yet no one had been charged with their deaths. The total of murdered infants, in Rennes and elsewhere in Europe, would surely have been higher had not two institutions offered legal opportunities for fertile women to avoid raising children in times of crisis: foundling hospitals and, in Catholic countries, nunneries.")]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("‘Get thee to a nunnery’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-59",
      "id": "nr4-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In Italy, by 1650, perhaps 70,000 females lived in nunneries, most of them in towns. Nunneries housed 8 per cent of the total female population in Bologna, 9 per cent in Ferrara, 11 per cent in Florence and 12 per cent in Siena. By then France boasted at least as many nuns, while Spain had 20,000, with many more in Germany, the South Netherlands and Poland."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-60",
      "id": "nr4-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" The cities of Russia and the Balkans also included a significant population of cloistered females, as did those of Catholic Europe's colonies – and in every region, the number of nuns increased markedly in the course of the seventeenth century. Why? Many nuns, like Isabel Flores de Oliva (later canonized as Santa Rosa of Lima), took the veil through a religious vocation; others did so because some disability placed them at a disadvantage in the outside world; others still sought temporary refuge in the cloisters from abusive husbands or while their husbands were away. A few, no doubt, felt attracted by the lavish lifestyle of certain convents, where servants and slaves made up half the population (and in some nunneries even outnumbered the nuns). But a considerable number of young women in the seventeenth century entered convents against their will. Elena Cassandra Tarrabotti (1604–52), daughter of a Venetian patriarch, was one of them. "), _c('a', {
    attrs: {
      "id": "p98"
    }
  }, [_vm._v("Her father sent her to a nunnery at age 13 claiming that, because of the economic depression, he lacked the money for an appropriate dowry. There she wrote several books – with titles like "), _c('i', [_vm._v("Innocence undone or the father's tyranny")]), _vm._v(" and "), _c('i', [_vm._v("The nun's hell")]), _vm._v(" – lamenting her lot. ‘Consider it a fact,’ she thundered in one of them, ‘that more than one-third of nuns, confined against their will, find their senses opposing their reason, and subject themselves unwillingly and out of fear to the outrageous misfortunes cruelly created for them’ by their fathers. It would be a kindness, she continued provocatively, if parents strangled their daughters at birth rather than condemn them to a life behind bars against their will."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-61",
      "id": "nr4-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Although Tarrabotti's works went straight onto the "), _c('i', [_vm._v("Index of Prohibited Books")]), _vm._v(", the proportion of daughters of patrician families forced to take the veil increased as the seventeenth-century crisis deepened. In Venice, in 1642, 80 per cent of them became nuns, and in 1656, 90 per cent. Although patricians justified their ‘sacrifice’ of a daughter as an act of exemplary piety, they doubtless consoled themselves with the fact that marriage dowries averaged 1,500 scudi, whereas it cost only 400 to place a daughter in even a prestigious convent. Regardless of motive, incarcerating daughters in a cloister proved highly effective in reducing the number of elite women available to marry and reproduce: 40 Venetian patricians married annually in the 1580s, but under 30 in the 1650s."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-62",
      "id": "nr4-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many convents also accepted foundlings. Indeed, some institutions installed a special ‘wheel of fortune’ to make it easier for mothers to abandon their unwanted offspring: they could place their babies on the wheel outside anonymously and then rotate it inwards for collection within. At the Foundling Hospital of Milan, where desperate mothers left some 400 babies a year, use of the ‘wheel of fortune’ ("), _c('i', [_vm._v("scaffetta")]), _vm._v(") followed the fluctuations in grain prices with sickening regularity: in a year of food scarcity four or five infants might be placed on the wheel in a single night ("), _c('a', {
    attrs: {
      "href": "#/#fig_15"
    }
  }, [_vm._v("Fig. 15")]), _vm._v("). Likewise, in Madrid, where almost 15 per cent of all children baptized in the mid-seventeenth century had been abandoned by their parents, the city's Foundling Hospital took in about 500 children a year; while the Foundling Hospital of Seville averaged almost 300 admissions a year – increasing notably during periods of economic adversity. In cities that lacked a Foundling Hospital, such as London, up to 1,000 infants a year were ‘found on the streets, stalls and dunghills of the capital’, their number likewise rising and falling in step with the price of bread."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-63",
      "id": "nr4-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Parents who abandoned their babies on dunghills probably did not intend them to live, so their action might be seen as infanticide; others, however, not only left their child in a public place but also wrote a heart-wrenching note of explanation. By chance, about 150 notes have survived from the Madrid Foundling Hospital in the 1620s. All were small – some of them very small, written on a scrap of paper torn from a book or on the back of a document, and in one case on the back of a playing card – and stated whether the child had been baptized or not, and usually its name, date of birth and saint's day. A few provided a brief explanation (parents too poor; mother abandoned by her lover; mother died in childbirth; mother unable to produce milk; in one case ‘a well-known lady who does not wish to be found out’). The saddest messages of all were those written in the first person (Plate 6):")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p99"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_15.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p99"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p99"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_15"
    }
  }, [_vm._v("15. Children abandoned at the Foundling Hospital of Milan."), _c('br'), _vm._v("The upper graph shows the time at which parents delivered the children they could not feed to the Foundling Hosital of Milan. In daytime, foundlings were delivered to the staff, but the number rose after dark, with most infants left anonymously on the ‘scaffetta’ or ‘wheel of fortune’. The lower register leaves no doubt about this: the hour that saw most infants abandoned changed according to the season of the year (between 5 and 6 p.m. in December and January; between 9 and 10 p.m. between June and August), presumably to spare the distraught parent the shame of being seen. Although these data come from the eighteenth century, the same patterns prevailed a century earlier.")])]), _c('a', {
    attrs: {
      "id": "fig_15"
    }
  }), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "fig_15"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "fig_15"
    }
  }), _c('a', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("My name is Ana. I have been baptized. My parents are honourable people who, because they are poor, entrust me to Our Lady and St Joseph. I beg you to entrust me to someone who will look after me.")])]), _c('a', {
    attrs: {
      "id": "p100"
    }
  }), _c('p', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("A"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-64",
      "id": "nr4-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Almost certainly, Ana pleaded in vain. Most of those who entered a Foundling Hospital, whether in Madrid or elsewhere, died there – for the simple reason that almost half of all foundlings were abandoned within their first week, and at that vulnerable age, without the immediate intervention of a wet nurse, they would die. Moreover, since ‘mortality tends to increase with admissions’, life expectations fell as admissions rose: in the Hospital of the Innocents in Florence, one-third of the 700 foundlings abandoned in the famine year 1629 died on their first day; half died within a week; and almost two-thirds died within a month. Leaving a newborn baby on the ‘wheel of fortune’ may thus not technically have been infanticide, but the effect was much the same: it provided an additional method, brutal but effective, of rapidly reducing the number of mouths to feed in a crisis."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-65",
      "id": "nr4-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("III. Migration")]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("Voluntary Migration")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Well over one million West Europeans responded to economic adversity in the seventeenth century by migrating to find a better life abroad. So many Scots left the kingdom to make a living in Poland in the seventeenth century that the Poles invented the word "), _c('i', [_vm._v("szot")]), _vm._v(" (Scot: meaning ‘tinker’); and, in all, between 1600 and 1650 perhaps 100,000 Scotsmen, or one-fifth of the kingdom's adult males, went to live abroad. In western Europe, only Portugal also suffered losses on this scale through migration: in the course of the seventeenth century perhaps 250,000 people set sail for its overseas colonies."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-66",
      "id": "nr4-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" At the same time, further east, tens of thousands of Russian and Polish families – the majority of them unfree peasants – fled to join the Cossacks living on the rich ‘black earth’ lands in the south, and in the case of Russia (and in lesser numbers) also to Siberia (see chapter 6 below).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Thousands of Chinese families, too, elected to escape adversity by migrating overseas. Many, especially from the mountainous southeastern provinces, left for the Philippines and Southeast Asia, either as settlers or to ‘service’ the European colonies there. By 1700 some 20,000 Chinese lived in a special suburb of Manila known as the Parián (and its population would have been much larger but for the periodic massacres carried out by the Spaniards and their Filipino allies); and several thousand more lived in Batavia (now Jakarta), which became a ‘Chinese colonial town under Dutch protection’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-67",
      "id": "nr4-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" The establishment of European colonies on Taiwan after 1624 created another opportunity for Chinese ‘co-colonization’. Almost immediately, the governor of Fujian province allowed ‘several tens of thousands’ of those destitute through famine to migrate to the lands around the main Dutch settlement, providing each person with three "), _c('i', [_vm._v("taels")]), _vm._v(" of silver and every family with a cow. By 1683, when Qing forces annexed the island, some 120,000 Chinese "), _c('a', {
    attrs: {
      "id": "p101"
    }
  }, [_vm._v("lived on Taiwan alongside the indigenous population. In each of these locations – Manila, Batavia, Taiwan and so on – virtually no Chinese settlement had existed a century before."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-68",
      "id": "nr4-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Thanks to the unparalleled prevalence of war in the seventeenth century, many more men than ever before left home to join an army. In India, perhaps one-tenth of the active male population of Hindustan formed part of a sophisticated military labour market because the Mughal emperors, like their Afghan predecessors and their British successors, raised Rajput troops on their northwest frontier and sent them to fight on the eastern and southern borders of their empire. Many of them married and settled there. A similar system of military expatriation characterized the Spanish empire. Every year, troops raised in the towns and villages of Castile left for the Netherlands where, in 1640, Philip IV's troops included over 17,000 Spaniards. Many of these expatriates, like the Rajputs of Mughal India, married and settled abroad, never planning to come home. As a Spanish patriarch told his younger brother when he left for the wars, ‘I don't want you to enjoy the countryside in the Netherlands, but the war. The war must become your home.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-69",
      "id": "nr4-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Every state found recruiting easier in years of economic adversity. In the words of the reluctant Spanish warrior who met Don Quixote on the way to join his regiment:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Necessity drove me to the wars;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If I had money truly I would never go.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Or, as a French general put it just after the ‘Great Winter’ of 1708–9: ‘It might well be said that “it's an ill wind that blows nobody any good”, for we could only find so many recruits because of the misery of the provinces … The misfortune of the masses was the salvation of the kingdom.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-70",
      "id": "nr4-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Other forms of ‘voluntary migration’ during the mid-seventeenth century also mirrored economic conditions. For example, up to 6,000 people came to London every year, most of them either boys who became ‘bound apprentice’ to a merchant or artisan in return for instruction in his craft, or females and males who came to work as domestic servants until they had accumulated enough savings to become financially independent and marry – a goal that became more elusive whenever economic circumstances deteriorated. In the English capital, as elsewhere in western Europe, these migrants made up 10 per cent or more of the urban populations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Other people migrated on an annual basis to work on the crops, because the cultivation of most staples requires many extra hands at certain predictable, intense, but short periods. In the case of rice, farmers needed to transplant seedlings and add fertilizer as rapidly as possible, and so throughout East and Southeast Asia itinerant labourers followed the rhythm of these activities. In cereal-producing areas, harvesting had to be accomplished rapidly and so required additional hands for a very brief period. In Catalonia, for example, every June ‘by ancient custom, many reapers [the "), _c('i', [_vm._v("segadors")]), _vm._v("] came down from all the mountainous regions and converged on Barcelona’ to hire themselves out to farmers with land in the fertile plains of the principality."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-71",
      "id": "nr4-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p102"
    }
  }, [_vm._v("Itinerant labourers who lacked ‘a house, a job or a fixed address’ were extremely vulnerable to economic adversity – far more vulnerable than those who remained in their community, and so could claim at least some ‘entitlements’. They were also far more dangerous. One eyewitness characterized the "), _c('i', [_vm._v("segadors")]), _vm._v(" as ‘dissolute and bold men who for the rest of the year lived disordered lives’ and ‘normally caused disturbances and unrest wherever they went; but the absolute need for their services apparently made it impossible to stop them.’ In June 1640, after a prolonged drought had caused great scarcity in the principality, some 2,500 restless reapers arrived in Barcelona and almost immediately ‘caused disturbances and unrest’ that led first to the murder of three royal judges and the viceroy, and eventually to the declaration of the ‘Republic of Catalonia’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-72",
      "id": "nr4-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Except for those who became domestic servants, few migrants were female. In the seventeenth century only a handful of European women crossed the oceans alone, and even they sometimes disguised themselves as men (like the remarkable Basque transvestite ‘lieutenant nun’ Catalina de Erauso, who dictated memoirs describing her feats as a soldier of Philip IV in America). Rather more accompanied their husbands or parents as they sailed to overseas colonies – but males always outnumbered females."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-73",
      "id": "nr4-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Neither masquerading nor migration was an option for many Han Chinese women because from about the age of seven their mothers tightly bound their feet, just like their own. This produced, in its extreme form, ‘the golden lotus’: a foot measuring only three inches from the heel to the end of the large toe. A poem by Hu Shilan, a woman from a gentry family later forced to earn her living by teaching the daughters of more fortunate families, bitterly recalled the days when")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("My little maid stood by me under canopy of flowers")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("So that my tiny shoes wouldn't slip on mosses so green.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Little did I know that in mid-life I would have to roam around")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Braving the scorched sun and furious storms.")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In a crisis, a woman with bound feet would find it hard to ‘roam around’ – or, more important, to run away: a potentially fatal disadvantage during the Ming-Qing transition when China teemed with soldiers and bandits."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-74",
      "id": "nr4-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("Involuntary Migration")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Besides those migrants who were ‘pulled’ from their homes through the prospect (whether apparent or real) of economic advancement elsewhere, the mid-seventeenth-century crisis ‘pushed’ hosts of others onto the roads through the threat of death or destitution if they remained. In Anatolia, the heart of the Ottoman empire, what contemporaries called the ‘Great Flight’ caused the tax-paying population of some communities to decline by three-quarters between the 1570s and the 1640s as landless unmarried men departed to find sustenance by serving in bandit armies, by seeking work in cities, or by studying in religious schools ("), _c('i', [_vm._v("medreses")]), _vm._v(": see chapter 7 below). In central Europe, the Thirty Years War depopulated many "), _c('a', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("communities. Martin Opitz, the most famous German poet of his day, asked rhetorically in his 1621 verse epic, ‘Consolation in the Adversity of War’:")])]), _c('a', {
    attrs: {
      "id": "p103"
    }
  }, [_c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Is there nowhere that war cannot come")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("So that we can live there without fear or flight? …")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The trees stand no more;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The gardens are desolate.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The sickle and the plough are now a sharp blade.")])])]), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("In India, the famine and floods in Gujarat in 1628–31 likewise caused widespread flight, especially by craftsmen. According to an English observer, ‘the greater part of [the] weavers, washers and dyers who (such as are escaped the direfull stroake of famine) are disperst into forraigne parts of greater plentie, leaving few or none of their faculty [skills]’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-75",
      "id": "nr4-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" In China, Chen Zilong, a scholar-official of the Ming as well as one of the finest poets of his generation, captured the agonizing fate of such refugees from disaster in ‘The Little Cart’:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("The little cart jolting and banging through the yellow haze of dusk;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The man pushing behind: the woman pulling in front.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("They have left the city and do not know where to go.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("‘Green, green, those elm-tree leaves: "), _c('i', [_vm._v("they")]), _vm._v(" will cure my hunger,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If only we could find some quiet place and sup upon them together.’")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The wind has flattened the yellow mother-wort;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Above it, in the distance, they see the walls of a house.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("‘There, surely, must be people living who'll give you something to eat.’")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("They tap at the door, but no one comes; they look in, but the kitchen is empty.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("They stand hesitating in the lonely road and their tears fall like rain."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-76",
      "id": "nr4-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Those arbitrarily deprived of their freedom before being deported faced an even worse fate. Some were conscripted soldiers and sailors. Although, in Europe, only Sweden introduced a permanent ‘draft’, most states periodically resorted to ‘impressment’: the compulsory enlistment in armies and navies of men with no obvious means of support, of men who had beaten or abandoned their wives, and of men who had embarked on what the community considered a life of sin – adulterers and fornicators. In addition, since in wartime ‘sin’ seldom filled the ranks, governments periodically conscripted law-abiding citizens. In Castile, communities often met their quota for the draft through a lottery held among all eligible males, and the criteria for ‘eligibility’ widened notably as the seventeenth century advanced and the population declined. Thus in the university town of Salamanca, in 1630 all men over age 40 were exempt, but this limit had risen to age 70 by 1640. At the same time, traditional exemptions (for students and professors, for town officials and familiars of the Inquisition, for gentlemen and doctors, even for the disabled) were challenged, until the only categories recognized as exempt were clerics and gypsies (the latter regularly rounded up for compulsory galley service). The draft could soon depopulate entire communities. Thus in 1642 the Spanish town of Villarrobledo, with some 3,000 inhabitants, complained that impressment had removed some "), _c('a', {
    attrs: {
      "id": "p104"
    }
  }, [_vm._v("400 men over the previous five years and asked for relief since it now lacked sufficient manpower to work the fields. (The government responded with a demand for 60 more men.) Sometimes recruits became so scarce that they were held in gaol between enlistment and deployment to prevent escape. Thus a group of recruits from Castile who had languished in gaol for eight months, awaiting transport to fight in Italy, pleaded with the Council of War in Madrid ‘for the love of God arrange for us to get out of this prison so that we may serve His Majesty, even if it should be in Hell itself’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-77",
      "id": "nr4-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Some states also deported large numbers of miscreants rather than executing them. A number were captured in war and rebellion. The Mughals, for example, regularly sold their prisoners in the slave markets of central Asia. Thus in the 1630s the governor of Kalpi, in the foothills of the Himalayas, boasted that in repressing a rebellion he had ‘beheaded the leaders and enslaved their women, daughters and children, who were more than two lachs [200,000] in number’, and sent them for sale. While recognizing that chronicles tend to exaggerate numbers, historian Scott Levi (who quoted this detail) estimated that ‘over the years, Mughal military expansion in India accounts for the enslavement and exportation of hundreds of thousands of individuals’. Other deportees were convicts. The Russian government deported many criminals to defend the southern frontier against Tatar raids, rather than putting them to death – including some convicted witches who received a sentence of permanent exile and, ironically, spent the rest of their lives patrolling the frontiers of Orthodoxy (in most parts of western Europe they would have been publicly executed). In Scotland, exasperated by the constant lawlessness of one particular clan, in 1626 the government deported all men named ‘Macgregor’ to continental Europe, ‘sufficiently guarded by some of their officers who will be answerable for their not escaping’. Before leaving for the continent, every Macgregor had to swear ‘that they shall never return again within this kingdom under the pain of death’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-78",
      "id": "nr4-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Most British deportees were transported to America. England's Virginia Company showed the way, rounding up in 1618 ‘a hundred young boys and girls that lay starving in the streets’ and sending them to Virginia. A few years later, the Company similarly removed the ‘super-increasing people from the city [of London] to Virginia’ so that it ‘may ease the city of many that are ready to starve, and do starve daily in our streets … for want of food to put into their mouths’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-79",
      "id": "nr4-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" By the 1640s the Company employed ‘spirits’ who ‘did entice children and people away for Virginia’ aboard their waiting ships with the promise of food once they got on board, but, according to Charles Baily (one of the thousands of victims), ‘being once on board, [I] could never get on shoar untill I came to America, where I was sold as a bond-slave for seaven years’. Baily later believed that he and the other ‘poor creatures had better have been hanged, than to suffer the death and misery they did’. Some of these ‘poor creatures’ were defeated soldiers and rebels whom the victorious Republican regime in London condemned to work as unfree labour in Barbados and other American colonies. According to a recent study, ‘tens of thousands of people from Britain and Ireland ended up working as bond slaves in the Chesapeake and Caribbean during the revolutionary period’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-80",
      "id": "nr4-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p105"
    }
  }, [_vm._v("Some European governments deported not only convicts to work in their colonies in America and Asia during the seventeenth century, but also orphaned girls and prostitutes, hoping to redress the extreme gender imbalance that prevailed in most overseas colonies. It did not always work: a stunning 80 per cent of the married women in seventeenth-century Canada who died childless had come as ‘Filles du Roy’ (‘daughters of the king’, as the deportees were known)."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-81",
      "id": "nr4-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" Many male migrants also failed to reproduce. Some perished en route from the rigours of the journey, and others died soon after they reached their destination because they lacked immunity to the pathogens they encountered there. Thus between 1604 and 1634 some 25,000 European males died in the Royal Hospital in Goa, the capital of Portuguese India, most of them shortly after disembarking from their long sea voyage from Lisbon; and of over 5,000 Portuguese men who left Lisbon for India between 1629 and 1634, fewer than half arrived alive. Equally, despite the immigration of some 223,000 Europeans to England's Caribbean islands in the course of the seventeenth century, their total ‘white’ population in 1700 was scarcely 40,000.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The greatest forced migration of the seventeenth century also involved the greatest mortality: the deportation of Africans. Some, especially in east Africa, were captured and taken to Muslim states in the north. Throughout the seventeenth century slave caravans brought 5,000–6,000 African men and women to Ottoman Egypt each year, whence they were distributed throughout the empire – but, after the arrival of the Europeans in the west, far more Africans went involuntarily to the Americas."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-82",
      "id": "nr4-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Estimating the overall size of the trade in slaves between Africa and the various European colonies in America is extremely difficult; nevertheless, around 1640 an official with extensive experience estimated that the slave population of Spanish America stood at about 325,000 and that just over 9,000 new slaves were required each year to maintain this level. In addition, a further 80,000 slaves probably laboured in Brazil, where the colony needed to import over 2,000 slaves annually just to replace ‘losses'; while in 1656 alone 2,000 African slaves arrived in the English colony of Barbados. Taken together, these figures suggest that a total of at least 13,000 African slaves arrived each year in America in the mid-seventeenth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-83",
      "id": "nr4-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" In addition, thousands more captured Africans died either en route to the Atlantic coast, or in the holding pens where they awaited shipment, or on the voyage. Adding these totals together, Europeans enslaved some two million Africans during the seventeenth century, half of them from west-central Africa and most of the rest from the states along the Gold Coast and the Bights of Benin and Biafra.")]), _vm._v(" "), _c('p', {
    staticClass: "bhd"
  }, [_vm._v("Negative Compound Interest")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The various processes that reduced the human population in the mid-seventeenth century, and thus reduced short-term demand for resources (especially food), had five important long-term consequences that created a ‘negative compound interest’:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("• "), _c('b', [_vm._v("Depleting the next generation of mothers.")]), _vm._v(" Pressure on widows to kill themselves decimates the current generation of mothers, already reduced by high mortality during and after childbirth (and, in Catholic countries, also by an increase in the number of nuns); but killing or abandoning girls at birth decimates the mothers of the "), _c('i', [_vm._v("next")]), _vm._v(" generation. "), _c('i', [_vm._v("A female infanticide rate of 10 per cent will reduce population growth in the next generation by 30 per cent")]), _vm._v(". A Chinese poem bitterly noted this double assault on women:")])]), _c('a', {
    attrs: {
      "id": "p106"
    }
  }), _c('div', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p106"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Fujian custom leaves alive after birth only half the number of baby girls born;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Lucky survivors desire to be virtuous females.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Daughters should die after their husband's death;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Poisoned wine is ready in cups and cords await on beams.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "poem"
  }, [_vm._v("A daughter clinging to life withstands great pressure,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Broken hearts are full of grievances;")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Death occurs at last amid clansmen's cheers,")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("Official distinction is bestowed to glorify the clan's name for a thousand years."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-84",
      "id": "nr4-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('b', [_vm._v("Creating depleted cohorts.")]), _vm._v(" Any short-term crisis that significantly reduces the size of an age cohort, whether through human or natural catastrophe, automatically reduces the ability of that cohort to reproduce itself. A rise of 50 per cent in the prevailing death rate means that those under 15 at the time of the crisis will lack the numbers to restore the previous population level. Moreover, by a tragic coincidence (and it seems to be no more than a coincidence, at least in Europe) each generation reduced by a major mortality crisis in the seventeenth century reached marriageable age just as another catastrophe struck. Thus the ‘cohort’ depleted by the plague of 1630–1 came of age just in time to face the famine of 1661–3, while their children reached the age of reproduction during the crisis of the 1690s. Similarly, the ‘cohort’ depleted by the crises of 1618–21 and 1647–53 came of age just in time to face the harvest failures of the mid-1670s, while their children reached the age of reproduction during the ‘Great Winter’ of 1708–9 and the resulting famine."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-85",
      "id": "nr4-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Each catastrophe thus reduced not only the size of the afflicted generation but also the size of the next one.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('b', [_vm._v("Death on the road.")]), _vm._v(" In every age, it is hard to raise a family on the move. Parish registers all over Europe record the frequent death of ‘strangers’ – men, women and children who perished as they tried to get from one place to another, usually in search of work or food. Because each parish kept separate records, their entries rarely allow historians to recreate the losses of migrant families, but some qualitative sources come to the rescue. To take a single example, Peter Hagendorf, a soldier in the Thirty Years War between 1624 and 1648, kept a diary as he marched almost 15,000 miles around Europe with his regiment. He recorded meticulously the births, marriages and deaths of his family, later placing numbers beside the death of all four children by his first wife between 1627 and 1633, "), _c('a', {
    attrs: {
      "id": "p107"
    }
  }, [_vm._v("when she died, and of four more by his second wife between 1635 and 1648. Most of his eight children died as infants (one before baptism, and two more in their first week). In the course of the Thirty Years War Hagendorf thus sired ten legitimate children, but only two were still alive when it ended, one aged five and the other just an infant."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-86",
      "id": "nr4-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(" If Hagendorf's experience was representative, then active military service was a sentence of death not only for many soldiers, but also for their families; and since at least a million men fought in the European wars of the mid-seventeenth century, the overall demographic consequences were severe.")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('b', [_vm._v("The hidden costs of migration.")]), _vm._v(" Some of the villages of northern Portugal that supplied large numbers of men – both sailors and colonists – for the country's overseas enterprise boasted fewer than 60 men for every 100 women, and scarcely half the women in the community ever married. Similar gender imbalances characterized other villages where most of the men migrated to find work, producing two long-term demographic consequences. First, in cereal-producing areas with soils too heavy for women to till by themselves, the departure of too many men (whether to fight, as in Scandinavia, or to colonize, as in Iberia) could reduce food production so much that, although consumption fell (because the men no longer ate local food), the community might no longer be able to feed itself and so eventually atrophied. Second, at least in monogamous societies, male migration on this scale dramatically reduced the number of marriages and therefore the size of the next generation, once again creating a kind of ‘negative compound interest’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-87",
      "id": "nr4-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('b', [_vm._v("‘A young man's world’.")]), _vm._v(" The sociologist Jack Goldstone drew attention to ‘the extraordinary youthfulness of England's population in the 1630s’, both absolutely and relatively.")])]), _vm._v(" "), _c('table', [_c('caption', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Age as a percentage of England's total population")])]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "10%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('hr', {
    staticStyle: {
      "border": "1px solid black",
      "border-collapse": "collapse"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Year")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Total Population")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("0–4")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("5–14")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("15–24")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("25–29")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Total aged 15–29")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Total aged 30+")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('hr', {
    staticStyle: {
      "border": "1px solid black",
      "border-collapse": "collapse"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1631")]), _vm._v(" "), _c('td', [_vm._v("4,892,580")]), _vm._v(" "), _c('td', [_vm._v("12.5")]), _vm._v(" "), _c('td', [_vm._v("19.9")]), _vm._v(" "), _c('td', [_vm._v("18.2")]), _vm._v(" "), _c('td', [_vm._v("7.9")]), _vm._v(" "), _c('td', [_vm._v("26.1")]), _vm._v(" "), _c('td', [_vm._v("41.6")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1641")]), _vm._v(" "), _c('td', [_vm._v("5,091,725")]), _vm._v(" "), _c('td', [_vm._v("11.8")]), _vm._v(" "), _c('td', [_vm._v("20.5")]), _vm._v(" "), _c('td', [_vm._v("17.3")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("25.3")]), _vm._v(" "), _c('td', [_vm._v("42.4")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('hr', {
    staticStyle: {
      "border": "1px solid black",
      "border-collapse": "collapse"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("As Goldstone noted, ‘the cohort that reached ages 26–35 during the 1630s "), _c('i', [_vm._v("was the largest youth cohort of the entire period 1500–1750")]), _vm._v("’; and a large number of them remained unmarried."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-88",
      "id": "nr4-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" Such a demographic structure is inherently unstable, not only because those who are young and single are the ones more likely to voice their discontent, but also because (as Goldstone observed) ‘the participation of people in demonstrations or opposition movements depends to some extent on how great they perceive the support of that opposition movement to be’. Therefore, since ‘the more timorous among the discontented may only join an opposition that appears widespread and successful’, the growth of the 26–35 age cohort to unprecedented size in the 1630s would also have increased the chances that people over age 35 would join the opposition. This, in turn, increased the volatility of the "), _c('i', [_vm._v("whole")]), _vm._v(" population."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-89",
      "id": "nr4-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p108"
    }
  }, [_vm._v("Chinese data, although not as precise as England's parish registers, record a parallel phenomenon. The prevalence of female infanticide inevitably increased the number of ‘bare sticks’ – the common Chinese term for unmarried men – in the next generation. A Fujian gazetteer claimed that during the 1650s almost half of all males remained single because they could not find women to marry; and, as in England, such an unusual demographic pattern would explain why so many people refused to see scarcity as a natural calamity to be stoically endured, but rather as the consequence of human agency to be vigorously protested."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-90",
      "id": "nr4-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In his influential essay "), _c('i', [_vm._v("Poverty and Famines")]), _vm._v(", inspired by his experience of the Bengal famine of 1943, Amartya Sen argued that ‘Starvation is the characteristic of some people not "), _c('i', [_vm._v("having")]), _vm._v(" enough food to eat. It is not the characteristic of there "), _c('i', [_vm._v("being")]), _vm._v(" not enough food to eat. While the latter can be a cause of the former, it is but one of many "), _c('i', [_vm._v("possible")]), _vm._v(" causes.‘"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-91",
      "id": "nr4-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" That is: famines arise more often from distribution problems caused by human agency than from supply problems caused by nature. Whether or not Sen is correct, such ‘anthropocentric’ views convinced many people (in the words of Stephen L. Kaplan) ‘that they were the victims of a terrible conspiracy’. In the early modern world, Kaplan argued,")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("Consumers found reasons to question the authenticity of the dearth. They uncovered signs that the harvest was not as bad as announced, that unusual and illegal acts were occurring in the grain trade, that the government was not performing as it was supposed to, and so on. As subsistence anxieties deepened … the conviction grew that the crisis was contrived, that there was a criminal conspiracy afoot against the people, that popular suffering was needless, and that the plotters somehow had to be resisted. The villains were virtually interchangeable from crisis to crisis. They included men of power (ministers … magistrates, and so forth), of great means (for example, financiers, tax farmers, bankers, military contractors), and members of the entourages of several of the key leaders (mistresses and relatives.)")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Much the same anthropocentric assumptions surrounded major epidemics: that they were spread by evil and powerful men (and occasionally women)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en4-92",
      "id": "nr4-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Such convictions led many people in the early modern period to insist that the authorities could and must do more to provide their subjects with sufficient food and security to ensure survival. The notion that the state's paramount duty was to ‘Nourish the people’ did not only hold sway in China. "), _c('i', [_vm._v("Politics drawn from the very words of Holy Scripture")]), _vm._v(", a treatise written in 1679 for the heir to the French throne by his tutor, Jean-Bénigne Bossuet, stressed that ‘The prince must provide for the needs of his people’ (the title of one of the book's ‘propositions’). Indeed, Bossuet chided:")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The obligation to take care of the people is the basis of all the rights that sovereigns have over their subjects. That is why, in times of great need, the people have a right to appeal to their prince. ‘In an extreme famine, the people cried to Pharaoh for "), _c('a', {
    attrs: {
      "id": "p109"
    }
  }, [_vm._v("food.’ The famished people asked for bread from their king, as from a shepherd, or rather as from their father."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en4-93",
      "id": "nr4-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("That is why (Bossuet might have added) early modern rulers who followed Pharaoh's example, and ignored the ‘appeal’ of their people, soon faced more rebellions and revolutions. Indeed, the greatest population losses occurred in precisely the states that experienced not only most famines and wars, but also most rebellions and revolutions: China, Russia, the Polish-Lithuanian Commonwealth, the Ottoman empire, Germany and its neighbours, the Iberian Peninsula, France, Britain and Ireland.")])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780300189193',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(199)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(201);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 201 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.98bcfac88ff29dc48709.js